
if (!window.requestIdleCallback) {
  window.requestIdleCallback = function (cb) {
    return setTimeout(() => {
      cb({ didTimeout: false, timeRemaining: () => Math.max(0, 50 - (Date.now() % 50)) });
    }, 1);
  };
}


function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

document.addEventListener("DOMContentLoaded", function () {
    function cleanProductURLs() {
        document.querySelectorAll(".product-item-link, .card-title a").forEach(link => {
            let href = link.getAttribute("href");
            if (href && href.includes("/products/")) {
                let cleanHref = href.replace(/-\d+$/, ""); // Remove trailing numbers

                if (href !== cleanHref) {
                    fetch(cleanHref, { method: 'HEAD' })
                        .then(response => {
                            if (response.ok) {
                                link.setAttribute("href", cleanHref);
                                console.log("Cleaned URL:", cleanHref);
                            } else {
                                console.log("Main variant URL does not exist, keeping:", href);
                            }
                        })
                        .catch(() => {
                            console.warn("URL check failed, keeping original:", href);
                        });
                }
            }
        });
    }

    function handleProductRedirect() {
        let path = window.location.pathname;
        let regex = /(\/products\/[a-zA-Z0-9-]+)-\d+$/;

        if (regex.test(path)) {
            let cleanPath = path.replace(/-\d+$/, "");
            console.log("Checking if clean URL exists:", cleanPath);

            fetch(cleanPath, { method: 'HEAD' })
                .then(response => {
                    if (response.ok) {
                        console.log("Redirecting to clean URL:", cleanPath);
                        window.location.replace(cleanPath);
                    } else {
                        console.log("Clean product URL does NOT exist. Keeping current URL:", path);
                    }
                })
                .catch(() => {
                    console.warn("Error checking clean URL, staying on:", path);
                });
        }
    }

    // Run the cleaning function once and observe for future changes
    cleanProductURLs();
    
    const observer = new MutationObserver(cleanProductURLs);
    observer.observe(document.body, { childList: true, subtree: true });

    // Handle product page redirects if necessary
    handleProductRedirect();
});




document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/cart') return;
    let allVariants = []; // Define allVariants globally
    document.body.classList.add("has-halo-loader");
    function logEvent(event, details) {
      const timestamp = new Date().toISOString();
      console.log(`[${timestamp}] Event: ${event}`, details || '');
      // if(event == "Group and Display Products Called with"){
      //     console.log('stop loaddddddingnnngggggg', event)
         setTimeout(function(){
           console.log('goooottt loaddddddingnnngggggg', event)
           //$("body").removeClass("has-halo-loader");
         },2000)
          
      // }

    }
  
  //Select the color   
  
  
    // Function to apply styles to the card title
    function applyCardTitleStyles() {
      const styleElement = document.createElement('style');
      styleElement.innerHTML = `
       .productListing li{
          display:none !important;
       }
       .main-group-product-parent.products-grid,.main-group-product-parent-mega.products-grid, .product-recommendations-loading .products-carousel, .slick-initialized .slick-slide{
         position: relative;
         }
        .card-title {
          width: 100% !important;
          font-size: 18px !important;
          padding-left: 10px !important;
          padding-right: 10px !important;
          font-family: "Made-Avenue" !important;
          line-height: 1.5vw !important;
          font-weight: 400 !important;
          letter-spacing: 1px !important;
          text-align: center !important;
          display: block;
          margin: 0 auto;
        }
  
        .card-information.page_collections span.transcy-money {
          font-size: 18px;
          letter-spacing: 0.48px !important;
        }
        .price {
          font-size: 18px;
          font-family: "Made-Avenue" !important;
          font-weight: 400;
          letter-spacing: 0.48px !important;
          color: #232323;
        }
        /* CSS for setting a fixed height and centering images */
        .product-item-image-container {
          position: relative;
          width: 100%;
          overflow: hidden;
        }
        
        .product-item-image {
         /* height: 400px;  Adjust the height as needed */
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          position: relative;
          background: #fff;
          border: 1px solid #ab896e69;
          border-radius: 10px;
          padding-bottom:150%;  
        }
  
        .product-item-image img {
          transition: opacity 0.5s ease-in-out;
              position: absolute;
              top: 0;
              height: 100%;
              width: 100%;
              object-fit: contain;
              object-position: center;
                max-width: 100%;
                left: 50%;
                transform: translateX(-50%);
        }
         .main-group-product-parent-mega.products-grid .product-item-image, .main-group-product-parent.products-grid .product-item-image {
             padding-bottom: 100%; 
        }
        .main-group-product-parent-mega.products-grid .product-item-image img,  .main-group-product-parent.products-grid .product-item-image img {
              object-fit: contain;
                max-width:200px;
        }
        .megamenu_style_5.megamenu_style_5--style2 .main-group-product-parent-mega .product {
            align-items: normal;
        }
        .megamenu_style_5--style2 .site-nav-banner .menu-dropdown__product .card-information {
               width: 100% !important;
        }
        .product-item-image img.additional-image {
          opacity: 0;
           padding: 20px 20px;
        }     
        .main-group-product-parent-mega .product-item-image-container {
    width: 100%;
}
        .product-item-image-container.has-additional-images:hover img {
          opacity: 0;
        }
  
        .product-item-image-container.has-additional-images:hover img.additional-image:last-child {
          opacity: 1;
        }
  
        /* CSS for aligning prices and color swatches */
        .product {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
        }
  
        .product-item-link {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
          position:relative;
        }
  
        .card-title {
          flex-grow: 1;
        }
  
        .card-information.page_collections {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: auto;
        }
  
        .color-swatches {
          margin-top: 10px;
        }
        /* Set a consistent height for product titles */
        .product-title {
          height: 3em; /* Adjust this value based on your design */
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* Number of lines you want to show */
          -webkit-box-orient: vertical;
        }
  
        /* Scrollable available colors section */
        .available-colors-section {
          margin-top: 10px;
        }
        .available-colors-section .available-colors-title {
          margin-bottom: 5px;
        }
        .available-colors-container {
          display: flex;
          overflow-x: auto;
          padding: 10px 0;
        }
        .available-colors-container ul {
          display: flex;
          padding: 0;
          margin: 0;
          list-style: none;
        }
        .available-colors-container li {
          flex: 0 0 auto;
          margin-right: 10px;
        }
        .available-colors-container img {
          max-width: 50px;
          height: auto;
          cursor: pointer;
        }
        .saleLabel-cust{
          font-size: 16px;
          width: 55px;
          height: 20px;
          display: flex;
          align-items: center;
          border-radius: 5px;
          letter-spacing: 1.5px;
          justify-content: center;
          background-color: #bfa092 !important;
          font-family: MADEAvenuePERSONALUSE;
          letter-spacing: 1px;
          color:#ffff;
        
        }
       .productGrid .product .saleLabel-cust, .main-group-product-parent .product .saleLabel-cust, .main-group-product-parent-mega .product .saleLabel-cust, .product-recommendations-loading .products-carousel .product .saleLabel-cust{
          position: absolute;
          top: 10px;
          bottom: 0;
          left:10px;
          z-index: 9999;
      }
        .card-action-custom {
          bottom: 20px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        .main-group-product-parent-mega .card-action-custom {
          bottom: 20px;
        }
         .card-action-custom #product-add-to-cart{
             border-radius: 50px;
            background: black;
            color: white;
            font-weight: 300;
            font-family: "MADEAvenuePERSONALUSE";
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 16px;
            padding: 10px 30px;
         }
         .main-group-product-parent-mega.products-grid, .main-group-product-parent.products-grid{
           display: flex;
           width: 100%;
         }
         .main-query-search.main-group-product-parent.products-grid{
           flex-wrap: wrap;
         }
          .main-group-product-parent-mega.products-grid{
          max-width: 65%;
          }
         .main-group-product-parent-mega.products-grid .product{
            display: flex;
            flex-wrap: nowrap;
            flex-direction: row;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            word-wrap: break-word;
            gap: 1rem;
         }

         .menu-dropdown__product .main-group-product-parent-mega.products-grid .card-information{
           margin-top: 0;
         }
         .main-group-product-parent-mega.products-grid .product .color-swatches{
           gap: 0;
           margin: 0;
         }
         .product-form__radio[checked="true"]+.product-form__label .text {
            color: var(--variant-color-active);
            background-color: var(--variant-bg-active);
            border-color: var(--swatch-border-active);
        }
      `;
      document.head.appendChild(styleElement);
    }
  
// Function to format price specifically for listing pages
function formatPrice(priceElement) {
  if (!priceElement) return;

  let priceText = priceElement.textContent.trim();
  priceText = priceText.replace(' EUR', '').replace('€', '');

  // Parse to float and ensure two decimal places
  let formattedPrice = parseFloat(priceText);
  if (!isNaN(formattedPrice)) {
    priceElement.textContent = `€${formattedPrice.toFixed(2)}`; // Add currency symbol and enforce two decimals
  } else {
    //console.error('Invalid price detected:', priceText);
  }
}

  
    // Function to apply price styles to products
    function applyPriceStyles() {
      const priceElements = document.querySelectorAll('.price');
      priceElements.forEach(priceElement => {
        formatPrice(priceElement);
      });
      setTimeout(function(){
          removeLoading();  
      },800)
      
    }
  

  
  async function fetchProductsWithMetafields(cursor = null) {
    const query = `
      {
        products(first: 250${cursor ? `, after: "${cursor}"` : ''}) {
          edges {
            cursor
            node {
              id
              title
              handle
              productType
              vendor
              createdAt
              
              images(first: 10) {
                edges {
                  node {
                    transformedSrc
                    originalSrc
                  }
                }
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    priceV2 {
                      amount
                      currencyCode
                    }
                    compareAtPriceV2 {
                      amount
                      currencyCode
                    }
                    image {
                      transformedSrc(maxWidth: 200, maxHeight: 200)
                      originalSrc
                    }
                    selectedOptions {
                      name
                      value
                    }
                    quantityAvailable
                    availableForSale
                    metafield(namespace: "custom", key: "promisedreceiptdate1") {
                      value
                    }
                  }
                }
              }
                collectionName: metafield(namespace: "custom", key: "collectionname") {
                  value
                }
                skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
                  value
                }
                seasonName: metafield(namespace: "custom", key: "seasonname") {
                  value
                }
                colorFamily: metafield(namespace: "custom", key: "colorfamily") {
                  value
                }
                modelNo: metafield(namespace: "custom", key: "modelno") {
                  value
                }
                stof: metafield(namespace: "custom", key: "stof") {
                  value
                }
                kleur: metafield(namespace: "custom", key: "kleur") {
                  value
                }
                merk: metafield(namespace: "custom", key: "merk") {
                  value
                }
                kenmerk: metafield(namespace: "custom", key: "kenmerk") {
                  value
                }
              metafield(namespace: "custom", key: "modelno") {
                value
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `;
  
    try {
      const response = await fetch('https://alwero-nl.myshopify.com/api/2024-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'ae17f26e1cbd143df5a2e1cb38a8ce40'
        },
        body: JSON.stringify({ query })
      });
  
      if (!response.ok) {
        console.error('Network response was not ok:', response.statusText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const responseBody = await response.json();
      console.log('Full Response Body:', responseBody);
  
      if (responseBody.errors) {
        console.error('GraphQL Errors:', responseBody.errors);
        responseBody.errors.forEach(error => {
          console.error('Error:', error.message);
        });
        return { products: [], hasNextPage: false };
      }
  
      if (!responseBody.data || !responseBody.data.products) {
        console.error('Unexpected response structure:', responseBody);
        return { products: [], hasNextPage: false };
      }
  
      const products = responseBody.data.products.edges.map(edge => edge.node);
      const hasNextPage = responseBody.data.products.pageInfo.hasNextPage;
      const lastCursor = responseBody.data.products.edges.length > 0 
        ? responseBody.data.products.edges[responseBody.data.products.edges.length - 1].cursor 
        : null;
  
      return { products, hasNextPage, lastCursor };
  
    } catch (error) {
      console.error('Fetch Error:', error);
      return { products: [], hasNextPage: false };
    }
  }
  
  async function fetchAllProducts() {
    let allProducts = [];
    let hasNextPage = true;
    let cursor = null;
  
    while (hasNextPage) {
      const { products, hasNextPage: nextPage, lastCursor } = await fetchProductsWithMetafields(cursor);
      allProducts = allProducts.concat(products);
      hasNextPage = nextPage;
      cursor = lastCursor;
    }
  
    return allProducts;
  }
  
  function displayFilteredProducts(products) {
    console.log('Display Filtered Products Called with:', products);
    const container = document.querySelector('.available-colors-section');
    if (!container) {
      console.error('Container for available colors not found');
      return;
    }
    container.innerHTML = '';
  
    if (products.length > 0) {
      const title = document.createElement('div');
      container.parentElement.insertBefore(title, container);
  
      const ul = document.createElement('ul');
      ul.style.display = 'flex';
      ul.style.listStyleType = 'none';
  
      const uniqueColors = {};
  
      products.forEach(product => {
          product.variants.edges.forEach(variantEdge => {
          const variant = variantEdge.node;
          console.log("variant-found-alpen", variant);
          const imageUrl = variant.image ? variant.image.transformedSrc : 'https://cdn.shopify.com/s/files/1/0673/6094/8477/files/default_image.svg?v=1725886016';
           console.log("imageUrl-found-alpen", imageUrl); 
          const promisedReceiptDate = variant.metafield?.value || 'No date available';
  
          if (!uniqueColors[imageUrl]) {
            uniqueColors[imageUrl] = {
              product: product,
              variants: [],
            };
          }
  
          uniqueColors[imageUrl].variants.push({ ...variant, promisedReceiptDate });
        });
      });
  
      Object.keys(uniqueColors).forEach(imageUrl => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        const empty_img = 'https://cdn.shopify.com/s/files/1/0673/6094/8477/files/default_image.svg?v=1725886016';
           console.log("uniqueColors-imageUrl-found-alpen", uniqueColors); 
        
        a.href = `/products/${uniqueColors[imageUrl].product.handle}`;
        //a.href = 'javascript:void(0);';
        a.className = 'variant-selector';
        a.setAttribute('data-image-url', imageUrl);
        // a.setAttribute('data-high-res-image-url', uniqueColors[imageUrl].variants[0].image.originalSrc );
        if (uniqueColors[imageUrl] && 
            uniqueColors[imageUrl].variants && 
            uniqueColors[imageUrl].variants[0] && 
            uniqueColors[imageUrl].variants[0].image && 
            uniqueColors[imageUrl].variants[0].image.originalSrc) {
        
            a.setAttribute('data-high-res-image-url', uniqueColors[imageUrl].variants[0].image.originalSrc);
        } else {
            // Handle the case when the image is not available
            console.log("Image not found or doesn't exist");
        }
        a.setAttribute('data-variants', JSON.stringify(uniqueColors[imageUrl].variants));
        a.title = uniqueColors[imageUrl].product.title;
  
        uniqueColors[imageUrl].variants.forEach((variant, index) => {
          a.setAttribute(`data-variant-id-${index}`, variant.id.split('/').pop());
          a.setAttribute(`data-variant-title-${index}`, variant.title);
          a.setAttribute(`data-variant-price-${index}`, variant.priceV2.amount);
          a.setAttribute(`data-variant-promised-receipt-date-${index}`, variant.promisedReceiptDate);
        });
  
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = uniqueColors[imageUrl].product.title;
  
        a.appendChild(img);
        li.appendChild(a);
        ul.appendChild(li);
      });
  
      const scrollContainer = document.createElement('div');
      scrollContainer.className = 'available-colors-container';
      scrollContainer.appendChild(ul);
      container.appendChild(scrollContainer);
    } else {
      console.log('No products found for filtering');
      container.parentElement.style.display = 'none';
    }
  }

  
    async function initAvailableColors() {
      const currentModelno = document.querySelector('[data-modelno]').getAttribute('data-modelno');
      const currentProductId = document.querySelector('[data-product-id]').getAttribute('data-product-id');
  
      console.log('Current Product Model No:', currentModelno);
      console.log('Current Product ID:', currentProductId);
      
      const startInit = performance.now();
      const products = await fetchAllProducts();
       console.log('Fetched Products:', products);
       const endInit = performance.now();
       logEvent('Initializing Product..... page...');
        logEvent('Initialization', `took ${endInit - startInit} ms`);
       
      const filteredProducts = products.filter(product => {
        const modelnoMetafield = product.metafield;
        if (modelnoMetafield) {
          const modelno = modelnoMetafield.value;
          console.log('Checking product', product.id, 'with modelno:', modelno);
          return modelno === currentModelno && product.id != currentProductId;
        } else {
          console.log('Product', product.id, 'does not have required metafields');
          return false;
        }
      });
  
      console.log('Filtered Products:', filteredProducts);
      displayFilteredProducts(filteredProducts);
  
      if (filteredProducts.length > 0) {
        const firstProduct = filteredProducts[0];
        const ColorMetafieldName = firstProduct.kleur;
        console.log('First Product:', firstProduct);
        updateThumbnails(firstProduct);
        SizeVariantcurrent(firstProduct);
        ColorMetafieldNames(ColorMetafieldName);
        
        const firstThumbnail = firstProduct.images.edges[0].node.originalSrc;
        console.log(firstThumbnail, 'firstThumbnail')
        const mainImageContainer = document.querySelector('.productView-img-container .media');
        console.log(mainImageContainer.getAttribute,'mainImageContainer-sgellery');
         mainImageContainer.setAttribute('href',firstThumbnail) ;
        mainImageContainer.href = firstThumbnail;
        const mainImage = mainImageContainer.querySelector('img');
        mainImage.src = firstThumbnail;
        mainImage.srcset = firstThumbnail;
  
        highlightThumbnail(firstThumbnail);
        highlightVariant(firstThumbnail);
        setSelectedVariant(firstProduct.variants.edges[0].node.id.split('/').pop(), firstThumbnail);
      } else {
        const mainImageContainer = document.querySelector('.productView-images-wrapper');
        mainImageContainer.style.flexDirection = 'column';
        mainImageContainer.style.alignItems = 'center';
  
        document.querySelectorAll('.productView-thumbnail').forEach(thumbnail => {
          const img = thumbnail.querySelector('img');
          img.style.maxWidth = '100px';
          img.style.maxHeight = '100px';
        });
      }
    }
    function getURLParams(url) {
      let params = new URL(url).searchParams;
      let paramObj = {};
      params.forEach((value, key) => {
        if (paramObj[key]) {
          if (Array.isArray(paramObj[key])) {
            paramObj[key].push(value);
          } else {
            paramObj[key] = [paramObj[key], value];
          }
        } else {
          paramObj[key] = value;
        }
      });
      return paramObj;
    }
    // Function to fetch products with metafields for collection page
    async function fetchProductsWithMetafieldsForCollection(collectionHandle, cursor = null) {
     
     console.log(collectionHandle, 'collectionHandlecollectionHandle')
      const query = `
      {
        collectionByHandle(handle: "${collectionHandle}") {
          products(first: 250${cursor ? `, after: "${cursor}"` : ''}) {
            edges {
              cursor
              node {
                id
                title
                handle
                productType
                vendor
                createdAt
                availableForSale
                collections(first: 10) {
                  edges {
                    node {
                      title
                    }
                  }
                }
                tags
                images(first: 10) {
                  edges {
                    node {
                      transformedSrc
                      originalSrc
                    }
                  }
                }
                variants(first: 10) {
                  edges {
                    node {
                      id
                      title
                      priceV2 {
                        amount
                        currencyCode
                      }
                      compareAtPriceV2 {
                        amount
                        currencyCode
                      }
                      image {
                        transformedSrc(maxWidth: 200, maxHeight: 200)
                        originalSrc
                      }
                      selectedOptions {
                        name
                        value
                      }
                        availableForSale
                    }
                  }
                }
                collectionName: metafield(namespace: "custom", key: "collectionname") {
                  value
                }
                skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
                  value
                }
                seasonName: metafield(namespace: "custom", key: "seasonname") {
                  value
                }
                colorFamily: metafield(namespace: "custom", key: "colorfamily") {
                  value
                }
                modelNo: metafield(namespace: "custom", key: "modelno") {
                  value
                }
                stof: metafield(namespace: "custom", key: "stof") {
                  value
                }
                kleur: metafield(namespace: "custom", key: "kleur") {
                  value
                }
                merk: metafield(namespace: "custom", key: "merk") {
                  value
                }
                kenmerk: metafield(namespace: "custom", key: "kenmerk") {
                  value
                }
                metafield(namespace: "custom", key: "modelno") {
                  value
                }
              }
            }
            pageInfo {
              hasNextPage
            }
          }
        }
      }
    `;
      try {
        const response = await fetch('https://alwero-nl.myshopify.com/api/2024-04/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'ae17f26e1cbd143df5a2e1cb38a8ce40'
          },
          body: JSON.stringify({ query })
        });
    
        if (!response.ok) {
          console.error('Network response was not ok', response.statusText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const responseBody = await response.json();
       
        if (responseBody.errors) {
          console.error('GraphQL Errors', responseBody.errors);
          return { products: [], hasNextPage: false };
        }
    
        if (!responseBody.data || !responseBody.data.collectionByHandle || !responseBody.data.collectionByHandle.products) {
          console.error('Unexpected response structure', responseBody);
          return { products: [], hasNextPage: false };
        }
    
        const products = responseBody.data.collectionByHandle.products.edges.map(edge => edge.node);
        const hasNextPage = responseBody.data.collectionByHandle.products.pageInfo.hasNextPage;
        const lastCursor = responseBody.data.collectionByHandle.products.edges.length > 0 ? responseBody.data.collectionByHandle.products.edges[responseBody.data.collectionByHandle.products.edges.length - 1].cursor : null;
        console.log(products, 'responseBody')
  
   /****************************** */
      let urlc = window.location.href;
      let urlParams = getURLParams(urlc);
      console.log(urlParams);
      if (JSON.stringify(urlParams) !== '{}') {
  
        const filteredProducts = products.filter(product => {
         
          const collectionNames = urlParams['filter.p.m.custom.collectionname'] 
            ? (Array.isArray(urlParams['filter.p.m.custom.collectionname']) ? urlParams['filter.p.m.custom.collectionname'] : [urlParams['filter.p.m.custom.collectionname']])
            : null;
      
          const productTypes = urlParams['filter.p.product_type'] 
            ? (Array.isArray(urlParams['filter.p.product_type']) ? urlParams['filter.p.product_type'] : [urlParams['filter.p.product_type']])
            : null;
      
          const colorFamilies = urlParams['filter.p.m.custom.colorfamily'] 
            ? (Array.isArray(urlParams['filter.p.m.custom.colorfamily']) ? urlParams['filter.p.m.custom.colorfamily'] : [urlParams['filter.p.m.custom.colorfamily']])
            : null;
      
          const seasonNames = urlParams['filter.p.m.custom.seasonname'] 
            ? (Array.isArray(urlParams['filter.p.m.custom.seasonname']) ? urlParams['filter.p.m.custom.seasonname'] : [urlParams['filter.p.m.custom.seasonname']])
            : null;
      
          const stofs = urlParams['filter.p.m.custom.stof'] 
            ? (Array.isArray(urlParams['filter.p.m.custom.stof']) ? urlParams['filter.p.m.custom.stof'] : [urlParams['filter.p.m.custom.stof']])
            : null;
      
          const merk = urlParams['filter.p.m.custom.merk'] || null;
          const minPrice = urlParams['filter.v.price.gte'] ? parseFloat(urlParams['filter.v.price.gte']) : 0;
          const maxPrice = urlParams['filter.v.price.lte'] ? parseFloat(urlParams['filter.v.price.lte']) : Infinity;
          console.log("product.seasonName", product.seasonName);
          const matchesCollectionName = collectionNames && collectionNames.length > 0 && !collectionNames.includes(undefined) ? collectionNames.includes(product.collectionName?.value) : true;
          const matchesProductType = productTypes && productTypes.length > 0 && !productTypes.includes(undefined) ? productTypes.includes(product.productType) : true;
          const matchesColorFamily = colorFamilies && colorFamilies.length > 0 && !colorFamilies.includes(undefined) ? colorFamilies.includes(product.colorFamily?.value) : true;
          const matchesSeasonName = seasonNames && seasonNames.length > 0 && !seasonNames.includes(undefined) ? product.seasonName?.value.includes(seasonNames) : true;
          const matchesStof = stofs && stofs.length > 0 && !stofs.includes(undefined) ? stofs.includes(product.stof?.value) : true;
          const matchesMerk = merk ? product.merk?.value === merk : true;
      
          let matchesPriceAndAvailability = true;
        //  console.log(product.variants?.edges, 'variantsvariantsvariantsvariantsvariants')
          if (product.variants) {
            matchesPriceAndAvailability = product.variants?.edges.some(variant => {
              return parseFloat(variant.node.priceV2.amount) >= minPrice &&
                     parseFloat(variant.node.priceV2.amount) <= maxPrice;
            });
          }
      
          return (
            matchesCollectionName &&
            matchesProductType &&
            matchesColorFamily &&
            matchesSeasonName &&
            matchesStof &&
            matchesMerk &&
            matchesPriceAndAvailability
          );
        });
              // Sort products by the lowest variant price in ascending order
              const sortBy = urlParams['sort_by'] || null;
              console.log(sortBy, 'sortBysortBysortBysortBy')
              console.log('Filtered products with sale prices without filter', filteredProducts);
               if (sortBy) {
                 switch (sortBy) {
                   case 'price-ascending':
                    filteredProducts.sort((a, b) => {
                       const aMinPrice = Math.min(...a.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                       const bMinPrice = Math.min(...b.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                       return aMinPrice - bMinPrice;
                     });
                     break;
                   case 'price-descending':
                     console.log('price decending',sortBy )
                     filteredProducts.sort((a, b) => {
                       const aMaxPrice = Math.max(...a.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                       const bMaxPrice = Math.max(...b.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                       return bMaxPrice - aMaxPrice;
                     });
                     break;
                   case 'title-ascending':
                    filteredProducts.sort((a, b) => a.title.localeCompare(b.title));
                     break;
                   case 'title-descending':
                    filteredProducts.sort((a, b) => b.title.localeCompare(a.title));
                     break;
                   case 'created-ascending':
                    filteredProducts.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                     break;
                   case 'created-descending':
                    filteredProducts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                     break;
                   // case 'best-selling':
                   //   // Implement best-selling sorting logic
                   //   break;
                   // case 'manual':
                   //   // Implement manual sorting logic
                   //   break;
                   default:
                     break;
                 }
               }
               //console.log('sorted products with ', products);
        console.log('Filtered products with filter sale prices', filteredProducts);
        return { products: filteredProducts, hasNextPage, lastCursor };
      } else {
        console.log('Filtered products with sale prices', products);
        return { products: products, hasNextPage, lastCursor };
      }
      
      
    
      } catch (error) {
        console.error('Fetch Error', error);
        return { products: [], hasNextPage: false };
      }
  
    }
  
    // Function to fetch all products in a collection
    async function fetchAllProductsForCollection(collectionHandle) {
      let allProducts = [];
      let hasNextPage = true;
      let cursor = null;
  
      while (hasNextPage) {
        logEvent('Fetching products with cursor', cursor);
        const { products, hasNextPage: nextPage, lastCursor } = await fetchProductsWithMetafieldsForCollection(collectionHandle, cursor);
        allProducts = allProducts.concat(products);
        hasNextPage = nextPage;
        cursor = lastCursor;
      }
  
      logEvent('All fetched products', allProducts);
      return allProducts;
    }


   function createProductCardMegaMenu(product) {
      const productDiv = document.createElement('div');
      productDiv.className = 'product';
      productDiv.setAttribute('data-product-id', product.id);
  
      const productLink = document.createElement('a');
      productLink.href = `/products/${product.handle}`;
      productLink.className = 'product-item-link';
  
      const productImageContainer = document.createElement('div');
      productImageContainer.className = 'product-item-image-container';
  
      const productImage = document.createElement('div');
      productImage.className = 'product-item-image';
      
      const img = document.createElement('img');
      if(product.images.edges.length > 0){
        img.src = product.images.edges[0].node.transformedSrc;
        img.alt = product.title;
        productImage.appendChild(img);
      }
  
      let hasAdditionalImages = false;
  
      product.images.edges.forEach((imageEdge, index) => {
        if (index > 0) {
          const additionalImg = document.createElement('img');
          additionalImg.src = imageEdge.node.transformedSrc;
          additionalImg.alt = product.title;
          additionalImg.className = 'additional-image';
          productImage.appendChild(additionalImg);
          hasAdditionalImages = true;
        }
      });
  
      if (hasAdditionalImages) {
        productImageContainer.classList.add('has-additional-images');
      }
  
      productImageContainer.appendChild(productImage);
  
      const productTitle = document.createElement('h3');
      productTitle.className = 'card-title link-underline card-title-ellipsis product-title';
      productTitle.textContent = product.title;
  
      const productPrice = document.createElement('div');
      productPrice.className = 'card-information page_collections';
      const priceAmount = product.variants[0].priceV2.amount;
      productPrice.innerHTML = `<span class="price">€${priceAmount}</span>`;
  
      const colorSwatches = document.createElement('div');
      colorSwatches.className = 'color-swatches';
      const uniqueColors = {};
      let buttonATCP  = '';
      product.variants.forEach(variant => {
        if (variant.image && !uniqueColors[variant.image.transformedSrc]) {
          uniqueColors[variant.image.transformedSrc] = true;
          const colorSwatch = document.createElement('img');
          colorSwatch.src = variant.image.transformedSrc;
          colorSwatch.alt = variant.title;
          colorSwatch.className = 'color-swatch';
          colorSwatch.setAttribute('data-variation', variant.id);
          colorSwatch.setAttribute('data-product', variant.productId);
          if(variant.compareAtPriceV2 && variant.compareAtPriceV2 != null){
            colorSwatch.setAttribute('data-sale', 'yes')
            colorSwatch.setAttribute('data-price-item', variant.compareAtPriceV2);
            let spanElement = document.createElement("span");
            spanElement.className = "saleLabel-cust";
            spanElement.textContent = "Sale";
            
            if (!productLink.querySelector(".saleLabel-cust")) {
              productLink.prepend(spanElement);
            }
          }else{
            colorSwatch.setAttribute('data-sale', 'off')
            colorSwatch.setAttribute('data-price-item', variant.priceV2.amount);
          }
         //add button text 
           buttonATCP = createAddtoCartProduct(product);             
        
           colorSwatch.onclick = function() {
            const variantImageSrc = variant.image.originalSrc;
            img.src = variantImageSrc;
            img.srcset = variantImageSrc;
        
            const productContainer = this.closest('.product');
            const cardActionCustom = productContainer.querySelector('.card-action-custom');
            
            const colorSproductId = this.getAttribute('data-product'); 
            const colorSavriationId = this.getAttribute('data-variation'); 
          
            let pID = colorSproductId.split('/').pop();
            let vPiD = colorSavriationId.split('/').pop();
 
            if (cardActionCustom) {
                const form = cardActionCustom.querySelector('form');
                if (form) {
                    form.setAttribute('data-product-id', pID);
                    const idInput = form.querySelector('input[name="id"]');
                    if (idInput) {
                        idInput.value = vPiD;
                    } 
                } 
            } 
        };
        
          colorSwatches.appendChild(colorSwatch);
        }
      });

      productDiv.addEventListener('mouseenter', function() {
        let cardActionCustom = this.querySelector('.card-action-custom');
        if (cardActionCustom) {
            cardActionCustom.style.opacity = '1';
        }
    });
    
    productDiv.addEventListener('mouseleave', function() {
        let cardActionCustom = this.querySelector('.card-action-custom');
        if (cardActionCustom) {
            cardActionCustom.style.opacity = '0';
        }
    });
      
 
      productLink.appendChild(productImageContainer);
      if (buttonATCP instanceof HTMLElement) {
        productImageContainer.appendChild(buttonATCP);
      }
      productLink.appendChild(productTitle);
      productDiv.appendChild(productLink);
      productPrice.appendChild(productTitle);
      productDiv.appendChild(productPrice);
      productPrice.appendChild(colorSwatches);
  
      return productDiv;
    }
    // Function to create a product card
    function createProductCard(product) {
      const productDiv = document.createElement('div');
      productDiv.className = 'product';
      productDiv.setAttribute('data-product-id', product.id);
  
      const productLink = document.createElement('a');
      productLink.href = `/products/${product.handle}`;
      productLink.className = 'product-item-link';
  
      const productImageContainer = document.createElement('div');
      productImageContainer.className = 'product-item-image-container';
  
      const productImage = document.createElement('div');
      productImage.className = 'product-item-image';
      
      const img = document.createElement('img');
      if(product.images.edges.length > 0){
        img.src = product.images.edges[0].node.transformedSrc;
        img.alt = product.title;
        productImage.appendChild(img);
      }else{
         img.src = 'https://cdn.shopify.com/s/files/1/0673/6094/8477/files/placeholder-images-product.webp?v=1721824708';
         img.alt = '';
         productImage.appendChild(img);
      }
  
      let hasAdditionalImages = false;
  
      product.images.edges.forEach((imageEdge, index) => {
        if (index > 0) {
          const additionalImg = document.createElement('img');
          additionalImg.src = imageEdge.node.transformedSrc;
          additionalImg.alt = product.title;
          additionalImg.className = 'additional-image';
          productImage.appendChild(additionalImg);
          hasAdditionalImages = true;
        }
      });
  
      if (hasAdditionalImages) {
        productImageContainer.classList.add('has-additional-images');
      }
  
      productImageContainer.appendChild(productImage);
  
      const productTitle = document.createElement('h3');
      productTitle.className = 'card-title link-underline card-title-ellipsis product-title';
      productTitle.textContent = product.title;
  
      const productPrice = document.createElement('div');
      productPrice.className = 'card-information page_collections';
      const priceAmount = product.variants[0].priceV2.amount;
      productPrice.innerHTML = `<span class="price">€${priceAmount}</span>`;
  
      const colorSwatches = document.createElement('div');
      colorSwatches.className = 'color-swatches';
      const uniqueColors = {};
      let buttonATCP  = '';
      product.variants.forEach(variant => {
        if (variant.image && !uniqueColors[variant.image.transformedSrc]) {
          uniqueColors[variant.image.transformedSrc] = true;
          const colorSwatch = document.createElement('img');
          colorSwatch.src = variant.image.transformedSrc;
          colorSwatch.alt = variant.title;
          colorSwatch.className = 'color-swatch';
          colorSwatch.setAttribute('data-variation', variant.id);
          colorSwatch.setAttribute('data-product', variant.productId);
          if(variant.compareAtPriceV2 && variant.compareAtPriceV2 != null){
            colorSwatch.setAttribute('data-sale', 'yes');
            colorSwatch.setAttribute('data-price-item', variant.compareAtPriceV2.amount);      
            let spanElement = document.createElement("span");
            spanElement.className = "saleLabel-cust";
            spanElement.textContent = "Sale";
            
            if (!productLink.querySelector(".saleLabel-cust")) {
              productLink.prepend(spanElement);
            }
          }else{
            colorSwatch.setAttribute('data-sale', 'off')
            colorSwatch.setAttribute('data-price-item', variant.priceV2.amount);
          }
         //add button text 
           console.log("search-wih button", product);
           buttonATCP = createAddtoCartProduct(product);             
        
           colorSwatch.onclick = function() {
            const variantImageSrc = variant.image.originalSrc;
            img.src = variantImageSrc;
            img.srcset = variantImageSrc;
        
            const productContainer = this.closest('.product');
            const cardActionCustom = productContainer.querySelector('.card-action-custom');
            
            const colorSproductId = this.getAttribute('data-product'); 
            const colorSavriationId = this.getAttribute('data-variation'); 
          
            let pID = colorSproductId.split('/').pop();
            let vPiD = colorSavriationId.split('/').pop();
 
            if (cardActionCustom) {
                const form = cardActionCustom.querySelector('form');
                if (form) {
                    form.setAttribute('data-product-id', pID);
                    const idInput = form.querySelector('input[name="id"]');
                    if (idInput) {
                        idInput.value = vPiD;
                    } 
                } 
            } 
        };
        
          colorSwatches.appendChild(colorSwatch);
        }
      });

      productDiv.addEventListener('mouseenter', function() {
        let cardActionCustom = this.querySelector('.card-action-custom');
        if (cardActionCustom) {
            cardActionCustom.style.opacity = '1';
        }
    });
    
    productDiv.addEventListener('mouseleave', function() {
        let cardActionCustom = this.querySelector('.card-action-custom');
        if (cardActionCustom) {
            cardActionCustom.style.opacity = '0';
        }
    });

      productLink.appendChild(productImageContainer);
      if(buttonATCP){
         if (buttonATCP instanceof HTMLElement) {
           productImageContainer.appendChild(buttonATCP);
         }
      }
      productLink.appendChild(productTitle);
      productDiv.appendChild(productLink);
      productDiv.appendChild(productPrice);
      productPrice.appendChild(colorSwatches);
  
      return productDiv;
    }
    function createAddtoCartProduct(product) {
        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        if (isMobile) return ''; // Skip adding button on mobile
    
        // Determine button text
        const buttonText = getButtonText(product);
        let pID = product.id;
        pID = pID.split('/').pop();
        // Create form element
        const form = document.createElement('form');
        form.setAttribute('action', '/cart/add');
        form.setAttribute('method', 'post');
        form.className = 'variants';
        form.id = `form-${pID}-template--18155107680509__product-grid`;
        form.dataset.productId = pID;
        form.setAttribute('enctype', 'multipart/form-data');
      
        // Create hidden input for product ID
        const productIdInput = document.createElement('input');
        productIdInput.type = 'hidden';
        productIdInput.name = 'id';
        let vPiD = product.variants[0].id; 
        vPiD = vPiD.split('/').pop();
        productIdInput.value = 
        productIdInput.value = vPiD; // Assuming first variant
      
        // Create hidden input for quantity
        const quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';
      
        // Create submit button
        const button = document.createElement('button');
        button.type = 'submit';
        button.name = 'add';
        button.dataset.btnAddtocart = '';
        button.dataset.available = '';
        button.className = 'product-form__submit button button--primary an-';
        button.id = 'product-add-to-cart';
        button.textContent = buttonText;
      
        // Append inputs and button to form
        form.appendChild(productIdInput);
        form.appendChild(quantityInput);
        form.appendChild(button);
      
        // Create div element to wrap the form
        const cardActionDiv = document.createElement('div');
        cardActionDiv.className = 'card-action-custom  has-compare';
        cardActionDiv.style.opacity = '0';
        cardActionDiv.appendChild(form);
      
        return cardActionDiv;
      }

      function getButtonText(product) {
        const isAvailable = product.availableForSale;

        console.log('products get button text ', product)
        const variantsAvailable = product.variants.some(variant => variant.availableForSale);
      
        if (isAvailable || variantsAvailable) {
          const isPreOrder = product.tags.includes("Pre-Order") 
          if (isPreOrder) {
            return "Pre-Order";
          }
          const isQuickAdd = product.tags.includes("Quick Add") 
          if (isQuickAdd) {
            return "Quick Add";
          }
      
          return "+winkelwagen";
        } 
        // else {
        //   return "Out of Stock";
        // }
      }
    // Function to group and display products by model number
    function groupAndDisplayProducts(products) {
      logEvent('Group and Display Products Called with', products);
      const container = document.querySelector('.productListing');
      if (!container) {
        logEvent('Container for collection items not found');
        return;
      }
      let tp = 25;
      if(document.querySelector('span[name="paginateBy"]')){
        let numbPage = document.querySelector('span[name="paginateBy"]').textContent;
          tp = numbPage.trim(); 
      }
       let totalnumber = parseInt(tp );
       let newPageNumber = 1;
        if(document.querySelector('.button--secondary')){
          let url = document.querySelector('.button--secondary').getAttribute('href')
          let pageNumber = parseInt(url.match(/page=(\d+)/)[1]);
          newPageNumber = parseInt(pageNumber) - 1 ;
        
        }
       
        totalnumber = (parseInt(tp ) * parseInt(newPageNumber));
       
        console.log(tp, 'tp',newPageNumber, 'newPageNumber', totalnumber, 'totalnumber' );
    
      const productsByModelno = {};
      let productsArray = [];
    
   products.forEach(product => {
    const modelno = product.metafield ? product.metafield.value : null;
    if (modelno) {
        const productId = product.id;
        if (!productsByModelno[modelno]) {
            productsByModelno[modelno] = {
                ...product,
                variants: product.variants.edges.map(variant => ({
                    ...variant.node,
                    productId: productId
                }))
            };
          productsArray.push(productsByModelno[modelno]);
        } else {
            productsByModelno[modelno].variants = productsByModelno[modelno].variants.concat(
                product.variants.edges.map(variant => ({
                    ...variant.node,
                    productId: productId
                }))
            );
          const index = productsArray.findIndex(item => item.id === productsByModelno[modelno].id);
           productsArray[index] = { ...productsByModelno[modelno] };
        }
    }
});

  
      //const slicedProductsByModelno = Object.values(productsByModelno).slice(0, totalnumber);
  
      //console.log(slicedProductsByModelno);
  
      container.innerHTML = ''; // Clear existing content
      // Object.keys(productsByModelno).forEach(modelno => {
      //   const product = productsByModelno[modelno];
      //   const productDiv = createProductCard(product);
      //   container.appendChild(productDiv);
      // });
      console.log('productsByModelnoproductsByModelno', productsByModelno)
      // Object.keys(productsByModelno)
      // .slice(0, totalnumber)
      // .forEach((modelno) => {
      //   const product = productsByModelno[modelno];
      //   console.log('productdfdfdfdfdfdfdfdproductproduct', product)
      //   const productDiv = createProductCard(product);
      //   container.appendChild(productDiv);
      // });

      productsArray.slice(0, totalnumber)
      .forEach((product) => {
        const productDiv = createProductCard(product);
        container.appendChild(productDiv);
      });
   
      // Show the container once products are ready
      container.style.display = 'block';
  
      // Apply price styles
      applyPriceStyles();
     
    }
    function groupAndDisplayProductsSearch(products) {
      logEvent('Group and Display Products Called with', products);
      const container = document.querySelector('.productListing');
      if (!container) {
        logEvent('Container for collection items not found');
        return;
      }
      
    
      const productsByModelno = {};
  
      products.forEach(product => {
        const modelno = product.metafield ? product.metafield.value : null;
        if (modelno) {
            const productId = product.id;
            if (!productsByModelno[modelno]) {
                productsByModelno[modelno] = {
                    ...product,
                    variants: product.variants.edges.map(variant => ({
                        ...variant.node,
                        productId: productId
                    }))
                };
            } else {
                productsByModelno[modelno].variants = productsByModelno[modelno].variants.concat(
                    product.variants.edges.map(variant => ({
                        ...variant.node,
                        productId: productId
                    }))
                );
            }
        }
    });
  
      //const slicedProductsByModelno = Object.values(productsByModelno).slice(0, totalnumber);
  
      //console.log(slicedProductsByModelno);
      let tp = 10;
      if(document.querySelector('.productListing').hasAttribute('data-sf')){
           tp = parseInt(document.querySelector('.productListing').getAttribute('data-sf'));
      }
      let newPageNumber = 1;
       if(document.querySelector('.button--secondary')){
         let url = document.querySelector('.button--secondary').getAttribute('href')
         let pageNumber = parseInt(url.match(/page=(\d+)/)[1]);
         newPageNumber = parseInt(pageNumber) - 1 ;
       
       }
      
      let totalnumber = (parseInt(tp ) * parseInt(newPageNumber));
    
      container.innerHTML = ''; // Clear existing content
  
      // Object.keys(productsByModelno).forEach(modelno => {
      //   const product = productsByModelno[modelno];
      //   const productDiv = createProductCard(product);
      //   container.appendChild(productDiv);
      // });
      Object.keys(productsByModelno)
      .slice(0, totalnumber)
      .forEach((modelno) => {
        const product = productsByModelno[modelno];
        const productDiv = createProductCard(product);
        container.appendChild(productDiv);
      });
    
      // Show the container once products are ready
      container.style.display = 'block';
  
      // Apply price styles
      applyPriceStyles();
    }
  
    // Function to initialize the collection page
    async function initCollectionPage() {
      logEvent('Initializing collection page...');
      const startInit = performance.now();
      const pathArray = window.location.pathname.split('/');
      const collectionHandle = pathArray[pathArray.indexOf('collections') + 1]; // Dynamically get the collection handle from URL
      const products = await fetchAllProductsForCollection(collectionHandle);
      const endInit = performance.now();
      logEvent('Initialization', `took ${endInit - startInit} ms`);
      logEvent('Fetched Products for Collection Page', products);
      
    // Bewaar de sorteervolgorde
    if (window.sortedProducts) {
        groupAndDisplayProducts(window.sortedProducts);
    } else {
        groupAndDisplayProducts(products);
    }
    
    }

  

  // Function to initialize the initFeaturedCollectionPage collections
  async function initFeaturedCollectionPage() {
    logEvent('Initializing Featured collection page...');
     const startInit = performance.now();
     const collectionValues = [];
     $('.main-group-product-parent.products-grid').each(function() {
        const collectionValue = $(this).attr('data-collection');
         if (collectionValues.indexOf(collectionValue) === -1) {
            collectionValues.push(collectionValue);
            console.log('Unique data-collection values:', collectionValue);
          }
      });
      console.log('Unique data-collection collectionValues 2:', collectionValues);
      fetchAllProductsForCollectionFeatured(collectionValues);
  }

  // Function to fetch all products in a collection
  async function fetchAllProductsForCollectionFeatured(collectionHandle) {
    let cursor = null;
      fetchProductsWithMetafieldsForCollectionFeatured(collectionHandle, cursor).then(products => {
          const startInit = performance.now();
          console.log('Fetched products:', products);
          const endInit = performance.now();
          groupAndDisplayFeaturedProducts(products);  
        });
    console.log('result');
  }

  const fetchProductsWithMetafieldsForCollectionFeatured = async (handles,  cursor = null) => {
  console.log(handles, 'collectionHandlecollectionHandleFeatured');
   const allProducts = [];
  const getCollectionByHandleQuery = (cursor) => `
  query getCollectionByHandle($handle: String!) {
    collectionByHandle(handle: $handle) {
      id
      title
      products(first: 250${cursor ? `, after: "${cursor}"` : ''}) {
        edges {
          cursor
          node {
            id
            title
            handle
            productType
            vendor
            createdAt
            availableForSale
            collections(first: 200) {
              edges {
                node {
                  title
                  handle
                }
              }
            }
            tags
            images(first: 10) {
              edges {
                node {
                  transformedSrc
                  originalSrc
                }
              }
            }
            variants(first: 10) {
              edges {
                node {
                  id
                  title
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPriceV2 {
                    amount
                    currencyCode
                  }
                  image {
                    transformedSrc(maxWidth: 200, maxHeight: 200)
                    originalSrc
                  }
                  selectedOptions {
                    name
                    value
                  }
                  availableForSale
                }
              }
            }
            collectionName: metafield(namespace: "custom", key: "collectionname") {
              value
            }
            skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
              value
            }
            seasonName: metafield(namespace: "custom", key: "seasonname") {
              value
            }
            colorFamily: metafield(namespace: "custom", key: "colorfamily") {
              value
            }
            modelNo: metafield(namespace: "custom", key: "modelno") {
              value
            }
            stof: metafield(namespace: "custom", key: "stof") {
              value
            }
            kleur: metafield(namespace: "custom", key: "kleur") {
              value
            }
            merk: metafield(namespace: "custom", key: "merk") {
              value
            }
            kenmerk: metafield(namespace: "custom", key: "kenmerk") {
              value
            }
            metafield(namespace: "custom", key: "modelno") {
              value
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
  `;
  for (const handle of handles) {
    let hasNextPage = true;
    let cursor = null;
    
    while (hasNextPage) {
      const query = getCollectionByHandleQuery(cursor);
      const variables = { handle };
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'ae17f26e1cbd143df5a2e1cb38a8ce40'
        },
        body: JSON.stringify({ query, variables })
      };
  
      try {
        const response = await fetch('https://alwero-nl.myshopify.com/api/2024-04/graphql.json', options);
        const data = await response.json();
  
        if (data.errors) {
          console.error('GraphQL Errors', data.errors);
          break;
        }
  
        const collection = data.data.collectionByHandle;
        const products = collection.products.edges.map(edge => edge.node);
        allProducts.push(...products);
  
        hasNextPage = collection.products.pageInfo.hasNextPage;
        cursor = collection.products.edges.length > 0 ? collection.products.edges[collection.products.edges.length - 1].cursor : null;
      } catch (error) {
        console.error('Error fetching products:', error);
        break;
      }
    }
  }
  
  console.log("allProductsallProductsallProducts", allProducts);
  return allProducts;
  }


  // Function to group and display products by model number in Featured
function groupAndDisplayFeaturedProducts(products) {
  logEvent('Group and Display Products Called Featured with', products);
   const container = $('.main-group-product-parent.products-grid');
   

  // const containerEach =  container.getAttribute('data-collection');
   console.log("containerEach", container);
   if (!container) {
      logEvent('Container for Featured collection items not found');
      return;
    } 
  
   let totalnumber = 90;
   const productsByModelno = {};
   products.forEach(product => {
   const modelno = product.metafield ? product.metafield.value : null;
      if (modelno) {
          const productId = product.id;
          if (!productsByModelno[modelno]) {
              productsByModelno[modelno] = {
                  ...product,
                  variants: product.variants.edges.map(variant => ({
                      ...variant.node,
                      productId: productId
                  }))
              };
          } else {
              productsByModelno[modelno].variants = productsByModelno[modelno].variants.concat(
                  product.variants.edges.map(variant => ({
                      ...variant.node,
                      productId: productId
                  }))
              );
          }
      }
  });

  console.log('productsByModelnoproductsByModelno', productsByModelno);
    // Clear and populate each container based on matching products
      // $(container).each(function () {
      //   const items_card = $(this);
      //   const MegaAllHandleDiv = items_card.attr('data-collection');
      //   const perPageShow = $(container).attr('data-products-to-show');
      //   console.log("MegaAllHandleDiv", MegaAllHandleDiv);
      //   console.log("perPageShow", perPageShow);
        
      //   // Clear the content of the items_card before appending new products
      //   items_card.html('');
      
      //   // Find products that match the MegaAllHandleDiv
      //   Object.keys(productsByModelno)
      //     .slice(0, totalnumber)
      //     .forEach((modelno) => {
      //       const product = productsByModelno[modelno];
      //       console.log('productdfdfdfdfdfdfdfdproductproduct_modal_again', product);
      
      //       if (product.collections && product.collections.edges) {
      //         const productCollectionHandles = product.collections.edges.map(edge => edge.node.handle);
      //         console.log("productCollectionHandlesproductproductproduct", productCollectionHandles);
      
      //         if (productCollectionHandles.includes(MegaAllHandleDiv)) {
      //           console.log('Product matches collection handle:', product);
      //           const productDiv = createProductCard(product);
      //           items_card.append(productDiv); // Append productDiv to the items_card
      //            // $(container).slick({
      //            //     infinite: true,
      //            //     slidesToShow: 3
      //            //  });
      //         } else {
      //           console.log('Product does not match collection handle:', product);
      //         }
      //       } else {
      //         console.log('Product does not have collections data:', product);
      //       }
      //     });
      // });


      $(container).each(function () {
          const items_card = $(this);
          const MegaAllHandleDiv = items_card.attr('data-collection');
          const perPageShow = parseInt(items_card.attr('data-products-to-show'), 10);
          console.log("MegaAllHandleDivFeatured", MegaAllHandleDiv);
          console.log("perPageShowFeatured", perPageShow);
      
          // Clear the content of the items_card before appending new products
          items_card.html('');
      
          // Find products that match the FeaturedHandleDiv and limit by perPageShow
          let productCount = 0;
      
          Object.keys(productsByModelno).forEach((modelno) => {
              if (productCount >= perPageShow) {
                  return false; // Break the loop if the limit is reached
              }
      
              const product = productsByModelno[modelno];
              console.log('productdfdfdfdfdfdfdfdproductproduct_modal_againFeatured', product);
      
              if (product.collections && product.collections.edges) {
                  const productCollectionHandles = product.collections.edges.map(edge => edge.node.handle);
                  console.log("productCollectionHandlesproductproductproductFeatured", productCollectionHandles);
      
                  if (productCollectionHandles.includes(MegaAllHandleDiv)) {
                      console.log('Product matches collection handle Featured:', product);
                      const productDiv = createProductCard(product);
                      items_card.append(productDiv); // Append productDiv to the items_card
                      productCount++;
                  } else {
                      console.log('Product does not match collection handle Featured:', product);
                  }
              } else {
                  console.log('Product does not have collections data Featured:', product);
              }
          });
      
          // Initialize slick slider if needed
          // if (productCount > 0) {
          //     items_card.slick({
          //         infinite: true,
          //         slidesToShow: 3
          //     });
          // }
      });
      applyCardTitleStyles();
    
}

  // Function to group and display products by model number in query 
function groupAndDisplayProductsQuery(products) {
  logEvent('Group and Display Products Called Featured with', products);
   const container = document.querySelector('.main-query-search');
   const totalSearchItems = document.querySelector(".total-search-query-products");
   

  // const containerEach =  container.getAttribute('data-collection');
   console.log("containerEach", container);
   if (!container) {
      logEvent('Container for Featured collection items not found');
      return;
    } 
  
   let totalnumber = 3;
   const productsByModelno = {};
   products.forEach(product => {
   const modelno = product.metafield ? product.metafield.value : null;
      if (modelno) {
          const productId = product.id;
          if (!productsByModelno[modelno]) {
              productsByModelno[modelno] = {
                  ...product,
                  variants: product.variants.edges.map(variant => ({
                      ...variant.node,
                      productId: productId
                  }))
              };
          } else {
              productsByModelno[modelno].variants = productsByModelno[modelno].variants.concat(
                  product.variants.edges.map(variant => ({
                      ...variant.node,
                      productId: productId
                  }))
              );
          }
      }
  });

  console.log('productsByModelnoproductsByModelno', productsByModelno);
  
   //$(totalSearchItems).find(".total-searching-query-items #query-value").html(""); 
   $(totalSearchItems).show();
   container.innerHTML = ''; // Clear existing content
       // var productCount = {};
       // Object.keys(productsByModelno).forEach(modelno => {
       //    productCount = productsByModelno[modelno];
       // });
      const productCount = Object.keys(productsByModelno);
      const lengthProductTotal = productCount.length;

     // $(totalSearchItems).find(".total-searching-query-items #query-value").html(lengthProductTotal);
      //console.log('productsByModelnoproductsByModelno', productsByModelno)
      Object.keys(productsByModelno)
      .slice(0, totalnumber)
      .forEach((modelno) => {
        const product = productsByModelno[modelno];
        console.log('productdfdfdfdfdfdfdfdproductproduct', product)
        const productDiv = createProductCard(product);
        container.appendChild(productDiv);
      });
      applyCardTitleStyles();
      $(".halo-overlay-custom").hide();
}  
  // Function to initialize the mega menu collections
    async function initMegaMenuCollectionPage() {
      logEvent('Initializing Megamenu collection page...');
       const startInit = performance.now();
       const collectionValues = [];
       $(".halo-overlay-custom").show();
       $('.main-group-product-parent-mega.products-grid').each(function() {
          const collectionValue = $(this).attr('data-collection');
           if (collectionValues.indexOf(collectionValue) === -1) {
              collectionValues.push(collectionValue);
              console.log('Unique data-collection values:', collectionValue);
            }
        });
        console.log('Unique data-collection collectionValues 2:', collectionValues);
        fetchAllProductsForCollectionMegaMenu(collectionValues);
    }

 
 // Function to fetch all products in a collection
async function fetchAllProductsForCollectionMegaMenu(collectionHandle) {
    let cursor = null;
      fetchProductsWithMetafieldsForCollectionMegaMenu(collectionHandle, cursor).then(products => {
          const startInit = performance.now();
          console.log('Fetched products:', products);
          const endInit = performance.now();
          groupAndDisplayMegaMenuProducts(products);  
        });
}
  
const fetchProductsWithMetafieldsForCollectionMegaMenu = async (handles,  cursor = null) => {
console.log(handles, 'collectionHandlecollectionHandleMega');
 const allProducts = [];
 const getCollectionByHandleQuery = (cursor) => `
query getCollectionByHandle($handle: String!) {
  collectionByHandle(handle: $handle) {
    id
    title
    products(first: 250${cursor ? `, after: "${cursor}"` : ''}) {
      edges {
        cursor
        node {
          id
          title
          handle
          productType
          vendor
          createdAt
          availableForSale
          collections(first: 200) {
            edges {
              node {
                title
                handle
              }
            }
          }
          tags
          images(first: 10) {
            edges {
              node {
                transformedSrc
                originalSrc
              }
            }
          }
          variants(first: 10) {
            edges {
              node {
                id
                title
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                image {
                  transformedSrc(maxWidth: 200, maxHeight: 200)
                  originalSrc
                }
                selectedOptions {
                  name
                  value
                }
                availableForSale
              }
            }
          }
          collectionName: metafield(namespace: "custom", key: "collectionname") {
            value
          }
          skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
            value
          }
          seasonName: metafield(namespace: "custom", key: "seasonname") {
            value
          }
          colorFamily: metafield(namespace: "custom", key: "colorfamily") {
            value
          }
          modelNo: metafield(namespace: "custom", key: "modelno") {
            value
          }
          stof: metafield(namespace: "custom", key: "stof") {
            value
          }
          kleur: metafield(namespace: "custom", key: "kleur") {
            value
          }
          merk: metafield(namespace: "custom", key: "merk") {
            value
          }
          kenmerk: metafield(namespace: "custom", key: "kenmerk") {
            value
          }
          metafield(namespace: "custom", key: "modelno") {
            value
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
}
`;
for (const handle of handles) {
  let hasNextPage = true;
  let cursor = null;
  
  while (hasNextPage) {
    const query = getCollectionByHandleQuery(cursor);
    const variables = { handle };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'ae17f26e1cbd143df5a2e1cb38a8ce40'
      },
      body: JSON.stringify({ query, variables })
    };

    try {
      const response = await fetch('https://alwero-nl.myshopify.com/api/2024-04/graphql.json', options);
      const data = await response.json();

      if (data.errors) {
        console.error('GraphQL Errors', data.errors);
        break;
      }

      const collection = data.data.collectionByHandle;
      const products = collection.products.edges.map(edge => edge.node);
      allProducts.push(...products);

      hasNextPage = collection.products.pageInfo.hasNextPage;
      cursor = collection.products.edges.length > 0 ? collection.products.edges[collection.products.edges.length - 1].cursor : null;
    } catch (error) {
      console.error('Error fetching products:', error);
      break;
    }
  }
}

console.log("allProductsallProductsallProducts", allProducts);
return allProducts;
}



// Function to group and display products by model number in Megamenu
function groupAndDisplayMegaMenuProducts(products) {
  logEvent('Group and Display Products Called Megamenu with', products);
   const container = $('.main-group-product-parent-mega.products-grid');
   

  // const containerEach =  container.getAttribute('data-collection');
   console.log("containerEach", container);
   if (!container) {
      logEvent('Container for Megamenu collection items not found');
      return;
    } 
  
   let totalnumber = 90;
   const productsByModelno = {};
   products.forEach(product => {
   const modelno = product.metafield ? product.metafield.value : null;
      if (modelno) {
          const productId = product.id;
          if (!productsByModelno[modelno]) {
              productsByModelno[modelno] = {
                  ...product,
                  variants: product.variants.edges.map(variant => ({
                      ...variant.node,
                      productId: productId
                  }))
              };
          } else {
              productsByModelno[modelno].variants = productsByModelno[modelno].variants.concat(
                  product.variants.edges.map(variant => ({
                      ...variant.node,
                      productId: productId
                  }))
              );
          }
      }
  });

  console.log('productsByModelnoproductsByModelno', productsByModelno);
      $(container).each(function () {
          const items_card = $(this);
          const MegaAllHandleDiv = items_card.attr('data-collection');
          const perPageShow = parseInt(items_card.attr('data-products-to-show'), 10);
          console.log("MegaAllHandleDiv", MegaAllHandleDiv);
          console.log("perPageShow", perPageShow);
      
          // Clear the content of the items_card before appending new products
          items_card.html('');
      
          // Find products that match the MegaAllHandleDiv and limit by perPageShow
          let productCount = 0;
      
          Object.keys(productsByModelno).forEach((modelno) => {
              if (productCount >= perPageShow) {
                  return false; // Break the loop if the limit is reached
              }
      
              const product = productsByModelno[modelno];
              console.log('productdfdfdfdfdfdfdfdproductproduct_modal_again', product);
      
              if (product.collections && product.collections.edges) {
                  const productCollectionHandles = product.collections.edges.map(edge => edge.node.handle);
                  console.log("productCollectionHandlesproductproductproduct", productCollectionHandles);
      
                  if (productCollectionHandles.includes(MegaAllHandleDiv)) {
                      console.log('Product matches collection handle:', product);
                      const productDiv = createProductCardMegaMenu(product);
                      items_card.append(productDiv); // Append productDiv to the items_card
                      productCount++;
                  } else {
                      console.log('Product does not match collection handle:', product);
                  }
              } else {
                  console.log('Product does not have collections data:', product);
              }
          });
      
          // Initialize slick slider if needed
          // if (productCount > 0) {
          //     items_card.slick({
          //         infinite: true,
          //         slidesToShow: 3
          //     });
          // }
      });
      applyCardTitleStyles();
       $(".halo-overlay-custom").hide();
      
    
}

  function createProductMegaMenuCard(product) {
      const productDiv = document.createElement('div');
      productDiv.classList.add('product-card');
      
      // Add your product details to the div
      productDiv.innerHTML = `
        <h2>${product.title}</h2>
        <p>${product.vendor}</p>
      `;
      
      return productDiv;
  }
      
  /********sarch********** */
    async function fetchProductsWithMetafieldsSearch(cursor = null) {
    
      // Example usage:
      if(window.location.pathname != '/search'){
        return; 
      }
      const url = window.location.href;
      const urlParams = new URL(url).searchParams;
      const searchQuery = urlParams.get('q');
      console.log(searchQuery, 'searchQuery');
      const query = `
      {
        products(first: 250, query: "${searchQuery}"${cursor ? `, after: "${cursor}"` : ''}) {
          edges {
            cursor
              node {
                id
                title
                handle
                productType
                vendor
                createdAt
                availableForSale
                collections(first: 10) {
                  edges {
                    node {
                      title
                    }
                  }
                }
                tags
                images(first: 10) {
                  edges {
                    node {
                      transformedSrc
                      originalSrc
                    }
                  }
                }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    priceV2 {
                      amount
                      currencyCode
                    }
                    compareAtPriceV2 {
                      amount
                      currencyCode
                    }
                    image {
                      transformedSrc(maxWidth: 200, maxHeight: 200)
                      originalSrc
                    }
                    selectedOptions {
                      name
                      value
                    }
                    metafield(namespace: "custom", key: "promisedreceiptdate1") {
                      value
                    }
                    availableForSale
                  }
                }
              }
               collectionName: metafield(namespace: "custom", key: "collectionname") {
                  value
                }
                skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
                  value
                }
                seasonName: metafield(namespace: "custom", key: "seasonname") {
                  value
                }
                colorFamily: metafield(namespace: "custom", key: "colorfamily") {
                  value
                }
                modelNo: metafield(namespace: "custom", key: "modelno") {
                  value
                }
                stof: metafield(namespace: "custom", key: "stof") {
                  value
                }
                kleur: metafield(namespace: "custom", key: "kleur") {
                  value
                }
                merk: metafield(namespace: "custom", key: "merk") {
                  value
                }
                kenmerk: metafield(namespace: "custom", key: "kenmerk") {
                  value
                }
                metafield(namespace: "custom", key: "modelno") {
                  value
                }
              metafield(namespace: "custom", key: "modelno") {
                value
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `;
    
      try {
        const response = await fetch('https://alwero-nl.myshopify.com/api/2024-04/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'ae17f26e1cbd143df5a2e1cb38a8ce40'
          },
          body: JSON.stringify({ query })
        });
    
        if (!response.ok) {
          console.error('Network response was not ok:', response.statusText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const responseBody = await response.json();
        console.log('Full Response Body:', responseBody);
    
        if (responseBody.errors) {
          console.error('GraphQL Errors:', responseBody.errors);
          responseBody.errors.forEach(error => {
            console.error('Error:', error.message);
          });
          return { products: [], hasNextPage: false };
        }
    
        if (!responseBody.data || !responseBody.data.products) {
          console.error('Unexpected response structure:', responseBody);
          return { products: [], hasNextPage: false };
        }
    
        const products = responseBody.data.products.edges.map(edge => edge.node);
        const hasNextPage = responseBody.data.products.pageInfo.hasNextPage;
        const lastCursor = responseBody.data.products.edges.length > 0 
          ? responseBody.data.products.edges[responseBody.data.products.edges.length - 1].cursor 
          : null;
    
          let urlc = window.location.href;
          let urlParams = getURLParams(urlc);
          console.log(urlParams);
          if (JSON.stringify(urlParams) !== '{}') {
            const filteredProducts = products.filter(product => {
             
              const collectionNames = urlParams['filter.p.m.custom.collectionname'] 
                ? (Array.isArray(urlParams['filter.p.m.custom.collectionname']) ? urlParams['filter.p.m.custom.collectionname'] : [urlParams['filter.p.m.custom.collectionname']])
                : null;
          
              const productTypes = urlParams['filter.p.product_type'] 
                ? (Array.isArray(urlParams['filter.p.product_type']) ? urlParams['filter.p.product_type'] : [urlParams['filter.p.product_type']])
                : null;
          
              const colorFamilies = urlParams['filter.p.m.custom.colorfamily'] 
                ? (Array.isArray(urlParams['filter.p.m.custom.colorfamily']) ? urlParams['filter.p.m.custom.colorfamily'] : [urlParams['filter.p.m.custom.colorfamily']])
                : null;
          
              const seasonNames = urlParams['filter.p.m.custom.seasonname'] 
                ? (Array.isArray(urlParams['filter.p.m.custom.seasonname']) ? urlParams['filter.p.m.custom.seasonname'] : [urlParams['filter.p.m.custom.seasonname']])
                : null;
          
              const stofs = urlParams['filter.p.m.custom.stof'] 
                ? (Array.isArray(urlParams['filter.p.m.custom.stof']) ? urlParams['filter.p.m.custom.stof'] : [urlParams['filter.p.m.custom.stof']])
                : null;
              
              const merk = urlParams['filter.p.m.custom.merk'] || null;
              const minPrice = urlParams['filter.v.price.gte'] ? parseFloat(urlParams['filter.v.price.gte']) : 0;
              const maxPrice = urlParams['filter.v.price.lte'] ? parseFloat(urlParams['filter.v.price.lte']) : Infinity;
          
              const matchesCollectionName = collectionNames && collectionNames.length > 0 && !collectionNames.includes(undefined) ? collectionNames.includes(product.collectionName?.value) : true;
              const matchesProductType = productTypes && productTypes.length > 0 && !productTypes.includes(undefined) ? productTypes.includes(product.productType) : true;
              const matchesColorFamily = colorFamilies && colorFamilies.length > 0 && !colorFamilies.includes(undefined) ? colorFamilies.includes(product.colorFamily?.value) : true;
              const matchesSeasonName = seasonNames && seasonNames.length > 0 && !seasonNames.includes(undefined) ? product.seasonName?.value.includes(seasonNames) : true;
              const matchesStof = stofs && stofs.length > 0 && !stofs.includes(undefined) ? stofs.includes(product.stof?.value) : true;
              const matchesMerk = merk ? product.merk?.value === merk : true;
          
              let matchesPriceAndAvailability = true;
              //console.log(product.variants?.edges, 'variantsvariantsvariantsvariantsvariants')
              if (product.variants) {
                matchesPriceAndAvailability = product.variants?.edges.some(variant => {
                  return parseFloat(variant.node.priceV2.amount) >= minPrice &&
                         parseFloat(variant.node.priceV2.amount) <= maxPrice;
                });
              }
          
              return (
                matchesCollectionName &&
                matchesProductType &&
                matchesColorFamily &&
                matchesSeasonName &&
                matchesStof &&
                matchesMerk &&
                matchesPriceAndAvailability
              );
            });
            const sortBy = urlParams['sort_by'] || null;
            console.log(sortBy, 'sortBysortBysortBysortBy')
            console.log('Filtered products with sale prices without filter', filteredProducts);
             if (sortBy) {
               switch (sortBy) {
                 case 'price-ascending':
                  filteredProducts.sort((a, b) => {
                     const aMinPrice = Math.min(...a.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                     const bMinPrice = Math.min(...b.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                     return aMinPrice - bMinPrice;
                   });
                   break;
                 case 'price-descending':
                   console.log('price decending',sortBy )
                   filteredProducts.sort((a, b) => {
                     const aMaxPrice = Math.max(...a.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                     const bMaxPrice = Math.max(...b.variants.edges.map(variant => parseFloat(variant.node.priceV2.amount)));
                     return bMaxPrice - aMaxPrice;
                   });
                   break;
                 case 'title-ascending':
                  filteredProducts.sort((a, b) => a.title.localeCompare(b.title));
                   break;
                 case 'title-descending':
                  filteredProducts.sort((a, b) => b.title.localeCompare(a.title));
                   break;
                 case 'created-ascending':
                  filteredProducts.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                   break;
                 case 'created-descending':
                  filteredProducts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                   break;
                 // case 'best-selling':
                 //   // Implement best-selling sorting logic
                 //   break;
                 // case 'manual':
                 //   // Implement manual sorting logic
                 //   break;
                 default:
                   break;
               }
             }
            console.log('Filtered products with sale prices', filteredProducts);
            return { products: filteredProducts, hasNextPage, lastCursor };
          } else {
            console.log('Filtered products with sale prices', products);
            return { products: products, hasNextPage, lastCursor };
          }  
       // return { products, hasNextPage, lastCursor };
    
      } catch (error) {
        console.error('Fetch Error:', error);
        return { products: [], hasNextPage: false };
      }
    }
    async function fetchAllProductsForSearch() {
      let allProducts = [];
      let hasNextPage = true;
      let cursor = null;
    
      while (hasNextPage) {
        const { products, hasNextPage: nextPage, lastCursor } = await fetchProductsWithMetafieldsSearch(cursor);
        allProducts = allProducts.concat(products);
        hasNextPage = nextPage;
        cursor = lastCursor;
      }
    
      return allProducts;
    }
  
    async function initSearchPage() {
      logEvent('Initializing Search page...');
      const startInit = performance.now();
      //const pathArray = window.location.pathname.split('/');
      //const collectionHandle = pathArray[pathArray.indexOf('search') + 1]; // Dynamically get the collection handle from URL
      const products = await fetchAllProductsForSearch();
      const endInit = performance.now();
      logEvent('Initialization', `took ${endInit - startInit} ms`);
      logEvent('Fetched Products for Search Page', products);
      groupAndDisplayProductsSearch(products);
      
    }


  async function GetAllProductRecommendations(product) {
    logEvent('Initializing Product recommendations page...');
    const startInit = performance.now();
    console.log("product recommendations", product);
    const ProductId = product;
    fetchAllRecommendationProducts(ProductId);
  }
  async function fetchAllRecommendationProducts(ProductId) {
    fetchProductRecommendations(ProductId).then((recommendations) => {
        const startInit = performance.now();
        console.log('Product Recommendations Items:', recommendations);
        const endInit = performance.now();
        groupAndDisplayProductRecommendations(recommendations);
      })
      .catch((error) => {
        console.error('Error fetching product recommendations:', error);
    });
  }
  const fetchProductRecommendations = async (productId) => {
    const url = 'https://alwero-nl.myshopify.com/api/2024-04/graphql.json'; // Update the version as necessary
    const token = 'ae17f26e1cbd143df5a2e1cb38a8ce40'; // Replace with your actual access token
    console.log("product id recommendations", productId);
    const cursor = null;
    const query = `
      query getProductRecommendations($productId: ID!) {
        productRecommendations(productId: $productId) {
            id
            title
            handle
            productType
            vendor
            availableForSale
            collections(first: 200) {
                    edges {
                        node {
                          title
                          handle
                        }
                    }
                }
            tags
            images(first: 10) {
                edges {
                  node {
                    transformedSrc
                    originalSrc
                  }
                }
              }
            variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    priceV2 {
                      amount
                      currencyCode
                    }
                    compareAtPriceV2 {
                      amount
                      currencyCode
                    }
                    image {
                      transformedSrc(maxWidth: 200, maxHeight: 200)
                      originalSrc
                    }
                    selectedOptions {
                      name
                      value
                    }
                    availableForSale
                  }
                }
              }
            collectionName: metafield(namespace: "custom", key: "collectionname") {
                        value
                      }
                      skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
                        value
                      }
                      seasonName: metafield(namespace: "custom", key: "seasonname") {
                        value
                      }
                      colorFamily: metafield(namespace: "custom", key: "colorfamily") {
                        value
                      }
                      modelNo: metafield(namespace: "custom", key: "modelno") {
                        value
                      }
                      stof: metafield(namespace: "custom", key: "stof") {
                        value
                      }
                      kleur: metafield(namespace: "custom", key: "kleur") {
                        value
                      }
                      merk: metafield(namespace: "custom", key: "merk") {
                        value
                      }
                      kenmerk: metafield(namespace: "custom", key: "kenmerk") {
                        value
                      }
                      metafield(namespace: "custom", key: "modelno") {
                        value
                      }
              }
       }
    `;
  
    const variables = {
      productId: productId,
    };
  
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query, variables }),
    });
    
    if (!response.ok) {
      console.error('Network response was not ok', response.statusText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const responseData = await response.json();

    if (response.ok) {
      return responseData.data.productRecommendations;
    } else {
      console.error('GraphQL error:', responseData.errors);
      throw new Error('Failed to fetch product recommendations');
    }
  }
// Function to group and display Products by modal number in Products Recommendations 
function groupAndDisplayProductRecommendations(products) {
  logEvent('Group and Display Products Called Recommendations with', products);

  const container = $('.product-recommendations-loading .products-carousel')[0];
  if (container.length === 0) {
    logEvent('Container for collection items not found');
    return;
  }
  console.log("sfsfsfsfsfsfsfsfsf", container);
  const productsByModelno = {};
  const totalnumber = 30;

  products.forEach(product => {
    const modelno = product.metafield ? product.metafield.value : null;
    if (modelno) {
      const productId = product.id;
      if (!productsByModelno[modelno]) {
        productsByModelno[modelno] = {
          ...product,
          variants: product.variants.edges.map(variant => ({
            ...variant.node,
            productId: productId
          }))
        };
      } else {
        productsByModelno[modelno].variants = productsByModelno[modelno].variants.concat(
          product.variants.edges.map(variant => ({
            ...variant.node,
            productId: productId
          }))
        );
      }
    }
  });

  $(container).html(''); // Clear the content of the container
  console.log('productsByModelnoproductsByModelnoRecommendations', productsByModelno);

  Object.keys(productsByModelno)
    .slice(0, totalnumber)
    .forEach((modelno, index, array) => {
      const product = productsByModelno[modelno];
      console.log('productdfdfdfdfdfdfdfdproductproductRecommendations', product);

     // setTimeout(function(){
        const productDiv = createProductCard(product);
        $(container).append(productDiv);

        // If last element, initialize slick
        if (index === array.length - 1) {
          $(container).slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>'
         
          });
          // Show the container once products are ready
          $(container).css('display', 'block');
          
        }
     // }, 10000);
    });
}
    // Function to update product thumbnails
    function updateThumbnails(product) {
      console.log('Update Thumbnails Called with:', product);
      const thumbnailWrapper = document.querySelector('.productView-thumbnail-wrapper');
      if (!thumbnailWrapper) {
        console.error('Thumbnail wrapper not found');
        return;
      }
      thumbnailWrapper.innerHTML = '';
  
      product.images.edges.forEach(imageEdge => {
        const image = imageEdge.node;
        console.log('Adding thumbnail for image:', image);
        const thumbnailDiv = document.createElement('div');
        thumbnailDiv.className = 'productView-thumbnail';
  
        const thumbnailLink = document.createElement('a');
        thumbnailLink.href = 'javascript:void(0);';
        thumbnailLink.className = 'productView-thumbnail-link';
        thumbnailLink.setAttribute('data-image-url', image.originalSrc);
        thumbnailLink.setAttribute('data-variant-id', product.id.split('/').pop());
  
        const thumbnailImg = document.createElement('img');
        thumbnailImg.src = image.originalSrc;
        thumbnailImg.alt = product.title;
  
        thumbnailLink.appendChild(thumbnailImg);
        thumbnailDiv.appendChild(thumbnailLink);
        thumbnailWrapper.appendChild(thumbnailDiv);
      });
    }
  
    // Function to highlight a selected thumbnail
    function highlightThumbnail(imageUrl) {
      console.log('Highlighting thumbnail:', imageUrl);
      document.querySelectorAll('.productView-thumbnail').forEach(el => {
        el.classList.remove('selected');
        const thumbnailLink = el.querySelector('.productView-thumbnail-link');
        if (thumbnailLink && thumbnailLink.getAttribute('data-image-url') === imageUrl) {
          el.classList.add('selected');
        }
      });
    }
  
    // Function to highlight a selected variant
    function highlightVariant(imageUrl) {
      console.log('Highlighting variant:', imageUrl);
      document.querySelectorAll('.variant-selector').forEach(el => {
        el.classList.remove('selected');
       let cl = el.getAttribute('data-high-res-image-url'); 
        console.log(el,'el',cl);
        if (el.getAttribute('data-high-res-image-url') === imageUrl) {
          el.classList.add('selected');
        }else{
          console.log('ready click');
        }
      });
    }
  
    // Function to set the selected variant
    function setSelectedVariant(variantId, variantImageUrl) {
      console.log('Setting selected variant:', variantId, variantImageUrl);
      const variantInput = document.querySelector('input[name="id"]');
      const imageUrlInput = document.querySelector('input[name="properties[variant_image_url]"]');
      const empty_img = 'https://cdn.shopify.com/s/files/1/0673/6094/8477/files/default_image.svg?v=1725886016';
      
      if (variantInput) {
        variantInput.value = variantId;
      }
      if (imageUrlInput) {
        imageUrlInput.value = variantImageUrl;
      }else{
        imageUrlInput.value = empty_img;
      }
      updateReceiptDate(variantId);
      
    }
  
  
  
    // Function to update the receipt date based on the selected variant
    function updateReceiptDate(variantId) {
      console.log('Updating receipt date for variant:', variantId);
  
      const variantElement = document.querySelector(`#variant-list li[data-variant-id="${variantId}"]`);
      const receiptDateContainer = document.querySelector('#variant-receipt-date-container');
  
      if (variantElement) {
        const receiptDate = variantElement.getAttribute('data-receipt-date');
        const formattedDate = new Date(receiptDate).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        });
        const receiptDateElement = document.querySelector('#variant-receipt-date');
        receiptDateElement.textContent = `Estimated Availability Date: ${formattedDate}`;
        receiptDateContainer.style.display = 'block';
      } else {
        const receiptDateElement = document.querySelector('#variant-receipt-date');
       if(receiptDateElement){ receiptDateElement.textContent = 'No promised receipt date available.'};
       if(receiptDateContainer){receiptDateContainer.style.display = 'block'};
      }
    }

  
    // Function to update the promised receipt date
    function updatePromisedReceiptDate(variantId) {
      const promisedReceiptDateContainer = document.getElementById('promised-receipt-date-container');
  
      if (!promisedReceiptDateContainer) {
        console.error('promised-receipt-date-container not found.');
        return;
      }
  
      const variantMetafield = document.querySelector(`.variant-metafield[data-variant-id="${variantId}"]`);
  
      console.log("Updating receipt date for variant:", variantId);
      console.log("Found variant metafield:", variantMetafield);
  
      if (variantMetafield) {
        const receiptDate = variantMetafield.getAttribute('data-receipt-date');
        promisedReceiptDateContainer.innerHTML = `
          <p class="promised-receipt-date">
            Estimated Availability Date: ${receiptDate}
          </p>
        `;
      } else {
        promisedReceiptDateContainer.innerHTML = `
          <p class="promised-receipt-date">
            No promised receipt date available.
          </p>
        `;
      }
    }
  
    // // update current variant size 
    // function SizeVariantcurrent(firstProduct) {
    //   const productId = firstProduct.id.split('/').pop();
    //   const variants = firstProduct.variants;
    //   allVariants = firstProduct.variants.edges.map(edge => edge.node);
    //    console.log("current firstProduct", firstProduct);
  
    //     const fieldset = document.querySelector('fieldset[data-product-attribute="set-rectangle"]');
    //     const inputsAndLabels = fieldset.querySelectorAll('input, label');
      
    //     // Remove each input and label element
    //     inputsAndLabels.forEach(element => {
    //       element.remove();
    //     });
    //     variants.edges.forEach((variant, index) => {
    //       console.log("current variant", variant);
    //      // console.log("sizeOrder", sizeOrder);
    //       let variantTitle = variant.node.title;
    //       let variantId = variant.node.id.split('/').pop();
          
    //       // Add 'checked' attribute to the first variant
    //       let isChecked = index === 0 ? ' checked' : '';
    //       const input = document.createElement('input');
    //         input.setAttribute('data-variants', '');
    //         input.classList.add('product-form__radio');
    //         input.type = 'radio';
    //         input.id = `option-${productId}-Variant-${index}`;
    //         input.name = 'Variant';
    //         input.value = variantTitle;
    //         input.setAttribute('data-variant-id', variantId);
    //         if (isChecked) {
    //           input.checked = true;
    //           let checkVariant = variant.node.id.split('/').pop();
    //           //const hiddenInput = document.querySelector('input[name="id"]');
    //           //hiddenInput.value = checkVariant;
    //           $("input[name=id]").val(checkVariant);
    //           console.log("checkVariant",checkVariant);
    //           updatePrice(checkVariant);
    //         }
  
    //        const label = document.createElement('label');
    //         label.setAttribute('data-variants', '');
    //         label.classList.add('change_delivery', 'product-form__label', 'available');
    //         label.setAttribute('for', `option-${productId}-Variant-${index}`);
    //         label.setAttribute('data-variant-id', variantId);
            
    //         const span = document.createElement('span');
    //         span.classList.add('text');
    //         span.textContent = variantTitle;
            
    //        label.appendChild(span);
    //        fieldset.appendChild(input);
    //        fieldset.appendChild(label);
          
    //     });
    // }
    
    // function changeFieldset(variantId) {
    //   const variantfield = document.querySelector("variant-radios fieldset input:checked").value;
    //   const fieldsetLegend = document.querySelector("fieldset legend span");
    //   fieldsetLegend.textContent = variantfield;
    //   console.log("ss", variantfield);
    // }
    //  // color name updated change variants
    // function ColorMetafieldNames(colorname) {
    //   const colorName = colorname.value;
    //   const color_section = document.querySelector(".kleur-section");
    //   const color_value = color_section.querySelector(".kleur-value");
    //   $(color_value).text(colorName);    
    // }
// Define the order of standard sizes
const sizeOrder = ["XS", "XXS/XS", "XS/S", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XL/XXL", "XXL", "2XL", "3XL", "4XL", "5XL"];

// Function to extract numerical values from a size string
function extractSizeValues(size) {
  const matches = size.match(/(\d+)/g);
  return matches ? matches.map(Number) : [];
}

// Function to sort variants based on extracted numerical values and predefined size order
function sortVariantsBySize(variants) {
  return variants.sort((a, b) => {
    const sizeA = a.title.toUpperCase();
    const sizeB = b.title.toUpperCase();

    // Check if both sizes are in the predefined size order
    const indexA = sizeOrder.indexOf(sizeA);
    const indexB = sizeOrder.indexOf(sizeB);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // If one of the sizes is not in the predefined order, sort by numerical values
    const numA = extractSizeValues(sizeA);
    const numB = extractSizeValues(sizeB);

    for (let i = 0; i < Math.min(numA.length, numB.length); i++) {
      if (numA[i] !== numB[i]) {
        return numA[i] - numB[i];
      }
    }

    return numA.length - numB.length;
  });
}

    
// Update current variant size
function SizeVariantcurrent(firstProduct) {
  const productId = firstProduct.id.split('/').pop();
  const variants = firstProduct.variants;
  
   allVariants = sortVariantsBySize(firstProduct.variants.edges.map(edge => edge.node)); // Populate allVariants here
  // console.log("alllllllllll variants", allVariants);
  // Sort the variants by size
  // allVariants = sortVariantsBySize(allVariants);

  console.log("alllllllllll variantsssss", allVariants);
  
  
  const fieldset = document.querySelector('fieldset[data-product-attribute="set-rectangle"]');
  const inputsAndLabels = fieldset.querySelectorAll('input, label');

  // Remove each input and label element
  inputsAndLabels.forEach(element => {
if (element && typeof element.remove === "function") element.remove();
  });

  let firstAvailableChecked = false;
  let allVariantsUnavailable = true; // Assume all variants are unavailable initially
  
  allVariants.forEach((variant, index) => {
      console.log("current variant", variant);
      
      let variantTitle = variant.title;
      let variantId = variant.id.split('/').pop();
      let variantAvailable = variant.availableForSale;
      
      // Add 'checked' attribute only to the first available variant
      let isChecked = !firstAvailableChecked && variantAvailable ? ' checked' : '';
      
      const input = document.createElement('input');
      input.setAttribute('data-variants', '');
      input.classList.add('product-form__radio');
      input.type = 'radio';
      input.id = `option-${productId}-Variant-${index}`;
      input.name = 'Variant';
      input.value = variantTitle;
      input.setAttribute('data-variant-id', variantId);
      input.setAttribute('data-available-qty', variantAvailable);
      
      if (isChecked) {
        input.checked = true;
        firstAvailableChecked = true; // Make sure only the first available variant gets checked
        let checkVariant = variant.id.split('/').pop();
        
        $("input[name=id]").val(checkVariant);
        console.log("variant", variant);
        $(".money-subtotal").html(`€${variant.priceV2.amount}`);
        $(".transcy-money").html(`€${variant.priceV2.amount}`);
        console.log("checkVariant", checkVariant);
        
        updatePrice(checkVariant);
        
        const fieldsetLegend = document.querySelector("fieldset legend span");
        fieldsetLegend.textContent = variantTitle;
      }
  
      // If any variant is available, set allVariantsUnavailable to false
      if (variantAvailable) {
        allVariantsUnavailable = false;
      }
  
      // Handle sold out/available labels
      var variantAvailableLabel = variantAvailable ? 'available' : 'soldout';

      if(variantAvailable == false){
        console.log("yesss variant not avaialble");
        updatePrice(variantId);
      }
      const label = document.createElement('label');
      label.setAttribute('data-variants', '');
      label.classList.add('change_delivery', 'product-form__label', variantAvailableLabel);
      label.setAttribute('for', `option-${productId}-Variant-${index}`);
      label.setAttribute('data-variant-id', variantId);
  
      const span = document.createElement('span');
      span.classList.add('text');
      span.textContent = variantTitle;
  
      label.appendChild(span);
      fieldset.appendChild(input);
      fieldset.appendChild(label);
    });
  
// Function to select the first available variant when switching colors
function selectFirstAvailableVariant() {
    let firstAvailableInput = $("input[name='Variant'][data-available-qty='true']").first();
    
    if (firstAvailableInput.length) {
        console.log("First available variant found: ", firstAvailableInput.val());
        firstAvailableInput.prop("checked", true).trigger("change");
    } else {
        console.log("No available variant found. All variants are sold out.");
        updateAddToCartButton(true); // Force "Sold Out" if all variants are unavailable
    }
}

// Function to update "Add to Cart" button status
function updateAddToCartButton(isSoldOut) {
    let $button = $(".product-form__buttons .product-form__submit");
    
    if (isSoldOut) {
        console.log("Disabling Add to Cart button - Product Sold Out");
        
        $button.prop("disabled", true)
               .removeAttr("id")
               .fadeOut(100, function () {
                   $(this).html("Uitverkocht").fadeIn(200);
               });

        // Ensure "Sold Out" badge is only added once
        if ($(".productView-badge .badge.sold-out-badge").length === 0) {
            var soldOutBadge = `<div class="productView-badge badge-right halo-productBadges halo-productBadges--right">
                <span class="badge sold-out-badge" aria-hidden="true">Uitverkocht</span></div>`;
            $(".productView-image-wrapper").prepend(soldOutBadge);
        }
    } else {
        console.log("Enabling Add to Cart button - Product Available");

        $button.prop("disabled", false)
               .removeAttr("disabled")
               .attr("id", "product-add-to-cart")
               .fadeOut(100, function () {
                   $(this).html("+ Winkelwagen").fadeIn(200);
               });

        // Remove "Sold Out" badge if a variant is available
        $(".productView-badge .badge.sold-out-badge").remove();
    }

    // Force UI refresh
    $button.trigger("change");
}

// Listen for variant selection changes
$("input[name='Variant']").on("change", function () {
    const selectedVariantId = $(this).attr("data-variant-id");
    const variantAvailable = $(this).attr("data-available-qty") === "true";

    console.log("Variant changed: ", selectedVariantId, "Available:", variantAvailable);

    // Update button status
    setTimeout(function() {
        updateAddToCartButton(!variantAvailable);
    }, 50);
});

// **Reset variant selection when switching colors**
$(".product-view__color-selector, .productView-thumbnail").on("click", function () {
    console.log("Color changed - Resetting variant selection.");

    // Uncheck all variants before switching
    $("input[name='Variant']").prop("checked", false);

    // Wait for DOM update, then select a valid variant
    setTimeout(function() {
        selectFirstAvailableVariant();
    }, 200);
});

// **Ensure a valid variant is selected on page load**
$(document).ready(function() {
    selectFirstAvailableVariant();
});






}

// Function to update the price based on the selected variant
  function updatePrice(variantId) {
      console.log('Updating price for variant:', variantId);
      console.log('All variants:', allVariants);
      //var selectedVariant = '';
      // if(allVariants.length == 0){
      //  // selectedVariant = variantId;
      // }else{
      //    selectedVariant = allVariants.find(variant => variant.id.split('/').pop() === variantId);
      // }
       const selectedVariant = allVariants.find(variant => variant.id.split('/').pop() === variantId);
       console.log('Selected selectedVariant:', selectedVariant);
      if (selectedVariant) {
        console.log('Selected variant:', selectedVariant);
        const parentElement = document.querySelector('.productView-price .price .price__sale .custom-sale-badge');
        const comparePriceElement = document.querySelector('.productView-price .price .price__sale  .price-item.price-item--regular');
        const lastPrice = document.querySelector(".price__sale .price__last .price-item.price-item--sale .transcy-money");
        const priceElement = document.querySelector('.productView-price .price__last .transcy-money');
        const priceElementLastCompare = document.querySelector('.productView-price .price__sale .price__last .price-item.price-item--sale span');
        const subtotalElement = document.querySelector('.productView-subtotal .money-subtotal');

       
        if (priceElement) {
          console.log('Updating price element:', priceElement);
          priceElement.textContent = `€${selectedVariant.priceV2.amount}`;
        }
        if(priceElementLastCompare){
               console.log('Updating price priceElement:', priceElementLastCompare);
               priceElementLastCompare.textContent = `€${selectedVariant.priceV2.amount}`;
            }
        if(selectedVariant.compareAtPriceV2 && selectedVariant.compareAtPriceV2 != null){
              document.querySelector('.productView-price .price').classList.add("price--on-sale");
              //$(lastPrice).html()
            // Check if comparePrice element already exists  
           
           if (!comparePriceElement.querySelector(".transcy-money")) {
               let compareHtml = document.createElement("span");
               compareHtml.className = "transcy-money compare";
               compareHtml.innerHTML = `€${selectedVariant.compareAtPriceV2.amount}`;
               comparePriceElement.append(compareHtml);
           }
           if(comparePriceElement.querySelector(".transcy-money")) {
             let spanExists = comparePriceElement.querySelector(".transcy-money");
             spanExists.innerHTML = `€${selectedVariant.compareAtPriceV2.amount}`;
           }
           if (!parentElement.querySelector(".product-sale-badge")) {
               let spanElement = document.createElement("span");
                spanElement.className = "label_sale saleLabel-cust product-sale-badge";
                spanElement.innerHTML = "Sale";
                parentElement.append(spanElement); 
            }
         }else{
               const Salebadge = document.querySelector(".product-sale-badge");
               if(Salebadge){
if (Salebadge && typeof Salebadge.remove === "function") Salebadge.remove();
               }
               document.querySelector('.productView-price .price').classList.remove("price--on-sale");
         }    
        if (subtotalElement) {
          console.log('Updating subtotal element:', subtotalElement);
          subtotalElement.textContent = `€${selectedVariant.priceV2.amount}`;
        }
      } else {
        console.log('Variant not found:', variantId);
      }
    }    

function changeFieldset(variantId) {
  const variantfield = document.querySelector("variant-radios fieldset input:checked").value;
  const fieldsetLegend = document.querySelector("fieldset legend span");
  fieldsetLegend.textContent = variantfield;
  console.log("ss", variantfield);
}

// Color name updated change variants
function ColorMetafieldNames(colorname) {
  const colorName = colorname.value;
  const color_section = document.querySelector(".kleur-section");
  const color_value = color_section.querySelector(".kleur-value");
  $(color_value).text(colorName);
}

async function fetchProductIdByHandle(handle) {
  const url = 'https://alwero-nl.myshopify.com/api/2024-04/graphql.json'; // Update the version as necessary
  const token = 'ae17f26e1cbd143df5a2e1cb38a8ce40'; // Replace with your actual access token

  const query = `
    query getProductIDByHandle($handle: String!) {
      productByHandle(handle: $handle) {
        id
      }
    }
  `;

  const variables = {
    handle: handle,
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query, variables }),
    });

    const responseData = await response.json();

    if (response.ok) {
      return responseData.data.productByHandle.id;
    } else {
      console.error('GraphQL error:', responseData.errors);
      throw new Error('Failed to fetch product ID');
    }
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
}

// Example usage:
async function FetchFirstProduct(){
  const productHandle = $(".product-details .productView").attr("data-product-handle");
    const startInit = performance.now();
     
  fetchProductIdByHandle(productHandle)
  .then(productId => {
     const endInit = performance.now();
   
    GetAllProductRecommendations(productId);
      logEvent('Initializing Product..... page...');
        logEvent('Initialization', `took ${endInit - startInit} ms`);
  })
  .catch(error => {
    console.error('Error fetching product ID:', error);
  });
}

    function removeLoading(){
      $("body").removeClass("has-halo-loader");
    }
    // Event listener for clicks
    document.addEventListener('click', function(event) {
      if (event.target.closest('.variant-selector')) {
        event.preventDefault();
        event.stopPropagation();
        const selector = event.target.closest('.variant-selector');
        const imageUrl = selector.getAttribute('data-high-res-image-url');
        const variants = JSON.parse(selector.getAttribute('data-variants'));
        const variantId = variants[0].id.split('/').pop();
        const productId = variantId.split('/').pop();
        
  
        console.log('Variant selector clicked:', {
          selector,
          imageUrl,
          variants,
          productId
          
        });
  
        fetchAllProducts().then(products => {
          const selectedProduct = products.find(product => product.variants.edges.some(edge => edge.node.id.split('/').pop() === productId));
          console.log('Selected Product:', selectedProduct);
          console.log("selected-productsss", selectedProduct);
          if (selectedProduct) {
            // udpate change variations to variant id
            $("input[name=id]").val(variantId);
            
            allVariants = selectedProduct.variants.edges.map(edge => edge.node); // Populate allVariants here
            const ColorMetafieldName = selectedProduct.kleur; // get product metafield color name
            const mainImageContainer = document.querySelector('.productView-img-container .media');
            console.log(mainImageContainer,'mainImageContainer');
            
           mainImageContainer.setAttribute('href',imageUrl) ;
            
            mainImageContainer.href = imageUrl;
            const mainImage = mainImageContainer.querySelector('img');
            if( imageUrl) {
              mainImage.src = imageUrl;
              mainImage.srcset = imageUrl;
            }else{
                const empty_img = 'https://cdn.shopify.com/s/files/1/0673/6094/8477/files/default_image.svg?v=1725886016';
                mainImage.src = empty_img;
                mainImage.srcset = empty_img;
            }
            
  
            updateThumbnails(selectedProduct);
  
            highlightVariant(imageUrl);
            highlightThumbnail(imageUrl);
            setSelectedVariant(variantId, imageUrl);
            SizeVariantcurrent(selectedProduct);
            //updatePrice(variantId);
            ColorMetafieldNames(ColorMetafieldName);
            Thumnailimg();
          }
        }).catch(error => {
          console.error('Error fetching products:', error);
        });
      } else if (event.target.closest('.productView-thumbnail-link')) {
        const thumbnailLink = event.target.closest('.productView-thumbnail-link');
        const imageUrl = thumbnailLink.getAttribute('data-image-url');
        const variantId = thumbnailLink.getAttribute('data-variant-id');
  
        console.log('Thumbnail clicked:', {
          thumbnailLink,
          imageUrl,
          variantId
        });
  
        const mainImageContainer = document.querySelector('.productView-img-container .media');
        mainImageContainer.href = imageUrl;
        mainImageContainer.setAttribute('href',imageUrl) ;
        console.log(mainImageContainer.getAttribute('href'),'mainImageContainer');
        const mainImage = mainImageContainer.querySelector('img');
           if( imageUrl) {
              mainImage.src = imageUrl;
              mainImage.srcset = imageUrl;
            }else{
                const empty_img = 'https://cdn.shopify.com/s/files/1/0673/6094/8477/files/default_image.svg?v=1725886016';
                mainImage.src = empty_img;
                mainImage.srcset = empty_img;
            }
  
        highlightThumbnail(imageUrl);
        // highlightVariant(imageUrl);
        setSelectedVariant(variantId, imageUrl);
        updatePrice(variantId);
        
      }
    });
  

   function Thumnailimg() {
        const thumbnailUrls = $('.productView-thumbnail-link').map(function () {
          return $(this).data('image-url');
        }).get();
        $('.productView-image img').each(function (index) {
          const newUrl = thumbnailUrls[index];
          console.log(newUrl, 'newUrl');     
          if (newUrl) {
            const media = $(this).closest('.media');
            media.attr('href', newUrl);
            $(this).attr('src', newUrl).attr('srcset', newUrl);
          }
        });
      }
  
    // Event listener for size variant change
    document.addEventListener('change', function(event) {
      console.log("change evt", event);
  
        const selector = $('.variant-selector.selected').attr("data-variants");
        const variants = ((typeof selector == 'string') ? JSON.parse(selector) :'');
        //   console.log("selector", variants);
      //   const variantId = variants[0].id.split('/').pop();
      //  const productId = variantId.split('/').pop();
        if (event.target.closest('input[name="Variant"]')) {
        // const variantInput = event.target.closest('input[name="Variant"]');
        // const variantId = variantInput.getAttribute('data-variant-id').split('/').pop();
        let fied = event.target.closest('fieldset');
        let radios = fied.querySelectorAll('input[type="radio"]');
        
        // Uncheck all radios in the fieldset
        radios.forEach(radio => {
            radio.removeAttribute('checked');
        });
        
        // Check the one that was clicked
       event.target.setAttribute('checked','true');
        
        console.log(fied, 'fied');

          
        const selector1 = $('.variant-selector.selected');
        const variants1 = JSON.parse($(selector1).attr('data-variants'));
        console.log("variants1", variants1);
         allVariants = variants1; // Populate allVariants here
          
              const variantInput = event.target.closest('input[name="Variant"]');
            
              const variantId = variantInput.getAttribute('data-variant-id').split('/').pop();
              const variantAvailable = variantInput.getAttribute('data-available-qty').split('/').pop();
              console.log('Size variant changed:', {
                variantInput,
                variantId,
                variantAvailable
              });  

                const available_product = variantAvailable;
          console.log(available_product,'available_product');
                const available_product_html = `<div class="productView-badge badge-right halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number><span class="badge sold-out-badge" aria-hidden="true">Uitverkocht</span></div>`;
                if(available_product == 'false'){
                  console.log("yesss product sold out");
                  $(".productView-image-wrapper").prepend(available_product_html);
                  $(".product-form__buttons .product-form__submit").attr("disabled", true);
                  $(".product-form__buttons .product-form__submit").removeAttr("id");
                  $(".product-form__buttons .product-form__submit").html("Uitverkocht");
                   $("quantity-input").addClass('disabled');
                }else if(available_product == 'true'){
                   console.log("yesss product not sold out");
                  $(".productView-badge .badge.sold-out-badge").html(" ");
                   $(".product-form__buttons .product-form__submit").removeAttr("disabled");
                   $(".product-form__buttons .product-form__submit").attr("id", "product-add-to-cart");
                  $("quantity-input").removeClass('disabled');
                   const labelToUpdate = document.querySelector(`.change_delivery[data-variant-id="${variantId}"]`);
             
                    if (labelToUpdate) {
                      labelToUpdate.classList.remove('soldout'); // Replace with the class you want to remove
                      console.log('evdfjdkljfkldjfieifhdlient.target---');
                    }

                }
          
              updatePrice(variantId);
              updateReceiptDate(variantId);
              changeFieldset(variantId);
              $('input[name="id"]').val(variantId); 
          
      } else if (event.target.matches('input[name="id"]')) {
        const variantId = event.target.value;
          console.log(variantId,'variantId');
        updatePromisedReceiptDate(variantId);
      }
    });
     console.log('ttttttttttttttttttttttttttinitialVariantId')
    const initialVariantId = document.querySelector('input[name="id"]:checked')?.value;
    if (initialVariantId) {
      console.log('initialVariantIdinitialVariantIdinitialVariantIdinitialVariantId')
      updatePromisedReceiptDate(initialVariantId);
    }
 // console.log('dlfkjjglkdjgdfklgjdflkgjdflkgdfjglkdfj',document.querySelector('.collection'))
 // console.log(document.querySelector('.collection').length ,  'lkdjflkjsdflkdsjflkdsjfdslkjfsdlkfjds')
    // Detect the type of page and initialize accordingly
    if (document.querySelector('.collection') && !document.querySelector('.template-search')) {
      console.log("innitionalization starterd beginn........")
      if(document.querySelector('.productListing')){
        document.querySelector('.productListing').style.display = "none";
      }
      // if(document.querySelector('.productListing li')){
      //    document.querySelector('.productListing li').style.display = "none";
      // }
      logEvent('Collection page detected');
      applyCardTitleStyles();
      initCollectionPage();
     
    } else if (document.querySelector('.productView')) {
      logEvent('Product page detected');
      applyCardTitleStyles();
      applyPriceStyles();
      initAvailableColors();
      FetchFirstProduct();  
    } else {
      logEvent('Not a collection or product page');
       
    }
    if (document.querySelector('.template-search')) {
      if(document.querySelector('.productListing')){
        document.querySelector('.productListing').style.display = "none";
      }
       applyCardTitleStyles();
       initSearchPage();
       console.log('this is a search page ');
    }
   console.log('lksdfjsdlkfjskljljkl jjlkjakljslkdjflk jjlkjklasjdlkfjsdklfjlk dsaj')
    initMegaMenuCollectionPage();
    initFeaturedCollectionPage();
  
    function handleLoadMoreClick(event) {
      
        if (event.target.classList.contains('button--secondary')) {
         
          setTimeout(function(){
           
            if (document.querySelector('.collection') && !document.querySelector('.template-search')) {
              initCollectionPage();
              }
            if (document.querySelector('.template-search')) {
              initSearchPage();
            }
            logEvent('loadmoreclick');
            console.log('load more button has been clicked')
            }, 1800);
        }
      }
    
      document.addEventListener('click', handleLoadMoreClick);
  
       
      $(document).on('click', 'img.color-swatch', function() {
        var $this = $(this);
        if ($this.data('sale') === 'yes') {
          if ($this.closest('.product').find('.saleLabel-cust').length  ==  0) {
            $this.closest('.product').find('.product-item-link').prepend('<span class="saleLabel-cust">Sale</span>');
          }
        }
         if($this.data('sale') === 'off'){
           $this.closest('.product').find('.saleLabel-cust').remove();
         }
      });
  
      const observerResult = new MutationObserver(function(mutations){
        mutations.forEach(function(mutation){
            mutation.addedNodes.forEach(function(addedNode){
              
                if(addedNode.className === 'results-count' && document.querySelector('.results-count .count')){
                    if (document.querySelector('.collection') && !document.querySelector('.template-search')) {
                      initCollectionPage();
                      
                    }
                    if (document.querySelector('.template-search')) {
                      initSearchPage();
                    }
                }
            })
        })
    })
    document.addEventListener('click', function(){
        observerResult.observe(document.body, {childList:true, subtree:true});
    })

         
    function debounceSearch(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }
    
    const searchInput = document.querySelector('predictive-search input[type="search"]');
     searchInput.addEventListener("focus", debounce(function () {
          $("[data-quick-trending-products]").addClass("is-show");
          $("[data-quick-trending-products]").removeClass("hidden");
     }, 300));
    
    searchInput.addEventListener("input", debounce(function () {
        const query = searchInput.value.trim();
        if (query.length > 0) {
             $(".halo-overlay-custom").show();
            fetchProductsSearchQuery(query);
            $(".total-search-query-products").show();
        } else {
            initFeaturedCollectionPage();
            $(".total-search-query-products").hide();
        }
    }, 300)); // 300ms debounce delay
 
   async function fetchProductsSearchQuery(query){
        const graphqlQuery = `
            {
                products(first: 250, query: "${query}") {
                  edges {
                      cursor
                      node {
                          id
                          title
                          handle
                          productType
                          vendor
                          createdAt
                          availableForSale
                          collections(first: 10) {
                              edges {
                                  node {
                                      title
                                  }
                              }
                          }
                          tags
                          images(first: 10) {
                              edges {
                                  node {
                                      transformedSrc
                                      originalSrc
                                  }
                              }
                          }
                          variants(first: 10) {
                              edges {
                                  node {
                                      id
                                      title
                                      priceV2 {
                                          amount
                                          currencyCode
                                      }
                                      compareAtPriceV2 {
                                          amount
                                          currencyCode
                                      }
                                      image {
                                          transformedSrc(maxWidth: 200, maxHeight: 200)
                                          originalSrc
                                      }
                                      selectedOptions {
                                          name
                                          value
                                      }
                                      metafield(namespace: "custom", key: "promisedreceiptdate1") {
                                          value
                                      }
                                      availableForSale
                                  }
                              }
                          }
                          collectionName: metafield(namespace: "custom", key: "collectionname") {
                              value
                          }
                          skuForSearch: metafield(namespace: "custom", key: "sku_for_search") {
                              value
                          }
                          seasonName: metafield(namespace: "custom", key: "seasonname") {
                              value
                          }
                          colorFamily: metafield(namespace: "custom", key: "colorfamily") {
                              value
                          }
                          modelNo: metafield(namespace: "custom", key: "modelno") {
                              value
                          }
                          stof: metafield(namespace: "custom", key: "stof") {
                              value
                          }
                          kleur: metafield(namespace: "custom", key: "kleur") {
                              value
                          }
                          merk: metafield(namespace: "custom", key: "merk") {
                              value
                          }
                          kenmerk: metafield(namespace: "custom", key: "kenmerk") {
                              value
                          }
                          metafield(namespace: "custom", key: "modelno") {
                              value
                          }
                      }
                  }
                  pageInfo {
                      hasNextPage
                  }
                }
            }
        `;

        fetch('https://alwero-nl.myshopify.com/api/2024-04/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'ae17f26e1cbd143df5a2e1cb38a8ce40'
            },
            body: JSON.stringify({ query: graphqlQuery })
        })
            .then(response => response.json())
            .then(data => {
                  console.log('Full Response Body data query:', data);
                  
  
                  const responseBody =  data;
                
                  console.log('Full Response Body:', responseBody);
  
                  if (responseBody.errors) {
                      console.error('GraphQL Errors:', responseBody.errors);
                      responseBody.errors.forEach(error => {
                          console.error('Error:', error.message);
                      });
                      return { products: [], hasNextPage: false };
                  }
  
                  const products = responseBody.data.products.edges.map(edge => edge.node);
                  const hasNextPage = responseBody.data.products.pageInfo.hasNextPage;
                  const lastCursor = responseBody.data.products.edges.length > 0
                      ? responseBody.data.products.edges[responseBody.data.products.edges.length - 1].cursor
                      : null;
                  groupAndDisplayProductsQuery(products)
              })
            .catch(error => {
                console.error('Error fetching products:', error);
            });
    }
  
  });
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  (function ($) {
    var $body = $("body"),
      $doc = $(document),
      $html = $("html"),
      $win = $(window);
  window.tts = halo;
    $doc.ready(() => {
      $doc.ajaxStart(() => {
        halo.isAjaxLoading = true;
      });
  
      $doc.ajaxStop(() => {
        halo.isAjaxLoading = false;
      });
  
      halo.ready();
    });
  
   document.addEventListener("DOMContentLoaded", function () {
    halo.init();
  });
  
    var halo = {
      haloTimeout: null,
      isAjaxLoading: false,
  
      ready: function () {
        this.loaderScript();
       // this.loaderProductBlock();
  
        if (
          navigator.userAgent.match(/OS X.*Safari/) &&
          !navigator.userAgent.match(/Chrome/)
        ) {
          document.body.classList.add("safari");
        } else {
          document.body.classList.add("chrome");
        }
  
        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS) document.body.classList.add("iOS");
  
        if ($body.hasClass("template-product")) {
          this.loaderRecommendationsBlock();
          this.scrollToReview();
        }
  
        if ($("[data-product-tab-block]").length) {
          this.clickedActiveProductTabs();
        }
  
        if ($body.hasClass("product-card-layout-07")) {
          this.calculateTranslateYHeight();
        }
  
        window.sharedFunctions = {
          setLocalStorageProductForWishlist:
            this.setLocalStorageProductForWishlist,
          checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
          productBlockSilder: this.productBlockSilder,
          productBlockScroller: this.productBlockScroller,
          calculateTranslateYHeight: this.calculateTranslateYHeight,
        };
        window.that = halo;
      },
  
      init: function () {
        window.tt = this;
        this.initMultiTab();
        this.initMultiTabMobile();
        this.productBlockInfiniteScroll();
        this.initGlobalCheckbox();
        this.initColorSwatch();
        this.initAddToCart();
        this.initQuickShop();
        this.initQuickCart();
        this.initNotifyInStock();
        this.initCompareProduct();
        this.initWishlist();
        this.initAskAnExpert();
        this.initHeader();
        this.headerLanguageCurrency();
        this.headerMasonry();
        this.initLiveChat();
        this.headerSidebarSearch();
        this.headerStickySearchForm();
        this.initCountdown();
        this.collectionCountdown();
        this.handleScrollDown();
        this.initVideoPopup();
        this.swapHoverVideoProductCard();
        this.initDynamicBrowserTabTitle();
        this.initWarningPopup();
        this.clickIconScrollSection();
        this.specialBanner();
        this.formMessage();
  
        if ($(".lookbook-carousel").length) {
          this.lookbookCarousel();
        }
  
        // Init Quick View
        if (window.quick_view.show || window.quick_view.show_mb) {
          this.initQuickView();
        }
  
        // Init Mobile Menu
        if (window.innerWidth < 1025) {
          this.menuSidebarMobile();
          this.menuSidebarMobileToggle();
        }
  
        // Check Lazyload Done
        const loadingImages = document.querySelectorAll(
          ".media--loading-effect img"
        );
        const productGrid = document.getElementById(
          "main-collection-product-grid"
        );
  
        if (loadingImages.length > 0 || productGrid) {
          this.initLazyloadObserver(loadingImages, productGrid);
        }
  
        if ($body.hasClass("show_effect_close")) {
          this.backgroundOverlayHoverEffect();
          this.backgroundOverlayHoverEffect1();
        }
  
        if (window.innerWidth > 1024) {
          this.productMenuSlider();
        }
  
        if ($body.hasClass("template-cart")) {
          this.updateGiftWrapper();
        }
  
        if ($body.hasClass("template-product")) {
          this.initProductView($(".halo-productView"));
          this.initProductBundle();
          this.articleGallery();
          this.toggleSidebarMobile();
          this.initCollapseSidebarBlock();
          this.initCategoryActive();
          this.initProductReviewSection();
          this.productCustomInformation();
          this.iconZoomClickMobile();
        }
  
        if (
          $body.hasClass("template-blog") ||
          $body.hasClass("template-article")
        ) {
          this.initCollapseSidebarBlock();
          this.initCategoryActive();
          this.toggleSidebarMobile();
          this.initBlogMasonry();
          this.productBlockSilderSidebar();
          this.productBlockSilderArticle();
        }
  
        if ($body.hasClass("template-article")) {
          this.articleGallery();
        }
  
        if (
          $body.hasClass("template-collection") ||
          $body.hasClass("template-search")
        ) {
          this.initCollapseSidebarBlock();
          this.initCategoryActive();
          this.toggleSidebarMobile();
          this.productBlockSilderSidebar();
          this.initInfiniteScrolling();
          this.initQuickShopProductList();
        }
  
        if ($body.hasClass("template-list-collections")) {
          this.toggleSidebarMobile();
          this.productBlockSilderSidebar();
        }
        if (
          $body.hasClass("template-collection") &&
          $(".collection-express-order").length
        ) {
          this.toggleVariantsForExpressOrder();
          this.initExpressOrderAddToCart();
        }
  
        halo.checkScrollLayoutForRecenlyViewed();
  
        let checkMenuMobile;
        window.innerWidth > 1024
          ? (checkMenuMobile = true)
          : (checkMenuMobile = false);
  
        $win.on("resize", () => {
          this.headerSidebarSearch();
          this.specialBanner();
          this.specialBannerSlider();
          if (window.innerWidth > 1024) {
            document.body.classList.remove("menu_open");
          } else if (checkMenuMobile) {
            checkMenuMobile = false;
            this.menuSidebarMobile();
            this.menuSidebarMobileToggle();
            this.initMultiTab();
            this.initMultiTabMobile();
          }
        });
      },
  
      checkNeedToConvertCurrency: function () {
        return (
          (window.show_multiple_currencies &&
            typeof Currency != "undefined" &&
            Currency.currentCurrency != shopCurrency) ||
          window.show_auto_currency
        );
      },
  
      loaderScript: function () {
        var load = function () {
          var script = $("[data-loader-script]");
  
          if (script.length > 0) {
            script.each((index, element) => {
              var $this = $(element),
                link = $this.data("loader-script"),
                top = element.getBoundingClientRect().top;
  
              if (!$this.hasClass("is-load")) {
                if (top < window.innerHeight + 100) {
                  halo.buildScript(link);
                  $('[data-loader-script="' + link + '"]').addClass("is-load");
                }
              }
            });
          }
        };
  
        load();
        window.addEventListener("scroll", load);
      },
  
      buildScript: function (name) {
        var loadScript = document.createElement("script");
        loadScript.src = name;
        document.body.appendChild(loadScript);
      },
  
      buildStyleSheet: function (name, $this) {
        if (name == "") return;
        const loadStyleSheet = document.createElement("link");
        loadStyleSheet.rel = "stylesheet";
        loadStyleSheet.type = "text/css";
        loadStyleSheet.href = name;
        $this.parentNode.insertBefore(loadStyleSheet, $this);
      },
  
      loaderProductBlock: function () {
        var isAjaxLoading = false;
  
        $doc.ajaxStart(() => {
          isAjaxLoading = true;
        });
  
        $doc.ajaxStop(() => {
          isAjaxLoading = false;
        });
  
        const handler = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const $block = $(entry.target);
              if ($block.hasClass("ajax-loaded")) return;
  
              var url = $block.data("collection"),
                layout = $block.data("layout"),
                limit = $block.data("limit"),
                image_ratio = $block.data("image-ratio"),
                swipe = $block.data("swipe"),
                sectionId = $block.attr("sectionId");
              hasCountdown = $block.attr("hasCountdown");
  
              if (url != null && url != undefined) {
                $.ajax({
                  type: "get",
                  url: window.routes.root + "/collections/" + url,
                  cache: false,
                  data: {
                    view: "ajax_product_block",
                    constraint:
                      "limit=" +
                      limit +
                      "+layout=" +
                      layout +
                      "+sectionId=" +
                      sectionId +
                      "+imageRatio=" +
                      image_ratio +
                      "+swipe=" +
                      swipe +
                      "+hasCountdown=" +
                      hasCountdown,
                  },
                  beforeSend: function () {
                    $block.addClass("ajax-loaded");
                  },
                  success: function (data) {
                    if (url != "") {
                      const res = halo.handleResponse($(data), 0, limit);
                      if (layout == "grid") {
                        $block.find(".products-grid").html(res);
                      } else if (layout == "slider") {
                        $block.find(".products-carousel").html(res);
                      } else if (layout == "scroll") {
                        $block.find(".products-flex").html(res);
                      }
                    }
                  },
                  complete: function () {
                    if (layout == "slider") {
                      halo.productBlockSilder($block);
                    }
  
                    if (layout == "scroll") {
                      const enableHover = $block
                        .find("[data-enable-hover]")
                        .attr("data-enable-hover");
                      if (enableHover === "true") {
                        halo.productBlockScroller($block);
                      }
                    }
  
                    if (
                      $block.hasClass("special-banner__product") &&
                      layout == "grid" &&
                      window.innerWidth < 1200
                    ) {
                      $block
                        .find(".special-banner__products--grid")
                        .addClass("products-carousel");
                      halo.productBlockSilder($block);
                    }
  
                    if (window.compare.show) {
                      var $compareLink = $("[data-compare-link]");
  
                      halo.setLocalStorageProductForCompare($compareLink);
                    }
  
                    halo.swapHoverVideoProductCard();
  
                    if (window.wishlist.show) {
                      halo.setLocalStorageProductForWishlist();
                    }
  
                    if (halo.checkNeedToConvertCurrency()) {
                      Currency.convertAll(
                        window.shop_currency,
                        $("#currencies .active").attr("data-currency"),
                        "span.money",
                        "money_format"
                      );
                    }
  
                    if (
                      window.review.show &&
                      $(".shopify-product-reviews-badge").length > 0 &&
                      window.SPR != null &&
                      typeof window.SPR.registerCallbacks === "functions"
                    ) {
                      return (
                        window.SPR.registerCallbacks(),
                        window.SPR.initRatingHandler(),
                        window.SPR.initDomEls(),
                        window.SPR.loadProducts(),
                        window.SPR.loadBadges()
                      );
                    }
                  },
                });
              } else {
                $block.addClass("ajax-loaded");
  
                if (layout == "slider") {
                  halo.productBlockSilder($block);
                }
  
                if (halo.checkNeedToConvertCurrency()) {
                  Currency.convertAll(
                    window.shop_currency,
                    $("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                  );
                }
              }
            }
          });
        };
  
        this.productBlock = document.querySelectorAll("[data-product-block]");
  
        const config = {
          threshold: 0.1,
        };
  
        this.observer = new IntersectionObserver(handler, config);
        this.productBlock.forEach((block) => {
          this.observer.observe(block);
        });
      },
  
      handleResponse($res, productToShow, limit) {
        $res = $res.splice(productToShow, limit);
        return $res;
      },
  
      loaderRecommendationsBlock: function () {
        halo.buildRecommendationBlock();
      },
  
      scrollToReview: function () {
        var $scope = $(".productView-tab");
  
        if ($scope.length) {
          $doc.on(
            "click",
            ".productView-details .halo-productReview",
            (event) => {
              event.preventDefault();
  
              $("body,html").animate(
                {
                  scrollTop: $scope.offset().top,
                },
                1000
              );
              var activeTab = $scope.find('[href="#tab-review"]');
              var activeTabCustom = $scope.find('[href="#tab-customer-reviews"]');
              var activeTabMb = $scope.find('[href="#tab-review-mobile"]');
              var activeTabCustomMb = $scope.find(
                '[href="#tab-customer-reviews-mobile"]'
              );
              if (
                !activeTab.hasClass("is-open") ||
                !activeTabMb.hasClass("is-open") ||
                !activeTabCustom.hasClass("is-open") ||
                !activeTabCustomMb.hasClass("is-open")
              ) {
                activeTab[0]?.click();
                activeTabMb[0]?.click();
                activeTabCustom[0]?.click();
                activeTabCustomMb[0]?.click();
              }
            }
          );
        }
      },
  
      headerMasonry: function () {
        $(".menu-dropdown__wrapper [data-masonry]").masonry({
          columnWidth: ".grid-sizer",
          itemSelector: "[data-gridItem]",
        });
      },
  
      initLiveChat: function () {
        var $item_globe = $(".live-wrapper-icon");
        $item_globe.on("click", function (e) {
          $(this).parent().toggleClass("live_help--active");
        });
  
        $body.on("click", function (e) {
          if (
            $(".live_help").hasClass("live_help--active") &&
            $(event.target).closest(".live_help").length === 0
          ) {
            e.preventDefault();
            $(".live_help").removeClass("live_help--active");
          }
        });
      },
  
      initHeader: function () {
        const headerAll = document.querySelectorAll('[class*="section-header"]');
        if (headerAll) {
          let index = headerAll.length + 20;
          headerAll.forEach((element) => {
            if (element.classList.contains("section-header-mobile")) return;
            element.setAttribute("data-index", index);
            element.style.zIndex = index;
            index--;
          });
  
          const headerBasicTransparent = document.querySelector(
            ".header-basic--transparent"
          );
          if (
            headerBasicTransparent &&
            document.body.classList.contains("template-index")
          ) {
            const height = headerBasicTransparent.offsetHeight,
              navTransparent = document.querySelector(
                '.header-navigation[class*="--transparent"]'
              );
            if (navTransparent) {
              navTransparent.style.top = `${height}px`;
              navTransparent.classList.add("has-top");
            }
          }
        }
      },
  
      headerLanguageCurrency: function () {
        if (!document.querySelector(".header-language_currency")) return;
        const header = document.querySelectorAll('[class*="section-header-"]');
  
        document.addEventListener("click", (event) => {
          const $target = event.target;
          const $headerLanguageCurrency = $target.closest(
            ".header-language_currency"
          );
          const languageCurrency = $headerLanguageCurrency?.querySelector(
            ".top-language-currency"
          );
          const dropdownCurrency =
            $headerLanguageCurrency?.querySelector(".dropdown-currency");
          const dropdownLanguage =
            $headerLanguageCurrency?.querySelector(".dropdown-language");
  
          if (
            $target.matches(".header-language_currency") ||
            $target.closest(".header-language_currency")
          ) {
            if (
              $target.matches(".icon-languageCurrency") ||
              $target.closest(".icon-languageCurrency")
            ) {
              languageCurrency?.classList.toggle("show");
            } else if (
              ($target.matches(".top-language-currency") ||
                $target.closest(".top-language-currency")) &&
              !document.querySelector(".icon-languageCurrency")
            ) {
              languageCurrency?.classList.toggle("show");
            }
  
            if (
              $target.matches(".halo-top-currency") ||
              $target.closest(".halo-top-currency")
            ) {
              dropdownLanguage?.classList.remove("show");
              dropdownCurrency?.classList.toggle("show");
            }
  
            if (
              $target.matches(".halo-top-language") ||
              $target.closest(".halo-top-language")
            ) {
              dropdownCurrency?.classList.remove("show");
              dropdownLanguage?.classList.toggle("show");
            }
  
            if ($target.matches(".dropdown-menu .dropdown-item")) {
              dropdownCurrency?.classList.remove("show");
              dropdownLanguage?.classList.remove("show");
            }
          } else {
            header.forEach((element) => {
              element
                .querySelector(".top-language-currency")
                ?.classList.remove("show");
              element
                .querySelector(".dropdown-currency")
                ?.classList.remove("show");
              element
                .querySelector(".dropdown-language")
                ?.classList.remove("show");
            });
          }
        });
      },
  
      headerSidebarSearch: function () {
        var headerSearchPC = $(".header-top .header__search .search_details"),
          headerSearchMB = $(
            "#search-form-mobile .halo-sidebar-wrapper .search_details"
          ),
          headerwraperSearchPC = $(".header-top .header__search"),
          headerwraperSearchMB = $("#search-form-mobile .halo-sidebar-wrapper"),
          searchDetails = $(".search_details"),
          predictiveSearchPC = $(".header-top .header__search predictive-search"),
          predictiveSearchMB = $(
            "#search-form-mobile .halo-sidebar-wrapper predictive-search"
          );
  
        if (predictiveSearchPC.length === 0)
          predictiveSearchPC = $(".header-top .header__search .search_details");
        if (predictiveSearchMB.length === 0)
          predictiveSearchMB = $(
            "#search-form-mobile .halo-sidebar-wrapper .search_details"
          );
        if (window.innerWidth < 1025) {
          if ($(".header").hasClass("header-01")) {
            predictiveSearchPC.appendTo(headerwraperSearchMB);
          }
          console.log('searchDetails: ',searchDetails);
          searchDetails.attr("open", "true");
          $("[data-search-mobile]").on("click", (event) => {
            event.preventDefault();
            $("body").addClass("open_search_mobile");
          });
          $("[data-search-close-sidebar], .background-overlay").on(
            "click",
            (event) => {
              event.preventDefault();
              $("body").removeClass("open_search_mobile");
            }
            
          );
        } else {
          if ($(".header").hasClass("header-01")) {
            predictiveSearchMB.appendTo(headerwraperSearchPC);
          }
          searchDetails.removeAttr("open");
  
          $(".search-modal__close-button").on("click", (event) => {
            $(".search_details").removeAttr("open");
            $("body").removeClass("open_search_menu");
          });
  
          // Click Search Icon On Header Nav And Sticky Menu
          $("[data-search-menu]").on("click", (event) => {
            event.preventDefault();
            $("body").addClass("open_search_menu");
          });
        }
      },
  
      headerStickySearchForm: function () {
        var iconSearchSlt = "[data-search-sticky-form]";
        var iconSearchMenu = "[data-search-menu-sticky-form] .icon-search";
        var iconSearchMenuCustom =
          "[data-search-menu-sticky-form] .icon-search-custom";
  
        if ($(window).width() > 1025) {
          $(document)
            .off("click.toggleSearch", iconSearchSlt)
            .on("click.toggleSearch", iconSearchSlt, function (event) {
              event.preventDefault();
              event.stopPropagation();
              $("body").addClass("sticky-search-open");
              console.log('from 655')
              $(".search_details").attr("open", "true");
            });
  
          $(document)
            .off("click.hideSearch")
            .on("click.hideSearch", function (event) {
              var formSearch = $(".search-modal__form"),
                quickSearch = $(".quickSearchResultsWrap");
              if (
                $("body").hasClass("sticky-search-open") &&
                !formSearch.has(event.target).length &&
                !quickSearch.has(event.target).length
              ) {
                $("body").removeClass("sticky-search-open");
                $('[class*="section-header-"]').removeClass(
                  "sticky-search-menu-open"
                );
                $(".search_details").removeAttr("open");
              }
            });
  
          // Click Search Icon On Header Nav And Sticky Menu
          $(document)
            .off("click.toggleSearch", iconSearchMenu)
            .on("click.toggleSearch", iconSearchMenu, function (event) {
              event.preventDefault();
              event.stopPropagation();
              $(event.target)
                .closest('[class*="section-header-"]')
                .addClass("sticky-search-menu-open");
              $(event.target)
                .closest(".section-header-navigation")
                .css("z-index", "101");
              console.log('from 689 line')
              $(".search_details").attr("open", "true");
            });
  
          // Click Search Icon On Header Hamburger - Search Dropdown Style Layout Custom
          $(document)
            .off("click.toggleSearch", iconSearchMenuCustom)
            .on("click.toggleSearch", iconSearchMenuCustom, function (event) {
              $(event.target)
                .closest('[class*="section-header-"]')
                .addClass("sticky-search-menu-custom-open");
            });
  
          $(document)
            .off("click.hideSearchSticky")
            .on("click.hideSearchSticky", function (event) {
              var formSearch = $(".header-navigation .search-modal__form"),
                quickSearch = $(".header-navigation .quickSearchResultsWrap");
              if (
                $('[class*="section-header-"]').hasClass(
                  "sticky-search-menu-open"
                ) &&
                !formSearch.has(event.target).length &&
                !quickSearch.has(event.target).length
              ) {
                const header = $(iconSearchMenu).closest(
                  ".section-header-navigation"
                );
                const index = header.data("index");
  
                $('[class*="section-header-"]').removeClass(
                  "sticky-search-menu-open"
                );
  
                header.css("z-index", index);
                $(".header-navigation .search_details").removeAttr("open");
                if (quickSearch.hasClass("is-show")) {
                  quickSearch.removeClass("is-show").addClass("hidden");
                }
              }
              if (
                $(event.target).closest(".search-modal__content").length === 0
              ) {
                $("body").removeClass("open_search_menu");
                $('[class*="section-header-"]').removeClass(
                  "sticky-search-menu-custom-open"
                );
              }
            });
        }
      },
  
      menuSidebarMobile: function () {
        var buttonIconOpen = $(".mobileMenu-toggle"),
          buttonClose = $(".halo-sidebar-close, .background-overlay");
  
        buttonIconOpen
          .off("click.toggleCurrencyLanguage")
          .on("click.toggleCurrencyLanguage", (event) => {
            event.preventDefault();
            $body.addClass("menu_open");
            if (window.mobile_menu == "default") {
              if (
                !$("#navigation-mobile .site-nav-mobile.nav .header__inline-menu")
                  .length
              ) {
                $(".header .header__inline-menu").appendTo(
                  "#navigation-mobile .site-nav-mobile.nav"
                );
              }
            }
            if (
              !$(
                "#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text"
              ).length
            ) {
              $(
                ".header-top--wrapper .header-top--right .free-shipping-text"
              ).appendTo(
                "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
              );
            }
            if (
              !$(
                "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
              ).length
            ) {
              $(
                ".header-top--wrapper .header-top--right .customer-service-text"
              ).appendTo(
                "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
              );
            }
            if (
              !$(
                "#navigation-mobile .site-nav-mobile.nav-account .header__location"
              ).length
            ) {
              $(
                ".header-top--wrapper .header-top--right .header__location"
              ).appendTo(
                "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
              );
            }
            if (!$("#navigation-mobile .top-language-currency").length) {
              if ($(".header").hasClass("header-03")) {
                $(".header .header-bottom-right .top-language-currency").appendTo(
                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                );
              } else if ($(".header").hasClass("header-05")) {
                $(".header .header-top--left .top-language-currency").appendTo(
                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                );
              } else {
                $(
                  ".header .header-language_currency .top-language-currency"
                ).appendTo(
                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                );
              }
            }
            halo.productMenuSlider();
          });
  
        buttonClose
          .off("click.toggleCloseCurrencyLanguage")
          .on("click.toggleCloseCurrencyLanguage", () => {
            $body.removeClass("menu_open");
            $("#navigation-mobile")
              .off("transitionend.toggleCloseMenu")
              .on("transitionend.toggleCloseMenu", () => {
                if (!$body.hasClass("menu_open")) {
                  if (!$(".header .header__inline-menu").length) {
                    if (
                      $(".header").hasClass("header-03") ||
                      $(".header").hasClass("header-04") ||
                      $(".header").hasClass("header-07") ||
                      $(".header").hasClass("header-08")
                    ) {
                      $(
                        "#navigation-mobile .site-nav-mobile.nav .header__inline-menu"
                      ).appendTo(
                        ".header .header-bottom--wrapper .header-bottom-left"
                      );
                    } else {
                      $(
                        "#navigation-mobile .site-nav-mobile.nav .header__inline-menu"
                      ).appendTo(".header .header-bottom--wrapper");
                    }
                  }
                  if (
                    !$(
                      ".header-top--wrapper .header-top--right .free-shipping-text"
                    ).length
                  ) {
                    if (!$(".header-04").hasClass("style_2")) {
                      $(
                        "#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text"
                      ).insertBefore(
                        ".header-top--wrapper .header-top--right .header__group"
                      );
                    }
                  }
                  if (
                    !$(
                      ".header-top--wrapper .header-top--right .header__location"
                    ).length
                  ) {
                    $(
                      "#navigation-mobile .site-nav-mobile.nav-account .header__location"
                    ).insertBefore(
                      ".header-top--wrapper .header-top--right .header__group"
                    );
                  }
                  if (
                    !$(
                      ".header-top--wrapper .header-top--right .customer-service-text"
                    ).length
                  ) {
                    if ($(".header").hasClass("header-03")) {
                      $(
                        "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
                      ).insertBefore(
                        ".header-top--wrapper .header-top--right .header__group .header__icon--wishlist"
                      );
                    } else {
                      $(
                        "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
                      ).insertBefore(
                        ".header-top--wrapper .header-top--right .top-language-currency"
                      );
                    }
                  }
                  if (
                    !$(".header-language_currency .top-language-currency").length
                  ) {
                    if ($(".header").hasClass("header-03")) {
                      $(
                        "#navigation-mobile .site-nav-mobile .top-language-currency"
                      ).appendTo(
                        ".header .header-bottom--wrapper .header-bottom-right .header-language_currency"
                      );
                    } else if ($(".header").hasClass("header-04")) {
                      $(
                        "#navigation-mobile .site-nav-mobile .top-language-currency"
                      ).appendTo(
                        ".header .header-bottom--wrapper .header-bottom-right .header-language_currency"
                      );
                    } else if ($(".header").hasClass("header-05")) {
                      $(
                        "#navigation-mobile .site-nav-mobile .top-language-currency"
                      ).appendTo(
                        ".header .header-top--wrapper .header-top--left .header-language_currency"
                      );
                    } else {
                      $(
                        "#navigation-mobile .site-nav-mobile .top-language-currency"
                      ).insertBefore(
                        ".header .header-language_currency .header__search"
                      );
                    }
                  }
                }
              });
          });
  
        $doc.on("click", ".halo-sidebar-close", function (e) {
          e.preventDefault();
          e.stopPropagation();
          $body.removeClass("menu_open");
        });
      },
  
      menuSidebarMobileToggle: function () {
        $body.on(
          "click",
          ".site-nav-mobile .list-menu .menu_mobile_link",
          function (e) {
            if (!e.currentTarget.classList.contains("list-menu__item--end")) {
              e.preventDefault();
              e.stopPropagation();
              var $target = $(this);
              var $parent = $target.parent();
              var $menuDislosure1 = $target
                .parent()
                .find("ul.list-menu--disclosure-1");
  
              $parent
                .removeClass("is-hidden")
                .addClass("is-open")
                .removeClass("d-none");
              $menuDislosure1
                .off("transitionend.toggleMenuLink1")
                .on("transitionend.toggleMenuLink1", () => {
                  if (
                    $parent.hasClass("is-open") &&
                    !$parent.hasClass("is-hidden") &&
                    !$parent.hasClass("d-none")
                  ) {
                    // $parent.addClass('d-none')
                    $parent
                      .siblings()
                      .removeClass("is-open")
                      .addClass("is-hidden")
                      .removeClass("d-none");
                  }
                });
  
              // $target.parent().siblings().removeClass('is-open').addClass('is-hidden');
              // $target.parent().removeClass('is-hidden').addClass('is-open');
            }
          }
        );
  
        $body.on(
          "click",
          ".site-nav-mobile .list-menu .menu_mobile_link_2",
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $target = $(this);
            var $target = $(this);
            var $parent = $target.parent().parent();
            var $menuDislosure2 = $target
              .parent()
              .find("ul.list-menu--disclosure-2");
            var $parentToScroll = $target
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .parent();
  
            $parent
              .removeClass("is-hidden")
              .addClass("is-open")
              .removeClass("d-none");
            $menuDislosure2
              .off("transitionend.toggleMenuLink2")
              .on("transitionend.toggleMenuLink2", () => {
                if (
                  $parent.hasClass("is-open") &&
                  !$parent.hasClass("is-hidden") &&
                  !$parent.hasClass("d-none")
                ) {
                  $parent.addClass("d-none");
                  $parent
                    .siblings()
                    .removeClass("is-open")
                    .addClass("is-hidden")
                    .removeClass("d-none");
                  $parentToScroll.animate(
                    {
                      scrollTop: 0,
                    },
                    0
                  );
                }
              });
  
            // if($('.header').hasClass('header-04') || $('.header').hasClass('header-01') || $('.header').hasClass('header-02')){
            // $target.parent().parent().siblings().removeClass('is-open').addClass('is-hidden');
            // $target.parent().parent().removeClass('is-hidden').addClass('is-open');
            // $target.parent().parent().parent().parent().parent().parent().animate({
            //     scrollTop: 0
            // }, 0);
            // } else{
            //     $target.parents('.site-nav').siblings().removeClass('is-open').addClass('is-hidden');
            //     $target.parents('.site-nav').removeClass('is-hidden').addClass('is-open');
            //     $target.parents('.menu-dropdown__wrapper').animate({
            //         scrollTop: 0
            //     }, 0);
            // }
  
            if (
              $(".menu-dropdown").hasClass("megamenu_style_4") ||
              $(".menu-dropdown").hasClass("megamenu_style_1")
            ) {
              $target.parents(".menu-dropdown").animate(
                {
                  scrollTop: 0,
                },
                0
              );
            }
  
            $target.parents(".menu-dropdown").addClass("is-overflow");
          }
        );
  
        $body.on("click", ".nav-title-mobile", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var $target = $(this),
            $parentLv1 = $target.parent().parent().parent().parent(".is-open"),
            $parentLv2 = $target.parent().parent().parent(".is-open"),
            $parentLv3 = $target.parent().parent(".is-open");
  
          $parentLv1.siblings().removeClass("is-hidden");
          $parentLv1.removeClass("is-open").removeClass("d-none");
          $parentLv2.siblings().removeClass("is-hidden");
          $parentLv2.removeClass("is-open").removeClass("d-none");
          $parentLv3.siblings().removeClass("is-hidden");
          $parentLv3.removeClass("is-open").removeClass("d-none");
          $(".menu-dropdown").removeClass("is-overflow");
        });
  
        if (window.mobile_menu != "default") {
          $doc.on("click", "[data-mobile-menu-tab]", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            var tabItem = event.currentTarget.closest("li"),
              tabTarget = event.currentTarget.dataset.target;
  
            if (!tabItem.classList.contains("is-active")) {
              document
                .querySelector("[data-navigation-tab-mobile]")
                .querySelectorAll("li")
                .forEach((element) => {
                  if (element != tabItem) {
                    element.classList.remove("is-active");
                  } else {
                    element.classList.add("is-active");
  
                    document
                      .querySelectorAll('[id^="MenuMobileListSection-"]')
                      .forEach((tab) => {
                        if (tab.getAttribute("id") == tabTarget) {
                          tab.classList.remove("is-hidden");
                          tab.classList.add("is-visible");
                        } else {
                          tab.classList.remove("is-visible");
                          tab.classList.add("is-hidden");
                        }
                      });
                  }
                });
            }
          });
        }
      },
  
      setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
  
      initMultiTab: function () {
        let designMode;
        document.body.matches(".shopify-design-mode")
          ? (designMode = true)
          : (designMode = false);
  
        if ($("[data-menu-tab]").length > 0) {
          $doc.on("click", "[data-menu-tab] li", (event) => {
            var active = $(event.currentTarget).data("load-page"),
              href = $(event.currentTarget).attr("href");
  
            $.cookie("page-url", active, {
              expires: 1,
              path: "/",
            });
          });
  
          var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;
  
          if (
            window.location.pathname.indexOf("/pages/") !== -1 &&
            window.page_active &&
            window.page_active != pageUrl
          ) {
            this.setCookie("page-url", window.page_active, 1);
            pageUrl = window.page_active;
          }
  
          if (pageUrl != null) {
            menuTabItem = $(`[data-load-page="${pageUrl}"]`);
            logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
            menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
          } else {
            menuTabItem = $("[data-load-page].is-active");
            logoTabItem = $("[data-load-logo-page].first");
            menuItem = $("[data-load-menu-page].is-active");
          }
  
          var menuTab = menuTabItem.closest("[data-menu-tab]");
  
          menuTab
            .find("[data-load-page]")
            .not(menuTabItem)
            .removeClass("is-active");
          logoTabItem.siblings().removeClass("is-active");
          menuItem.siblings().removeClass("is-active");
          if (pageUrl != "") {
            logoTabItem.addClass("is-active");
            menuTabItem.addClass("is-active");
            menuItem.addClass("is-active");
          } else {
            $("[data-load-page]:nth-child(1)").addClass("is-active");
            $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
            $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
          }
  
          const header = menuTabItem.closest(".header");
          if (header && window.innerWidth < 1025) {
            const logoMobile = $(".header-mobile .header__heading-link");
            const logDesktop = header.find(".header__heading-link.is-active");
  
            if (logDesktop.data("logo-mobile") == undefined) {
              logoMobile.find("img").addClass("logo-show");
              return;
            } else {
              logoMobile.html(
                `<img src="${logDesktop.data(
                  "logo-mobile"
                )}" alt="${logDesktop.data(
                  "logo-mobile-alt"
                )}" style="max-width: ${logoMobile.data(
                  "logo-width"
                )}px; height: auto"/>`
              );
              logoMobile.find("img").addClass("logo-show");
            }
          }
  
          var active = $("[data-menu-tab] li.is-active").data("load-page"),
            check = false,
            url =
              window.routes.root +
              `/search?type=product&q=${active}&view=ajax_mega_menu`;
  
          if ($body.hasClass("template-index")) {
            console.log('00000000000000000000')
            if ($win.width() < 1025) {
              if (window.mobile_menu == "default") {
                window.addEventListener(
                  "load",
                  () => {
                    if (designMode) {
                      if (check == false) {
                        check = true;
                        halo.initMobileMenuDefault(url);
                      }
                    } else {
                      document.body.addEventListener(
                        "click",
                        () => {
                          if (check == false) {
                            check = true;
                            halo.initMobileMenuDefault(url);
                          }
                        },
                        false
                      );
                    }
                  },
                  false
                );
              } else {
                window.addEventListener(
                  "load",
                  () => {
                    if (designMode) {
                      if (check == false) {
                        check = true;
                        halo.initMultiTabMobile();
                      }
                    } else {
                      document.body.addEventListener(
                        "click",
                        () => {
                          if (check == false) {
                            check = true;
                            halo.initMultiTabMobile();
                          }
                        },
                        false
                      );
                    }
                  },
                  false
                );
              }
            }
          } else {
            console.log('888888888888888888888888888')
            if ($win.width() < 1025) {
              if (window.mobile_menu == "default") {
                window.addEventListener(
                  "load",
                  () => {
                    if (designMode) {
                      if (check == false) {
                        check = true;
                        halo.initMobileMenuDefault(url);
                      }
                    } else {
                      document.body.addEventListener(
                        "click",
                        () => {
                          if (check == false) {
                            check = true;
                            halo.initMobileMenuDefault(url);
                          }
                        },
                        false
                      );
                    }
                  },
                  false
                );
              } else {
                window.addEventListener(
                  "load",
                  () => {
                    if (designMode) {
                      if (check == false) {
                        check = true;
                        halo.initMultiTabMobile();
                      }
                    } else {
                      document.body.addEventListener(
                        "click",
                        () => {
                          if (check == false) {
                            check = true;
                            halo.initMultiTabMobile();
                          }
                        },
                        false
                      );
                    }
                  },
                  false
                );
              }
            }
          }
        } else {
          var check = false,
            url = window.routes.root + "/search?view=ajax_mega_menu";
  console.log('444444444444444444444444')
          if ($win.width() < 1025) {
            if (window.mobile_menu == "default") {
              if (designMode) {
                if (check == false) {
                  check = true;
                  halo.initMobileMenuDefault(url);
                }
              } else {
                document.body.addEventListener(
                  "click",
                  () => {
                    if (check == false) {
                      check = true;
                      halo.initMobileMenuDefault(url);
                    }
                  },
                  false
                );
              }
            } else {
              window.addEventListener(
                "load",
                () => {
                  if (designMode) {
                    if (check == false) {
                      check = true;
                      halo.initMultiTabMobile();
                    }
                  } else {
                    document.body.addEventListener(
                      "click",
                      () => {
                        if (check == false) {
                          check = true;
                          halo.initMultiTabMobile();
                        }
                      },
                      false
                    );
                  }
                },
                false
              );
            }
          }
        }
      },
  
      initMobileMenuDefault: function (url) {
        const menuMobile = $("[data-navigation-mobile]");
        const nav = $("#HeaderNavigation [data-navigation]");
        const style =
          nav.attr("style") != undefined
            ? nav.attr("style")
            : nav.closest("#HeaderNavigation").attr("style");
        menuMobile.append(
          `<nav class="header__inline-menu" data-navigation role="navigation" style="${
            style != undefined ? style : ""
          }">${nav.html() != undefined ? nav.html() : ""}</nav>`
        );
  
        const topLanCur = $(".top-language-currency");
        const lanCurMobile = $("#navigation-mobile .nav-currency-language");
        if (lanCurMobile.text().trim() == "" && topLanCur.length > 0)
          lanCurMobile.append(
            `<div class="top-language-currency">${topLanCur.html()}</div>`
          );
      },
  
      initMultiTabMobile: function () {
        console.log('5555555555555555555')
        if ($win.width() < 1025) {
          if (window.mobile_menu == "custom") {
            var chk = false,
              menuElement = $('[data-section-type="menu"]'),
              menuMobile = $("[data-navigation-mobile]"),
              menuTabMobile = $("[data-navigation-tab-mobile]");
  
            document.body.addEventListener(
              "click",
              () => {
                if (chk == false) {
                  chk = true;
                  const content = document.createElement("div");
                  const tab = document.createElement("ul");
  
                  Object.assign(tab, {
                    className: "menu-tab list-unstyled",
                  });
  
                  tab.setAttribute("role", "menu");
  
                  menuElement.each((index, element) => {
                    var currentMenu = element
                      .querySelector("template")
                      .content.firstElementChild.cloneNode(true);
  
                    if (index == 0) {
                      currentMenu.classList.add("is-visible");
                    } else {
                      currentMenu.classList.add("is-hidden");
                    }
  
                    content.appendChild(currentMenu);
                  });
  
                  content
                    .querySelectorAll('[id^="MenuMobileListSection-"]')
                    .forEach((element, index) => {
                      var tabTitle = element.dataset.heading,
                        tabId = element.getAttribute("id"),
                        tabElement = document.createElement("li");
  
                      Object.assign(tabElement, {
                        className: "item",
                      });
  
                      tabElement.setAttribute("role", "menuitem");
  
                      if (index == 0) {
                        tabElement.classList.add("is-active");
                      }
  
                      tabElement.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${tabId}">${tabTitle}</a>`;
  
                      tab.appendChild(tabElement);
                    });
  
                  menuTabMobile.html(tab);
                  menuMobile.html(content.innerHTML);
                }
              },
              false
            );
          }
        }
      },
  
      initMenu: function (url) {
        if (!$(".header").hasClass("header-04")) {
          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const navigation = html.querySelector("#HeaderNavigation");
              if (navigation && navigation.innerHTML.trim().length) {
                document.querySelector("#HeaderNavigation").innerHTML =
                  navigation.innerHTML;
              }
            })
            .catch((e) => {
              console.error(e);
            });
        }
      },
  
      clickedActiveProductTabs: function () {
        const handler = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const $block = $(entry.target);
              if ($block.hasClass("ajax-loaded")) return;
  
              var listTabs = $block.find(".list-product-tabs"),
                tabLink = listTabs.find("[data-product-tabTop]"),
                tabContent = $block.find("[data-product-TabContent]"),
                limit = $block.data("limit");
  
              var linkActive = listTabs.find(".tab-links.active"),
                activeTab = $block.find(
                  ".product-tabs-content .tab-content.active"
                );
  
              if (!$block.hasClass("ajax-loaded")) {
                halo.doAjaxProductTabs(
                  linkActive.data("href"),
                  activeTab.find(".loading"),
                  activeTab.find(".products-load"),
                  $block.attr("sectionid"),
                  limit,
                  $block
                );
              }
  
              tabLink.off("click").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
  
                if (!$(this).hasClass("active")) {
                  const curTab = $(this),
                    curTabContent = $(curTab.data("target"));
  
                  tabLink.removeClass("active");
                  tabContent.removeClass("active");
  
                  if (!curTabContent.hasClass("loaded"))
                    halo.doAjaxProductTabs(
                      curTab.data("href"),
                      curTabContent.find(".loading"),
                      curTabContent.find(".products-load"),
                      $block.attr("sectionid"),
                      limit
                    );
  
                  curTab.addClass("active");
                  curTabContent.addClass("active");
                  curTabContent.find(".slick-slider").slick("refresh");
                }
              });
            }
          });
        };
  
        this.productBlock = document.querySelectorAll("[data-product-tab-block]");
  
        const config = {
          threshold: 0.1,
        };
  
        this.observer = new IntersectionObserver(handler, config);
        this.productBlock.forEach((block) => {
          this.observer.observe(block);
        });
      },
  
      doAjaxProductTabs: function (
        handle,
        loadingElm,
        curTabContent,
        sectionId,
        limit,
        self
      ) {
        $.ajax({
          type: "get",
          url: handle,
          data: {
            constraint: `sectionId=${handle}+limit=${limit}`,
          },
  
          beforeSend: function () {
            if (self != undefined) self.addClass("ajax-loaded");
          },
  
          success: function (data) {
            curTabContent.parent().addClass("loaded");
            if (handle == "?view=ajax_product_block") return;
  
            if ($(data).text().trim() === "") {
              noProduct(curTabContent);
            } else {
              const res = halo.handleResponse($(data), 0, limit);
              curTabContent.html(res);
  
              if (window.wishlist.show) {
                halo.setLocalStorageProductForWishlist();
              }
  
              if (halo.checkNeedToConvertCurrency()) {
                Currency.convertAll(
                  window.shop_currency,
                  $("#currencies .active").attr("data-currency"),
                  "span.money",
                  "money_format"
                );
              }
            }
          },
          complete: function () {
            if (curTabContent.hasClass("products-carousel")) {
              halo.productBlockSilder(curTabContent.parent());
            } else if (
              curTabContent.hasClass("products-cursor") &&
              curTabContent.data("enable-hover") === "true"
            ) {
              halo.productBlockScroller(curTabContent);
            }
  
            if (
              window.review.show &&
              $(".shopify-product-reviews-badge").length > 0 &&
              window.SPR != null &&
              typeof window.SPR.registerCallbacks === "functions"
            ) {
              return (
                window.SPR.registerCallbacks(),
                window.SPR.initRatingHandler(),
                window.SPR.initDomEls(),
                window.SPR.loadProducts(),
                window.SPR.loadBadges()
              );
            }
          },
          error: function (xhr, text) {
            noProduct(curTabContent);
          },
        });
  
        const noProduct = (curTabContent) => {
          curTabContent.html(
            `<p class="loading center">Sorry, there are no products in this collection</p>`
          );
        };
      },
      lookbookCarousel: function () {
        var lookbookCarousel = $(".lookbook-carousel"),
          itemToShow = lookbookCarousel.data("item-to-show"),
          itemDots = lookbookCarousel.data("item-dots"),
          itemDotsMb = lookbookCarousel.data("item-dots-mb"),
          itemArrows = lookbookCarousel.data("item-arrows"),
          itemArrowsMb = lookbookCarousel.data("item-arrows-mb");
  
        if (lookbookCarousel.length > 0) {
          console.log('hthis is the lcarasule 1111')
          if (lookbookCarousel.not(".slick-initialized")) {
            lookbookCarousel.slick({
              mobileFirst: true,
              adaptiveHeight: true,
              vertical: false,
              infinite: true,
              slidesToShow: itemToShow,
              slidesToScroll: itemToShow,
              arrows: itemArrowsMb,
              dots: itemDotsMb,
              autoplay: false,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                  },
                },
              ],
            });
          }
        }
  
        if (lookbookCarousel.hasClass("enable_counter_number")) {
          var slickNext = lookbookCarousel.find(".slick-next");
               console.log('hthis is the lcarasule 22222')
          lookbookCarousel
            .closest(".special-banner__item--lookbook_banner")
            .find(".products-counter-number")
            .appendTo(slickNext);
          lookbookCarousel.on("afterChange", (event) => {
            var slickIndex = lookbookCarousel
              .find(".slick-current")
              .data("slick-index");
            lookbookCarousel.find("#count-image").text(slickIndex + 1);
          });
        }
      },
      productBlockSilder: function (wrapper) {
        var productGrid = wrapper.find(".products-carousel"),
          itemToShow = productGrid.data("item-to-show"),
          itemDots = productGrid.data("item-dots"),
          itemDotsMb = productGrid.data("item-dots-mb"),
          itemArrows = productGrid.data("item-arrows"),
          itemArrowsMb = productGrid.data("item-arrows-mb"),
          isProductCard06 = document.body.classList.contains(
            "product-card-layout-06"
          );
  
        if (productGrid.length > 0) {
               console.log('hthis is the lcarasule 33333')
          if (productGrid.hasClass("slick-initialized")) return;
          if (productGrid.not(".slick-initialized")) {
            if (isProductCard06) {
              productGrid.on("init", () => {
                const selectOptionsHeight = productGrid
                  .find(".product .card-action")
                  .eq(0)
                  .height();
                productGrid
                  .find(".slick-list")
                  .css("padding-bottom", selectOptionsHeight + "px");
                productGrid.attr(
                  "data-slider-padding-bottom",
                  selectOptionsHeight
                );
              });
            }
  
            if (productGrid.hasClass("enable_progress_bar")) {
                   console.log('hthis is the lcarasule 44444')
              var progressBar = wrapper.find(".scrollbar-thumb");
              productGrid.on("init", (event, slick) => {
                var percent =
                  (slick.currentSlide / (slick.slideCount - 1)) * 100 + "%";
                progressBar.css("--percent", percent);
              });
            }
  
            productGrid.slick({
              mobileFirst: true,
              adaptiveHeight: true,
              vertical: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: itemArrowsMb,
              dots: itemDotsMb,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1599,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                    get slidesToShow() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== ""
                      ) {
                        return (this.slidesToShow = itemToShow);
                      } else {
                        return (this.slidesToShow = 1);
                      }
                    },
                    get slidesToScroll() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== "" &&
                        itemToShow !== 3.5 &&
                        itemToShow !== 4.5 &&
                        itemToShow !== 5.5
                      ) {
                        return (this.slidesToScroll = itemToShow);
                      } else {
                        return (this.slidesToScroll = 1);
                      }
                    },
                    get initialSlide() {
                      if (
                        itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                      ) {
                        return (this.initialSlide = 0.5);
                      } else {
                        return (this.initialSlide = 1);
                      }
                    },
                  },
                },
                {
                  breakpoint: 1024,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                    get slidesToShow() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== ""
                      ) {
                        if (itemToShow == 5 || itemToShow == 6) {
                          return (this.slidesToShow = itemToShow - 1);
                        } else {
                          if (
                            productGrid.parents(".collection-column-2").length
                          ) {
                            return (this.slidesToShow = 2);
                          } else {
                            return (this.slidesToShow = itemToShow);
                          }
                        }
                      } else {
                        return (this.slidesToShow = 1);
                      }
                    },
                    get slidesToScroll() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== "" &&
                        itemToShow !== 3.5 &&
                        itemToShow !== 4.5 &&
                        itemToShow !== 5.5
                      ) {
                        if (itemToShow == 5 || itemToShow == 6) {
                          return (this.slidesToScroll = itemToShow - 1);
                        } else {
                          if (
                            productGrid.parents(".collection-column-2").length
                          ) {
                            return (this.slidesToScroll = 2);
                          } else {
                            return (this.slidesToScroll = itemToShow);
                          }
                        }
                      } else {
                        return (this.slidesToScroll = 1);
                      }
                    },
                    get initialSlide() {
                      if (
                        itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                      ) {
                        return (this.initialSlide = 0.5);
                      } else {
                        return (this.initialSlide = 1);
                      }
                    },
                  },
                },
                {
                  breakpoint: 991,
                  settings: {
                    arrows: itemArrowsMb,
                    dots: itemDotsMb,
                    get slidesToShow() {
                      if (
                        productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                      ) {
                        if (
                          productGrid.parents(".product-block-has__banner")
                            .length &&
                          productGrid
                            .parents(".product-block-has__banner")
                            .data("width-banner") > 40
                        ) {
                          return (this.slidesToShow = 2);
                        } else {
                          return (this.slidesToShow = 3);
                        }
                      } else {
                        if (productGrid.parents(".collection-column-2").length) {
                          return (this.slidesToShow = 2);
                        } else if (itemToShow == 1) {
                          return (this.slidesToShow = itemToShow);
                        } else {
                          return (this.slidesToShow = 4);
                        }
                      }
                    },
                    get slidesToScroll() {
                      if (
                        productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                      ) {
                        if (
                          productGrid.parents(".product-block-has__banner")
                            .length &&
                          productGrid
                            .parents(".product-block-has__banner")
                            .data("width-banner") > 40
                        ) {
                          return (this.slidesToScroll = 2);
                        } else {
                          return (this.slidesToScroll = 3);
                        }
                      } else {
                        if (productGrid.parents(".collection-column-2").length) {
                          return (this.slidesToScroll = 2);
                        } else if (itemToShow == 1) {
                          return (this.slidesToScroll = itemToShow);
                        } else {
                          return (this.slidesToScroll = 4);
                        }
                      }
                    },
                    get initialSlide() {
                      if (
                        itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                      ) {
                        return (this.initialSlide = 0.5);
                      } else {
                        return (this.initialSlide = 1);
                      }
                    },
                  },
                },
                {
                  breakpoint: 767,
                  arrows: itemArrowsMb,
                  dots: itemDotsMb,
                  settings: {
                    get slidesToShow() {
                      if (
                        productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                      ) {
                        return (this.slidesToShow = 2);
                      } else if (itemToShow == 1) {
                        return (this.slidesToShow = itemToShow);
                      } else {
                        return (this.slidesToShow = 3);
                      }
                    },
                    get slidesToScroll() {
                      if (
                        productGrid.hasClass("has__banner_tab") ||
                        productGrid.parents(".product-block-has__banner").length
                      ) {
                        return (this.slidesToScroll = 2);
                      } else if (itemToShow == 1) {
                        return (this.slidesToScroll = itemToShow);
                      } else {
                        return (this.slidesToScroll = 3);
                      }
                    },
                    get initialSlide() {
                      if (
                        itemToShow == 3.5 ||
                        itemToShow == 4.5 ||
                        itemToShow == 5.5
                      ) {
                        return (this.initialSlide = 0.5);
                      } else {
                        return (this.initialSlide = 1);
                      }
                    },
                  },
                },
                {
                  breakpoint: 320,
                  arrows: itemArrowsMb,
                  dots: itemDotsMb,
                  settings: {
                    get slidesToShow() {
                      if (itemToShow == 1) {
                        if (
                          productGrid.hasClass(
                            "special-banner__products--slider"
                          ) ||
                          productGrid.hasClass("special-banner__products--grid")
                        ) {
                          return (this.slidesToShow = 2);
                        } else {
                          return (this.slidesToShow = itemToShow);
                        }
                      } else {
                        return (this.slidesToShow = 2);
                      }
                    },
                    get slidesToScroll() {
                      if (itemToShow == 1) {
                        return (this.slidesToScroll = itemToShow);
                      } else {
                        return (this.slidesToScroll = 2);
                      }
                    },
                  },
                },
              ],
            });
  
            if (productGrid.hasClass("enable_progress_bar")) {
                   console.log('hthis is the lcarasule 55555')
              productGrid.on("afterChange", (event, slick, nextSlide) => {
                var percent = (nextSlide / (slick.slideCount - 1)) * 100 + "%";
                progressBar.css("--percent", percent);
              });
            }
            if (productGrid.hasClass("enable_counter_number")) {
                   console.log('hthis is the lcarasule 66666')
              var slickNext = productGrid.find(".slick-next");
              productGrid
                .closest(".halo-block, .special-banner__product")
                .find(".products-counter-number")
                .appendTo(slickNext);
              productGrid.on("afterChange", (event) => {
                var slickIndex = productGrid
                  .find(".slick-current")
                  .data("slick-index");
                productGrid.find("#count-image").text(slickIndex + 1);
              });
            }
          }
        }
      },
  
      productBlockInfiniteScroll: function () {
        var productBlock = $("[data-product-block], [data-product-tab-block]");
  
        productBlock.each((index, element) => {
          var $block = $(element),
            showMore = $block.find("[data-product-infinite]");
  
          if (showMore.length > 0) {
            showMore.find(".button").on("click", (event) => {
              var showMoreButton = $(event.target);
  
              if (!showMoreButton.hasClass("view-all")) {
                event.preventDefault();
                event.stopPropagation();
  
                // var text = window.button_load_more.loading;
  
                showMoreButton.addClass("is-loading");
                // showMoreButton.text(text);
  
                var url = showMoreButton.attr("data-collection"),
                  limit = showMoreButton.attr("data-limit"),
                  swipe = showMoreButton.attr("data-swipe"),
                  total = showMoreButton.attr("data-total"),
                  image_ratio = showMoreButton.attr("data-image-ratio"),
                  sectionId = showMoreButton.attr("sectionId"),
                  page = parseInt(showMoreButton.attr("data-page"));
  
                halo.doProductBlockInfiniteScroll(
                  url,
                  total,
                  limit,
                  swipe,
                  image_ratio,
                  sectionId,
                  page,
                  showMoreButton,
                  $block
                );
              } else {
                window.location = showMoreButton.data("href");
              }
            });
          }
        });
      },
  
      doProductBlockInfiniteScroll: function (
        url,
        total,
        limit,
        swipe,
        image_ratio,
        sectionId,
        page,
        showMoreButton,
        $block
      ) {
        $.ajax({
          type: "get",
          url: window.routes.root + "/collections/" + url,
          cache: false,
          data: {
            view: "ajax_product_block",
            constraint:
              "limit=" +
              limit +
              "+page=" +
              page +
              "+sectionId=" +
              sectionId +
              "+imageRatio=" +
              image_ratio +
              "+swipe=" +
              swipe,
          },
          beforeSend: function () {
            // halo.showLoading();
          },
          success: function (data) {
            const $productGrid = showMoreButton.closest(".tab-content").length
              ? showMoreButton.closest(".tab-content").find(".products-grid")
              : showMoreButton
                  .closest(".halo-block-content")
                  .find(".products-grid");
            let length = $productGrid.find(".product").length;
            const res = halo.handleResponse(
              $(data),
              length,
              $productGrid.data("products-to-show")
            );
            $productGrid.append(res);
  
            if (length + res.length < $(data).length) {
              var text = window.button_load_more.default;
  
              showMoreButton.removeClass("is-loading");
              showMoreButton.attr("data-page", page + 1);
              showMoreButton.find("span").text(text);
            } else {
              if (
                Number(total) > $(data).length &&
                $(data).length <= length + res.length
              ) {
                var text = window.button_load_more.view_all;
  
                showMoreButton.find("span").text(text);
                showMoreButton.removeClass("is-loading");
                showMoreButton
                  .attr("data-href", window.routes.root + "/collections/" + url)
                  .addClass("view-all");
              } else {
                var text = window.button_load_more.no_more;
  
                showMoreButton.find("span").text(text);
                showMoreButton.removeClass("is-loading");
                showMoreButton.attr("disabled", "disabled");
              }
            }
          },
          complete: function () {
            // halo.hideLoading();
            if (halo.checkNeedToConvertCurrency()) {
              Currency.convertAll(
                window.shop_currency,
                $("#currencies .active").attr("data-currency"),
                "span.money",
                "money_format"
              );
            }
  
            if (
              window.review.show &&
              $(".shopify-product-reviews-badge").length > 0 &&
              window.SPR != null &&
              typeof window.SPR.registerCallbacks === "functions"
            ) {
              return (
                window.SPR.registerCallbacks(),
                window.SPR.initRatingHandler(),
                window.SPR.initDomEls(),
                window.SPR.loadProducts(),
                window.SPR.loadBadges()
              );
            }
          },
        });
      },
  
      productMenuSlider: function () {
        var productGrid = $(".megamenu_style_5");
        if (productGrid.length > 0) {
               console.log('hthis is the lcarasule 7777777')
          productGrid.each((index, el) => {
            let _self = $(el).find(".products-carousel"),
              _dataRows = _self.data("row");
            if (_self.not(".slick-initialized")) {
              _self.slick({
                mobileFirst: true,
                adaptiveHeight: true,
                vertical: false,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                rtl: window.rtl_slick,
                responsive: [
                  {
                    breakpoint: 1500,
                    settings: {
                      slidesToShow: _dataRows,
                      slidesToScroll: 1,
                      dots: false,
                    },
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                    },
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                    },
                  },
                ],
              });
            }
          });
        }
      },
  
      buildRecommendationBlock: function () {
       /* if (document.querySelector("[data-recommendations-block]") == null)
          return;
  
        var $this = document.querySelector("[data-recommendations-block]"),
          layout = $this.dataset.layout;
        swipe = $this.dataset.swipe;
  
        const config = {
          threshold: 0.25,
        };
  
        const handleIntersection = (entries, observer) => {
          const recommendationsContainer =
            $this.querySelector(".wrapper-container");
          if (!entries[0].isIntersecting) return;
          if (
            $this.innerHTML.trim() != "" &&
            !recommendationsContainer.classList.contains(
              "product-recommendations-loading"
            ) &&
            !recommendationsContainer.classList.contains("has-product")
          )
            return;
          recommendationsContainer.classList.add("has-product");
  
          fetch($this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                "[data-recommendations-block]"
              );
              if (recommendations && recommendations.innerHTML.trim().length) {
                $this.innerHTML = recommendations.innerHTML;
  
                var productItems = $($this).find(".product-item");
                var firstProductData = productItems.eq(0).data("json-product");
                if (!firstProductData) return $($this).remove();
  
                if (layout == "slider") {
                  halo.productBlockSilder($($this));
                } else if (layout == "scroll") {
                  const enableHover = $($this)
                    .find("[data-enable-hover]")
                    .attr("data-enable-hover");
                  const wrapper = $this.closest(".products-flex");
  
                  if (
                    enableHover === "true" &&
                    wrapper.clientWidth < wrapper.scrollWidth
                  ) {
                    halo.productBlockScroller($($this));
                  }
                }
  
                var productItems = $($this).find(".product-item");
                productItems.each(async (index, rawProduct) => {
                  var product = $(rawProduct);
                  var productId = product.data("product-id");
                  var productJson = product.data("json-product");
                  var handle = productJson.handle;
  
                  await $.ajax({
                    type: "get",
                    url:
                      window.routes.root +
                      "/products/" +
                      handle +
                      "?view=ajax_variant_quantity",
                    beforeSend: function () {},
                    success: function (data) {
                      const element = new DOMParser().parseFromString(
                        data,
                        "text/html"
                      );
                      if (
                        element.querySelector(
                          `[data-quantity-product-id="${productId}"]`
                        )
                      ) {
                        const quantityInfo = JSON.parse(
                          element.querySelector(
                            `[data-quantity-product-id="${productId}"]`
                          ).innerHTML
                        );
                        window[`quick_view_inven_array_${productId}`] =
                          quantityInfo;
                      }
                    },
                    error: function (xhr, text) {
                      halo.showWarning($.parseJSON(xhr.responseText).description);
                    },
                    complete: function () {},
                  });
                });
  
                const loadingImages = $this.querySelectorAll(
                  ".media--loading-effect img"
                );
                this.observeImageLazyloaded(loadingImages);
  
                if (window.compare.show) {
                  var $compareLink = $("[data-compare-link]");
  
                  halo.setLocalStorageProductForCompare($compareLink);
                }
  
                if (window.wishlist.show) {
                  halo.setLocalStorageProductForWishlist();
                }
  
                if (
                  window.review.show &&
                  $(".shopify-product-reviews-badge").length > 0 &&
                  window.SPR != null &&
                  typeof window.SPR.registerCallbacks === "functions"
                ) {
                  return (
                    window.SPR.registerCallbacks(),
                    window.SPR.initRatingHandler(),
                    window.SPR.initDomEls(),
                    window.SPR.loadProducts(),
                    window.SPR.loadBadges()
                  );
                }
  
                this.calculateTranslateYHeight();
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };
  
        new IntersectionObserver(
          handleIntersection.bind($this),
          ({}, config)
        ).observe($this); */
      },
  
      initVideoPopup: function () {
        console.log('initVideoPopup downnnnnnnnn')
        if ($(".video-open-popup").length) {
        } else {
          return;
        }
        $(".video-open-popup .video-button")
          .off("click")
          .on("click", function () {
            let video_type = $(this).attr("data-type"),
              video_src = $(this).attr("data-src"),
              aspect_ratio = $(this).attr("aspect_ratio"),
              modal = $("[data-popup-video]");
  
            const $content = `<div class="fluid-width-video-wrapper" style="padding-top: ${aspect_ratio}">
                                      ${
                                        video_type == "youtube"
                                          ? `<iframe
                                              id="player"
                                              type="text/html"
                                              width="100%"
                                              frameborder="0"
                                              webkitAllowFullScreen
                                              mozallowfullscreen
                                              allowFullScreen
                                              src="https://www.youtube.com/embed/${video_src}?autoplay=1&mute=1">
                                          </iframe>`
                                          : `<iframe 
                                              src="https://player.vimeo.com/video/${video_src}?autoplay=1&mute=1" 
                                              class="js-vimeo" 
                                              allow="autoplay; 
                                              encrypted-media" 
                                              webkitallowfullscreen 
                                              mozallowfullscreen 
                                              allowfullscreen">
                                          </iframe>`
                                      }
                                  </div>`;
            modal.find(".halo-popup-content").html($content);
            $body.addClass("video-show");
          });
  
        $(
          "[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay"
        ).on("click", function (e) {
          // e.preventDefault();
          // e.stopPropagation();
          let modalContent = $("[data-popup-video] .halo-popup-content");
          if (!modalContent.is(e.target) && !modalContent.has(e.target).length) {
            $body.removeClass("video-show");
            $("[data-popup-video] iframe").remove();
          }
        });
      },
  
      swapHoverVideoProductCard: function () {
        console.log('swapHoverVideoProductCard downnnnnnnnn')
        if (window.innerWidth > 1200) {
          $(".product-item .card").mouseenter(function () {
            var chil = $(this).find("video");
            var _chil = $(this).find("video").get(0);
            if (chil.length > 0) {
              _chil.play();
            }
          });
          $(".product-item .card").mouseleave(function () {
            var chil = $(this).find("video");
            var _chil = $(this).find("video").get(0);
            if (chil.length > 0) {
              _chil.pause();
            }
          });
        }
      },
  
      initGlobalCheckbox: function () {
        $doc.on("change", ".global-checkbox--input", (event) => {
          var targetId = event.target.getAttribute("data-target");
  
          if (event.target.checked) {
            $(targetId).attr("disabled", false);
          } else {
            $(targetId).attr("disabled", true);
          }
        });
  
        $doc.on("click", "[data-term-condition]", (event) => {
          event.preventDefault();
          event.stopPropagation();
          $body.addClass("term-condition-show");
        });
  
        $doc.on("click", "[data-close-term-condition-popup]", (event) => {
          event.preventDefault();
          event.stopPropagation();
          $body.removeClass("term-condition-show");
        });
  
        $doc.on("click", (event) => {
          setTimeout(() => {
            if ($body.hasClass("cart-sidebar-show")) {
              if (
                $(event.target).closest("[data-term-condition-popup]").length ===
                0
              ) {
                $body.removeClass("term-condition-show");
              }
            }
            if ($body.hasClass("term-condition-show")) {
              if (
                $(event.target).closest("[data-term-condition-popup]").length ===
                0
              ) {
                $body.removeClass("term-condition-show");
              }
            }
          }, 10);
        });
      },
  
      initColorSwatch: function () {
        $doc.ready(function () {
          $(".card .swatch-label.is-active").trigger("click");
        });
  
        $doc.on("click", ".card .swatch-label", (event) => {
          var $target = $(event.currentTarget),
            title = $target.attr("title").replace(/^\s+|\s+$/g, ""),
            product = $target.closest(".product-item"),
            productJson = product.data("json-product"),
            productTitle = product.find(".card-title"),
            productAction = product.find("[data-btn-addtocart]"),
            variantId = $target.data("variant-id"),
            productHref = product.find("a").attr("href"),
            oneOption = $target.data("with-one-option"),
            newImage = $target.data("variant-img"),
            mediaList = [];
  
          $target
            .parents(".swatch")
            .find(".swatch-label")
            .removeClass("is-active");
          $target.addClass("is-active");
  
          if (productTitle.hasClass("card-title-change")) {
            if ($body.hasClass("style_2_text_color_varriant")) {
              productTitle.find("[data-change-title]").text(title);
            } else {
              productTitle.find("[data-change-title]").text(" - " + title);
            }
          } else {
            if ($body.hasClass("style_2_text_color_varriant")) {
              productTitle
                .addClass("card-title-change")
                .append("<span data-change-title>" + title + "</span>");
            } else {
              productTitle
                .addClass("card-title-change")
                .append("<span data-change-title> - " + title + "</span>");
            }
          }
  
          const selectedVariant = productJson.variants.find(
            (variant) => variant.id === variantId
          );
  
          if (selectedVariant.compare_at_price > selectedVariant.price) {
            product.find(".price").addClass("price--on-sale");
            product
              .find(".price__sale .price-item--regular")
              .html(
                Shopify.formatMoney(
                  selectedVariant.compare_at_price,
                  window.money_format
                )
              );
            product
              .find(".price__sale .price-item--sale")
              .html(
                Shopify.formatMoney(selectedVariant.price, window.money_format)
              );
            const labelSale = `-${Math.round(
              ((selectedVariant.compare_at_price - selectedVariant.price) * 100) /
                selectedVariant.compare_at_price
            )}%`;
            product.find(".price__label_sale .label_sale").html(labelSale);
          } else {
            product
              .find(".price__regular .price-item")
              .html(
                Shopify.formatMoney(selectedVariant.price, window.money_format)
              );
  
            if (selectedVariant.compare_at_price == null) {
              product.find(".price").removeClass("price--on-sale");
              product.find(".price__sale .price-item--regular").html("");
            }
          }
  
          product
            .find("a:not(.single-action):not(.number-showmore)")
            .attr(
              "href",
              productHref.split("?variant=")[0] + "?variant=" + variantId
            );
  
          if (oneOption != undefined) {
            var quantity = $target.data("quantity");
  
            product.find('[name="id"]').val(oneOption);
  
            if (quantity > 0) {
              if (window.notify_me.show) {
                productAction.removeClass("is-notify-me").addClass("is-visible");
              } else {
                productAction.removeClass("is-soldout").addClass("is-visible");
              }
            } else {
              if (window.notify_me.show) {
                productAction.removeClass("is-visible").addClass("is-notify-me");
              } else {
                productAction.removeClass("is-visible").addClass("is-soldout");
              }
            }
  
            if (
              productAction.hasClass("is-soldout") ||
              productAction.hasClass("is-notify-me")
            ) {
              if (productAction.hasClass("is-notify-me")) {
                productAction.text(window.notify_me.button);
              } else {
                productAction
                  .text(window.variantStrings.soldOut)
                  .prop("disabled", true);
              }
            } else {
              productAction
                .text(window.variantStrings.addToCart)
                .prop("disabled", false);
            }
          } else {
            if (productJson != undefined) {
              if (window.quick_shop.show) {
                halo.checkStatusSwatchQuickShop(product, productJson);
              }
            }
  
            product
              .find('.swatch-element[data-value="' + title + '"]')
              .find(".single-label")
              .trigger("click");
          }
  
          if (productJson.media != undefined) {
            var mediaList = productJson.media.filter((index, element) => {
              return element.alt === title;
            });
          }
  
          if (mediaList.length > 0) {
            if (mediaList.length > 1) {
              var length = 2;
            } else {
              var length = mediaList.length;
            }
  
            for (var i = 0; i < length; i++) {
              product
                .find(".card-media img:eq(" + i + ")")
                .attr("srcset", mediaList[i].src);
            }
          } else {
            if (newImage) {
              product
                .find(".card-media img:nth-child(1)")
                .attr("srcset", newImage);
            }
          }
  
          // halo.checkPreOrderOfVariant(selectedVariant, productAction, productJson)
          if (halo.checkNeedToConvertCurrency()) {
            Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
          }
        });
  
        $doc.on("click", ".item-swatch-more .number-showmore", (event) => {
          if ($(event.target).closest(".swatch").hasClass("show--more")) {
            $(event.target).closest(".swatch").removeClass("show--more");
            $(event.target).find("span:eq(0)").text("+");
          } else {
            $(event.target).closest(".swatch").addClass("show--more");
            $(event.target).find("span:eq(0)").text("-");
          }
        });
      },
  
      checkPreOrderOfVariant: function (
        selectedVariant,
        productAction,
        productJson
      ) {
        // Check if variant is allowed to sale when out of stock
        const variantId = selectedVariant.id;
        const updatePreOrderText = (
          productAction,
          selectedVariant,
          inventoryQuantity
        ) => {
          const product = productAction.parents(".product-item");
          const hasQuickShopPanel =
            product.find("[data-quickshop-popup]").length > 0;
  
          if (selectedVariant.inventory_management == null) {
            productAction
              .text(
                hasQuickShopPanel
                  ? window.variantStrings.add
                  : window.variantStrings.addToCart
              )
              .prop("disabled", false)
              .addClass("button--pre-untrack");
          } else if (selectedVariant.available && inventoryQuantity <= 0) {
            productAction
              .text(window.variantStrings.preOrder)
              .prop("disabled", false)
              .addClass("button--pre-untrack");
          } else {
            productAction.removeClass("button--pre-untrack");
            if (inventoryQuantity > 0) {
              if (window.notify_me.show) {
                productAction.removeClass("is-notify-me").addClass("is-visible");
              } else {
                productAction.removeClass("is-soldout").addClass("is-visible");
              }
            } else {
              if (window.notify_me.show) {
                productAction
                  .removeClass("is-visible")
                  .addClass("is-notify-me")
                  .prop("disabled", false);
              } else {
                productAction
                  .removeClass("is-visible")
                  .addClass("is-soldout")
                  .prop("disabled", true);
              }
            }
  
            if (
              productAction.hasClass("is-soldout") ||
              productAction.hasClass("is-notify-me")
            ) {
              if (productAction.hasClass("is-notify-me")) {
                productAction
                  .text(window.notify_me.button)
                  .prop("disabled", false)
                  .removeClass("btn-unavailable");
              } else {
                productAction
                  .text(window.variantStrings.soldOut)
                  .prop("disabled", true);
              }
            } else {
              productAction
                .text(
                  hasQuickShopPanel
                    ? window.variantStrings.add
                    : window.variantStrings.addToCart
                )
                .prop("disabled", false);
            }
          }
        };
  
        const variantsQuantityInvenText = `quick_view_inven_array_${productJson.id}`;
        var arrayInVarName = variantsQuantityInvenText,
          inven_array = window[arrayInVarName];
  
        if (inven_array != undefined) {
          var inven_num = inven_array[variantId],
            inventoryQuantity = parseInt(inven_num);
          updatePreOrderText(productAction, selectedVariant, inventoryQuantity);
        } else {
          $.ajax({
            type: "get",
            url:
              window.routes.root +
              "/products/" +
              productJson.handle +
              "?view=ajax_quick_shop_data",
            beforeSend: function () {},
            success: function (data) {
              window[variantsQuantityInvenText] = JSON.parse(data.split("=")[1]);
              var inven_num = window[variantsQuantityInvenText][variantId],
                inventoryQuantity = parseInt(inven_num);
              updatePreOrderText(
                productAction,
                selectedVariant,
                inventoryQuantity
              );
            },
            error: function (xhr, text) {
              halo.showWarning($.parseJSON(xhr.responseText).description);
            },
            complete: function () {},
          });
        }
      },
  
      initQuickShop: function () {
        if (window.quick_shop.show) {
          $doc.on("click", "[data-quickshop-popup]", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            var $target = $(event.target),
              product = $target.parents(".product-item"),
              productJson = product.data("json-product"),
              variantPopup = product.find(".variants-popup");
  
            const $quickView = document.querySelector(".halo-quick-view-popup");
            if (
              !document.body.matches(".qv-loaded", ".qs3-loaded") &&
              $quickView
            ) {
              halo.buildStyleSheet(
                $quickView.dataset.urlStyleProduct,
                $quickView
              );
              document.body.classList.add("qs3-loaded");
            }
  
            if (!product.hasClass("quickshop-popup-show")) {
              $(".product-item").removeClass("quickshop-popup-show");
  
              if ($body.hasClass("quick_shop_option_2")) {
                var height = product.find(".card-media").outerHeight(true);
                var variantsArray = variantPopup.find(".variants");
  
                if ($body.hasClass("product-card-layout-02")) {
                  if ($win.width() > 1024) {
                    variantsArray.css("max-height", height - 114 + "px");
                    variantsArray.css("min-height", height - 114 + "px");
                  } else {
                    variantsArray.css("max-height", height - 70 + "px");
                    variantsArray.css("min-height", height - 70 + "px");
                  }
                } else if ($body.hasClass("product-card-layout-04")) {
                  if ($win.width() > 1024) {
                    variantsArray.css("max-height", height - 116 + "px");
                    variantsArray.css("min-height", height - 116 + "px");
                  } else {
                    variantsArray.css("max-height", height - 70 + "px");
                    variantsArray.css("min-height", height - 70 + "px");
                  }
                } else {
                  if ($win.width() > 1024) {
                    variantsArray.css("max-height", height - 74 + "px");
                    variantsArray.css("min-height", height - 74 + "px");
                  } else {
                    variantsArray.css("max-height", height - 20 + "px");
                    variantsArray.css("min-height", height - 20 + "px");
                  }
                }
  
                if (
                  variantsArray[0].scrollHeight > variantsArray[0].clientHeight
                ) {
                  variantsArray.addClass("scrollable");
                }
  
                if (!$(".productListing").hasClass("productList")) {
                  halo.appendProductQuickShopOption2(product);
                }
              } else if ($body.hasClass("quick_shop_option_3")) {
                const handle = $target.data("product-handle");
                if (!$(".productListing").hasClass("productList")) {
                  halo.updateContentQuickshopOption3(handle);
                }
  
                $doc.on("click", "[data-close-quick-shop-popup]", (event) => {
                  event.preventDefault();
                  event.stopPropagation();
  
                  $body.removeClass("quickshop-popup-show");
                });
  
                $doc
                  .off("click.quickShopOverlay")
                  .on("click.quickShopOverlay", (event) => {
                    if (
                      $body.hasClass("quickshop-popup-show") &&
                      $(event.target).is(".background-overlay")
                    ) {
                      $body.removeClass("quickshop-popup-show");
                    }
                  });
              }
  
              if (!$body.hasClass("quick_shop_option_3")) {
                console.log('111111111111111111111111111111')
                if ($win.width() < 767) {
                  if ($(".productListing").hasClass("productList")) {
                    halo.appendToListViewModal(product);
                  } else {
                    product.addClass("quickshop-popup-show");
                  }
                } else {
                  product.addClass("quickshop-popup-show");
                }
              } else {
                if ($(".productListing").hasClass("productList")) {
                  console.log('2222222222222222222222222222222222222222')
                  if ($win.width() < 767) {
                    halo.appendToListViewModal(product);
                  } else {
                    product.addClass("quickshop-popup-show");
                  }
                }
              }
  
              product.find(".swatch-label.is-active").trigger("click");
              halo.checkStatusSwatchQuickShop(product, productJson);
  
              if (
                $body.hasClass("quick_shop_option_2") ||
                ($("productListing").hasClass("productList") &&
                  !$(".card-swatch").hasClass("quick_shop_type_3"))
              ) {
                console.log('33333333333333333333333333333333333')
                if ($win.width() < 767) {
                  if (!$(".productListing").hasClass("productList")) {
                    var quickshopVariantPopup = $(
                      "#halo-card-mobile-popup .variants-popup"
                    );
                    quickshopVariantPopup
                      .find(".selector-wrapper")
                      .each((index, element) => {
                        $(element)
                          .find(".swatch-element:not(.soldout):not(.unavailable)")
                          .eq("0")
                          .find(".single-label")
                          .trigger("click");
                      });
                  } else {
                    variantPopup
                      .find(".selector-wrapper")
                      .each((index, element) => {
                        $(element)
                          .find(".swatch-element:not(.soldout):not(.unavailable)")
                          .eq("0")
                          .find(".single-label")
                          .trigger("click");
                      });
                  }
                } else {
                  variantPopup
                    .find(".selector-wrapper")
                    .each((index, element) => {
                      $(element)
                        .find(".swatch-element:not(.soldout):not(.unavailable)")
                        .eq("0")
                        .find(".single-label")
                        .trigger("click");
                    });
                }
                if (!$(".productListing").hasClass("productList")) {
                  $body.addClass("quick_shop_popup_mobile");
                }
              } else {
                variantPopup
                  .find(".selector-wrapper:not(.option-color)")
                  .each((index, element) => {
                    $(element)
                      .find(".swatch-element:not(.soldout):not(.unavailable)")
                      .eq("0")
                      .find(".single-label")
                      .trigger("click");
                  });
              }
            } else {
              halo.initAddToCartQuickShop($target, variantPopup);
            }
  
            if (halo.checkNeedToConvertCurrency()) {
              Currency.convertAll(
                window.shop_currency,
                $("#currencies .active").attr("data-currency"),
                "span.money",
                "money_format"
              );
            }
          });
  
          $doc.on("click", "[data-cancel-quickshop-popup]", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            var $target = $(event.currentTarget),
              product = $target.parents(".product-item"),
              quickshopMobilePopup = $doc.find("#halo-card-mobile-popup");
  
            product.removeClass("quickshop-popup-show");
            var productQuickshopShown = $doc.find(".quickshop-popup-show");
            productQuickshopShown.removeClass("quickshop-popup-show");
            $body.removeClass("quickshop-list-view-show");
  
            if ($body.hasClass("quick_shop_option_2")) {
              $body.removeClass("quick_shop_popup_mobile");
              quickshopMobilePopup.removeClass("show");
            }
          });
  
          $doc.on("click", (event) => {
            if (
              $(event.target).closest("[data-quickshop-popup]").length === 0 &&
              $(event.target).closest(".variants-popup").length === 0 &&
              $(event.target).closest(".card-swatch").length === 0 &&
              $(event.target).closest("[data-warning-popup]").length === 0
            ) {
              $(".product-item").removeClass("quickshop-popup-show");
              if ($body.hasClass("quick_shop_option_2")) {
                $body.removeClass("quick_shop_popup_mobile");
              }
            }
          });
  
          halo.changeSwatchQuickShop();
        }
      },
  
      appendToListViewModal: function (product) {
        const quickshopMobilePopup = $doc.find("#list-view-popup");
        const quickshopForm = product.clone();
        quickshopMobilePopup.find(".halo-popup-content").empty();
        quickshopMobilePopup.find(".halo-popup-content").append(quickshopForm);
  
        const form = quickshopMobilePopup
          .find("[data-quickshop] .card-information .variants-popup form")
          .eq("0");
        const mobilePopupId = form.attr("id") + "-mobile";
        const optionInputs = form.find(".single-option");
        const optionLabels = form.find(".single-label");
        const cardInfoWrapper = quickshopMobilePopup.find(".card-product");
        const variantsPopup = quickshopMobilePopup.find(".variants-popup");
        const submitBtn = quickshopMobilePopup.find("[data-btn-addtocart]");
        variantsPopup.removeClass("card-list__hidden");
        let clicked = {
          selected1: false,
          selected2: false,
          selected3: false,
        };
  
        form.attr("id", mobilePopupId);
        submitBtn.attr(
          "data-form-id",
          submitBtn.attr("data-form-id") + "-mobile"
        );
  
        optionInputs.each((index, optionInput) => {
          $(optionInput).attr("id", $(optionInput).attr("id") + "-mobile");
          $(optionInput).attr("name", $(optionInput).attr("name") + "-mobile");
        });
  
        optionLabels.each((index, optionLabel) => {
          $(optionLabel).attr("for", $(optionLabel).attr("for") + "-mobile");
  
          const swatchWrapper = $(optionLabel).closest(".selector-wrapper");
          const swatchElement = $(optionLabel).closest(".swatch-element");
          if (!swatchElement.hasClass("available")) return;
  
          if (
            swatchWrapper.hasClass("selector-wrapper-1") &&
            !clicked.selected1
          ) {
            clicked.selected1 = true;
            $(optionLabel).trigger("click");
          } else if (
            swatchWrapper.hasClass("selector-wrapper-2") &&
            !clicked.selected2
          ) {
            clicked.selected2 = true;
            $(optionLabel).trigger("click");
          } else if (
            swatchWrapper.hasClass("selector-wrapper-3") &&
            !clicked.selected3
          ) {
            clicked.selected3 = true;
            $(optionLabel).trigger("click");
          }
        });
  
        $body.addClass("quickshop-list-view-show");
  
        $(".background-overlay")
          .off("click.closeListViewModal")
          .on("click.closeListViewModal", () => {
            $body.removeClass("quickshop-list-view-show");
          });
      },
  
      changeSwatchQuickShop: function () {
        $doc.on("change", "[data-quickshop] .single-option", (event) => {
          var $target = $(event.target),
            product = $target.parents(".product-item"),
            productJson = product.data("json-product"),
            productAction = product.find("[data-btn-addtocart]"),
            variantList,
            optionColor = product.find(".option-color").data("option-position"),
            optionIndex = $target
              .closest("[data-option-index]")
              .data("option-index"),
            swatch = product.find(".swatch-element"),
            thisVal = $target.val(),
            selectedVariant,
            productInput = product.find("[name=id]"),
            selectedOption1 = product
              .find(".selector-wrapper-1")
              .find("input:checked")
              .val(),
            selectedOption2 = product
              .find(".selector-wrapper-2")
              .find("input:checked")
              .val(),
            selectedOption3 = product
              .find(".selector-wrapper-3")
              .find("input:checked")
              .val();
  
          if (
            $body.hasClass("quick_shop_option_2") &&
            $(".productListing").hasClass("productList")
          ) {
            selectedOption1 = product
              .find(".selector-wrapper-1")
              .eq("1")
              .find("input:checked")
              .val();
          } else {
            if (
              $(".productListing").hasClass("productList") &&
              $win.width() < 767
            ) {
              selectedOption1 = product
                .find(".selector-wrapper-1")
                .eq("1")
                .find("input:checked")
                .val();
              selectedOption2 = product
                .find('[data-option-index="1"]')
                .eq("1")
                .find("input:checked")
                .val();
            } else {
              selectedOption1 = product
                .find(".selector-wrapper-1")
                .eq("0")
                .find("input:checked")
                .val();
            }
          }
  
          if (productJson != undefined) {
            variantList = productJson.variants;
          }
  
          swatch.removeClass("soldout");
          swatch.find('input[type="radio"]').prop("disabled", false);
  
          switch (optionIndex) {
            case 0:
              var availableVariants = variantList.find((variant) => {
                if (optionColor == 1) {
                  return (
                    variant.option2 == thisVal &&
                    variant.option1 == selectedOption2
                  );
                } else {
                  if (optionColor == 2) {
                    return (
                      variant.option3 == thisVal &&
                      variant.option1 == selectedOption2
                    );
                  } else {
                    return (
                      variant.option1 == thisVal &&
                      variant.option2 == selectedOption2
                    );
                  }
                }
              });
  
              if (availableVariants != undefined) {
                selectedVariant = availableVariants;
              } else {
                var altAvailableVariants = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return variant.option2 == thisVal;
                  } else {
                    if (optionColor == 2) {
                      return variant.option3 == thisVal;
                    } else {
                      return variant.option1 == thisVal;
                    }
                  }
                });
  
                selectedVariant = altAvailableVariants;
              }
  
              break;
            case 1:
              var availableVariants = variantList.find((variant) => {
                if (optionColor == 1) {
                  return (
                    variant.option2 == selectedOption1 &&
                    variant.option1 == thisVal &&
                    variant.option3 == selectedOption2
                  );
                } else {
                  if (optionColor == 2) {
                    return (
                      variant.option3 == selectedOption1 &&
                      variant.option1 == thisVal &&
                      variant.option2 == selectedOption2
                    );
                  } else {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == thisVal &&
                      variant.option3 == selectedOption2
                    );
                  }
                }
              });
  
              if (availableVariants != undefined) {
                selectedVariant = availableVariants;
              } else {
                var altAvailableVariants = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return (
                      variant.option2 == selectedOption1 &&
                      variant.option1 == thisVal
                    );
                  } else {
                    if (optionColor == 2) {
                      return (
                        variant.option3 == selectedOption1 &&
                        variant.option1 == thisVal
                      );
                    } else {
                      return (
                        variant.option1 == selectedOption1 &&
                        variant.option2 == thisVal
                      );
                    }
                  }
                });
  
                selectedVariant = altAvailableVariants;
              }
  
              break;
            case 2:
              var availableVariants = variantList.find((variant) => {
                if (optionColor == 1) {
                  return (
                    variant.option2 == selectedOption1 &&
                    variant.option1 == selectedOption2 &&
                    variant.option3 == thisVal
                  );
                } else {
                  if (optionColor == 2) {
                    return (
                      variant.option3 == selectedOption1 &&
                      variant.option1 == selectedOption2 &&
                      variant.option2 == thisVal
                    );
                  } else {
                    return (
                      variant.option1 == selectedOption1 &&
                      variant.option2 == selectedOption2 &&
                      variant.option3 == thisVal
                    );
                  }
                }
              });
  
              if (availableVariants != undefined) {
                selectedVariant = availableVariants;
              }
  
              break;
          }
  
          if (selectedVariant == undefined) {
            return;
          }
  
          productInput.val(selectedVariant.id);
          var value = $target.val();
  
          $target
            .parents(".selector-wrapper")
            .find(".form-label span")
            .text(value);
          if (selectedVariant.available) {
            product.find("[data-btn-addtocart]").removeClass("btn-unavailable");
            product
              .find("[data-quickshop] quickshop-update-quantity")
              .removeClass("disabled");
            product.find("[data-btn-addtocart]").attr("data-available", "true");
          } else {
            product.find("[data-btn-addtocart]").addClass("btn-unavailable");
            product
              .find("[data-quickshop] quickshop-update-quantity")
              .addClass("disabled");
            product.find("[data-btn-addtocart]").attr("data-available", "false");
          }
  
          if (halo.checkNeedToConvertCurrency()) {
            Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
          }
  
          if (
            !$body.hasClass("quick_shop_option_2") &&
            !$body.hasClass("quick_shop_option_3") &&
            $win.width() < 767
          ) {
          }
  
          halo.checkStatusSwatchQuickShop(product, productJson);
          halo.checkPreOrderOfVariant(
            selectedVariant,
            productAction,
            productJson
          );
        });
      },
  
      checkStatusSwatchQuickShop: function (product, productJson) {
        var variantPopup = product.find(".card-variant"),
          variantList,
          productOption = product.find("[data-option-index]"),
          optionColor = product.find(".option-color").data("option-position"),
          selectedOption1 = product
            .find('[data-option-index="0"]')
            .find("input:checked")
            .val(),
          selectedOption2 = product
            .find('[data-option-index="1"]')
            .find("input:checked")
            .val(),
          selectedOption3 = product
            .find('[data-option-index="2"]')
            .find("input:checked")
            .val(),
          productId = product.data("product-id");
  
        if ($body.hasClass("quick_shop_option_2")) {
          var height = product.find(".card-media").outerHeight(true);
          if (selectedOption3 != undefined) {
            if ($body.hasClass("product-card-layout-01")) {
              if (height < 310) {
                $("[data-quickshop]").addClass("active_option_3");
              } else {
                $("[data-quickshop]").removeClass("active_option_3");
              }
            } else {
              if (height < 370) {
                $("[data-quickshop]").addClass("active_option_3");
              } else {
                $("[data-quickshop]").removeClass("active_option_3");
              }
            }
          } else {
            if ($win.width() > 1024) {
              if ($body.hasClass("product-card-layout-05")) {
                if (height < 350 && selectedOption2 != undefined) {
                  $("[data-quickshop]").addClass("active_option_3");
                } else {
                  $("[data-quickshop]").removeClass("active_option_3");
                }
              } else if ($body.hasClass("product-card-layout-01")) {
                if (height < 310 && selectedOption2 != undefined) {
                  $("[data-quickshop]").addClass("active_option_3");
                } else {
                  $("[data-quickshop]").removeClass("active_option_3");
                }
              } else {
                if (height < 370 && selectedOption2 != undefined) {
                  $("[data-quickshop]").addClass("active_option_3");
                } else {
                  $("[data-quickshop]").removeClass("active_option_3");
                }
              }
            } else {
              if ($body.hasClass("product-card-layout-01")) {
                if (height < 310) {
                  if (
                    selectedOption1 != undefined ||
                    selectedOption2 != undefined
                  ) {
                    $("[data-quickshop]").removeClass("active_option_3");
                  } else {
                    $("[data-quickshop]").addClass("active_option_3");
                  }
                } else {
                  $("[data-quickshop]").removeClass("active_option_3");
                }
              } else {
                if (height < 370) {
                  if (
                    selectedOption1 != undefined ||
                    selectedOption2 != undefined
                  ) {
                    $("[data-quickshop]").removeClass("active_option_3");
                  } else {
                    $("[data-quickshop]").addClass("active_option_3");
                  }
                } else {
                  $("[data-quickshop]").removeClass("active_option_3");
                }
              }
            }
          }
        }
  
        if (
          $body.hasClass("quick_shop_option_2") &&
          $(".productListing").hasClass("productList")
        ) {
          selectedOption1 = product
            .find('[data-option-index="0"]')
            .eq("1")
            .find("input:checked")
            .val();
        } else {
          if (
            $(".productListing").hasClass("productList") &&
            $win.width() < 767
          ) {
            selectedOption1 = product
              .find('[data-option-index="0"]')
              .eq("1")
              .find("input:checked")
              .val();
            selectedOption2 = product
              .find('[data-option-index="1"]')
              .eq("1")
              .find("input:checked")
              .val();
          } else {
            selectedOption1 = product
              .find('[data-option-index="0"]')
              .eq("0")
              .find("input:checked")
              .val();
          }
        }
  
        if (productJson != undefined) {
          variantList = productJson.variants;
        }
  
        productOption.each((index, element) => {
          var optionIndex = $(element).data("option-index"),
            swatch = $(element).find(".swatch-element");
  
          switch (optionIndex) {
            case 0:
              swatch.each((idx, elt) => {
                var item = $(elt),
                  swatchVal = item.data("value");
  
                var optionSoldout = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return variant.option2 == swatchVal && variant.available;
                  } else {
                    if (optionColor == 2) {
                      return variant.option3 == swatchVal && variant.available;
                    } else {
                      return variant.option1 == swatchVal && variant.available;
                    }
                  }
                });
  
                var optionUnavailable = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return variant.option2 == swatchVal;
                  } else {
                    if (optionColor == 2) {
                      return variant.option3 == swatchVal;
                    } else {
                      return variant.option1 == swatchVal;
                    }
                  }
                });
  
                if (optionSoldout == undefined) {
                  if (optionUnavailable == undefined) {
                    item.removeClass("soldout available").addClass("unavailable");
                    item.find('input[type="radio"]').prop("checked", false);
                  } else {
                    item
                      .removeClass("unavailable available")
                      .addClass("soldout")
                      .find(".single-action")
                      .attr("data-variant-id", optionUnavailable.title);
                    item.find('input[type="radio"]').prop("disabled", false);
                  }
                } else {
                  item.removeClass("soldout unavailable").addClass("available");
                  item.find('input[type="radio"]').prop("disabled", false);
                }
              });
  
              break;
            case 1:
              swatch.each((idx, elt) => {
                var item = $(elt),
                  swatchVal = item.data("value");
  
                var optionSoldout = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return (
                      variant.option2 == selectedOption1 &&
                      variant.option1 == swatchVal &&
                      variant.available
                    );
                  } else {
                    if (optionColor == 2) {
                      return (
                        variant.option3 == selectedOption1 &&
                        variant.option1 == swatchVal &&
                        variant.available
                      );
                    } else {
                      return (
                        variant.option1 == selectedOption1 &&
                        variant.option2 == swatchVal &&
                        variant.available
                      );
                    }
                  }
                });
  
                var optionUnavailable = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return (
                      variant.option2 == selectedOption1 &&
                      variant.option1 == swatchVal
                    );
                  } else {
                    if (optionColor == 2) {
                      return (
                        variant.option3 == selectedOption1 &&
                        variant.option1 == swatchVal
                      );
                    } else {
                      // CHECK: find the error and value of selectedOption1
                      return (
                        variant.option1 == selectedOption1 &&
                        variant.option2 == swatchVal
                      );
                    }
                  }
                });
  
                if (optionSoldout == undefined) {
                  if (optionUnavailable == undefined) {
                    item.removeClass("soldout available").addClass("unavailable");
                    item.find('input[type="radio"]').prop("checked", false);
                  } else {
                    item
                      .removeClass("unavailable available")
                      .addClass("soldout")
                      .find(".single-action-selector")
                      .attr("data-variant-id", optionUnavailable.title);
                    item.find('input[type="radio"]').prop("disabled", false);
                  }
                } else {
                  item.removeClass("soldout unavailable").addClass("available");
                  item.find('input[type="radio"]').prop("disabled", false);
                }
              });
              break;
            case 2:
              swatch.each((idx, elt) => {
                var item = $(elt),
                  swatchVal = item.data("value");
  
                var optionSoldout = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return (
                      variant.option2 == selectedOption1 &&
                      variant.option1 == selectedOption2 &&
                      variant.option3 == swatchVal &&
                      variant.available
                    );
                  } else {
                    if (optionColor == 2) {
                      return (
                        variant.option3 == selectedOption1 &&
                        variant.option1 == selectedOption2 &&
                        variant.option2 == swatchVal &&
                        variant.available
                      );
                    } else {
                      return (
                        variant.option1 == selectedOption1 &&
                        variant.option2 == selectedOption2 &&
                        variant.option3 == swatchVal &&
                        variant.available
                      );
                    }
                  }
                });
  
                var optionUnavailable = variantList.find((variant) => {
                  if (optionColor == 1) {
                    return (
                      variant.option2 == selectedOption1 &&
                      variant.option1 == selectedOption2 &&
                      variant.option3 == swatchVal
                    );
                  } else {
                    if (optionColor == 2) {
                      return (
                        variant.option3 == selectedOption1 &&
                        variant.option1 == selectedOption2 &&
                        variant.option2 == swatchVal
                      );
                    } else {
                      return (
                        variant.option1 == selectedOption1 &&
                        variant.option2 == selectedOption2 &&
                        variant.option3 == swatchVal
                      );
                    }
                  }
                });
  
                if (optionSoldout == undefined) {
                  if (optionUnavailable == undefined) {
                    item.removeClass("soldout available").addClass("unavailable");
                    item.find('input[type="radio"]').prop("checked", false);
                  } else {
                    item
                      .removeClass("unavailable available")
                      .addClass("soldout")
                      .find(".single-action-selector")
                      .attr("data-variant-id", optionUnavailable.title);
                    item.find('input[type="radio"]').prop("disabled", false);
                  }
                } else {
                  item.removeClass("unavailable soldout").addClass("available");
                  item.find('input[type="radio"]').prop("disabled", false);
                }
              });
  
              break;
          }
        });
  
        variantPopup
          .find(".selector-wrapper:not(.option-color)")
          .each((index, element) => {
            var item = $(element);
  
            if (item.find(".swatch-element").find("input:checked").length < 1) {
              if (item.find(".swatch-element.available").length > 0) {
                item
                  .find(".swatch-element.available")
                  .eq("0")
                  .find(".single-label")
                  .trigger("click");
              } else {
                item
                  .find(".swatch-element.soldout")
                  .eq("0")
                  .find(".single-label")
                  .trigger("click");
              }
            }
          });
  
        if ($body.hasClass("quick_shop_option_2")) {
          var variantId = product
            .find("[data-quickshop]")
            .eq(1)
            .find('[name="id"]')
            .val();
          var arrayInVarName = `quick_view_inven_array_${productId}`,
            inven_array = window[arrayInVarName];
  
          if (inven_array != undefined) {
            var inven_num = inven_array[variantId],
              inventoryQuantity = parseInt(inven_num),
              quantityInput = product.find('input[name="quantity"]').eq(0);
  
            quantityInput.attr("data-inventory-quantity", inventoryQuantity);
            if (quantityInput.val() > inventoryQuantity) {
              if (inventoryQuantity > 0) {
                quantityInput.val(inventoryQuantity);
              } else {
                quantityInput.val(1);
              }
            }
          }
        }
      },
  
      initAddToCartQuickShop: function ($target, popup) {
        var variantId = popup.find('[name="id"]').val(),
          qty = 1;
  
        halo.actionAddToCart($target, variantId, qty);
      },
  
      initAddToCart: function () {
        $doc
          .off("click.addToCart")
          .on("click.addToCart", "[data-btn-addtocart]", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            var $target = $(event.target),
              product = $target.parents(".product-item"),
              MobilePopup_Option_2 = $doc.find("#halo-card-mobile-popup"),
              ProductQuickShopShown_Option_2 = $doc.find(".quickshop-popup-show");
  
            if ($target.closest("product-form").length > 0) {
              var productForm = $target.closest("form");
  
              halo.actionAddToCart2($target, productForm);
            } else {
              if (
                !$target.hasClass("is-notify-me") &&
                !$target.hasClass("is-soldout")
              ) {
                var form = $target.parents("form"),
                  variantId = form.find('[name="id"]').val(),
                  qty = form.find('[name="quantity"]').val(),
                  input = form.find('[name="quantity"]').eq(0);
                if (qty == undefined) {
                  qty = 1;
                }
  
                halo.actionAddToCart($target, variantId, qty, input);
              } else if ($target.hasClass("is-notify-me")) {
                halo.notifyInStockPopup($target);
              }
            }
          });
  
        $doc.on("click", "[data-close-add-to-cart-popup]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.removeClass("add-to-cart-show");
        });
  
        $doc.on("click", (event) => {
          if ($body.hasClass("add-to-cart-show")) {
            if (
              $(event.target).closest("[data-add-to-cart-popup]").length === 0
            ) {
              $body.removeClass("add-to-cart-show");
            }
          }
        });
      },
  
      actionAddToCart: function ($target, variantId, qty, input) {
        var originalMessage = window.variantStrings.submit,
          waitMessage = window.variantStrings.addingToCart,
          successMessage = window.variantStrings.addedToCart;
  
        if ($target.hasClass("button-text-change")) {
          originalMessage = $target.text();
        }
  
        $target.addClass("is-loading");
  
        if ($body.hasClass("quick-view-show")) {
          Shopify.addItem(
            variantId,
            qty,
            $target,
            () => {
              // $target.text(successMessage);
              if (window.after_add_to_cart.type == "cart") {
                halo.redirectTo(window.routes.cart);
              } else {
                Shopify.getCart((cartTotal) => {
                  $body.addClass("cart-sidebar-show");
                  halo.updateSidebarCart(cartTotal);
                  $body.find("[data-cart-count]").text(cartTotal.item_count);
                  $target.removeClass("is-loading");
                });
              }
            },
            input
          );
        } else if ($body.hasClass("template-cart")) {
          Shopify.addItem(
            variantId,
            qty,
            $target,
            () => {
              // $target.text(successMessage);
              halo.redirectTo(window.routes.cart);
            },
            input
          );
        } else {
          Shopify.addItem(
            variantId,
            qty,
            $target,
            () => {
              // $target.text(successMessage);
              $target.removeClass("is-loading");
              if (
                $body.hasClass("quickshop-popup-show") &&
                $body.hasClass("quick_shop_option_3")
              ) {
                $body.removeClass("quickshop-popup-show");
  
                $(".quickshop-popup-show").removeClass("quickshop-popup-show");
              }
  
              if ($body.hasClass("quickshop-list-view-show")) {
                $body.removeClass("quickshop-list-view-show");
              }
  
              if ($body.hasClass("show-mobile-options")) {
                $body.removeClass("show-mobile-options");
                $(".background-overlay").addClass("hold");
              }
  
              if (
                $body.hasClass("quick_shop_popup_mobile") &&
                $body.hasClass("quick_shop_option_2")
              ) {
                // setTimeout(() => {
                $body.removeClass("quick_shop_popup_mobile");
                $doc.find("#halo-card-mobile-popup").removeClass("show");
                $doc.find(".quickshop-popup-show").each((index, popup) => {
                  $(popup).removeClass("quickshop-popup-show");
                });
                // }, 200);
              }
  
              switch (window.after_add_to_cart.type) {
                case "cart":
                  halo.redirectTo(window.routes.cart);
  
                  break;
                case "quick_cart":
                  if (window.quick_cart.show) {
                    Shopify.getCart((cart) => {
                      if (window.quick_cart.type == "popup") {
                        // $body.addClass('cart-modal-show');
                        // halo.updateDropdownCart(cart);
                      } else {
                        $body.addClass("cart-sidebar-show");
                        halo.updateSidebarCart(cart);
                      }
  
                      $target.removeClass("is-loading");
                      $(".background-overlay").removeClass("hold");
                    });
                  } else {
                    halo.redirectTo(window.routes.cart);
                  }
  
                  break;
                case "popup_cart_1":
                  Shopify.getCart((cart) => {
                    halo.updatePopupCart(cart, 1, variantId);
                    halo.updateSidebarCart(cart);
                    $body.addClass("add-to-cart-show");
                    $target.removeClass("is-loading");
                    $(".background-overlay").removeClass("hold");
                  });
  
                  break;
              }
            },
            input
          );
        }
      },
  
      actionAddToCart2: function ($target, productForm) {
        const config = fetchConfig("javascript");
        var originalMessage = window.variantStrings.submit,
          waitMessage = window.variantStrings.addingToCart,
          successMessage = window.variantStrings.addedToCart;
  
        if ($target.hasClass("button-text-change")) {
          originalMessage = $target.text();
        }
  
        $target.addClass("is-loading");
  
        let addToCartForm = document.querySelector(
          '[data-type="add-to-cart-form"]'
        );
        let formData = new FormData(addToCartForm);
  
        const properties = document.querySelectorAll('input[name^="properties"]');
  
        properties.forEach((property) => {
          if (property.value == null) return;
          if (property.type == "file") {
            formData.append(property.name, property.files[0]);
          } else {
            formData.append(property.name, property.value);
          }
        });
  
        const enoughInStock = halo.checkSufficientStock(productForm);
        if (!enoughInStock && $body.hasClass("quickshop-popup-show")) {
          alert(window.cartStrings.addProductOutQuantity);
          $target.removeClass("is-loading");
          return;
        }
  
        const addItemToCart = (variantId) => {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => {
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .finally(() => {
              if ($body.hasClass("quickshop-popup-show")) {
                $body.removeClass("quickshop-popup-show");
              }
  
              if ($body.hasClass("quick-view-show")) {
                if (window.after_add_to_cart.type == "cart") {
                  halo.redirectTo(window.routes.cart);
                } else {
                  Shopify.getCart((cartTotal) => {
                    $body.find("[data-cart-count]").text(cartTotal.item_count);
                    $target.removeClass("is-loading");
                  });
                }
              } else {
                switch (window.after_add_to_cart.type) {
                  case "cart":
                    halo.redirectTo(window.routes.cart);
  
                    break;
                  case "quick_cart":
                    if (window.quick_cart.show) {
                      Shopify.getCart((cart) => {
                        if (window.quick_cart.type == "popup") {
                          // $body.addClass('cart-modal-show');
                          // halo.updateDropdownCart(cart);
                        } else {
                          $body.addClass("cart-sidebar-show");
                          halo.updateSidebarCart(cart);
                        }
  
                        $target.removeClass("is-loading");
                      });
                    } else {
                      halo.redirectTo(window.routes.cart);
                    }
  
                    break;
                  case "popup_cart_1":
                    Shopify.getCart((cart) => {
                      halo.updatePopupCart(cart, 1, variantId);
                      halo.updateSidebarCart(cart);
                      $body.addClass("add-to-cart-show");
                      $target.removeClass("is-loading");
                    });
  
                    break;
                }
              }
            });
        };
  
        fetch(window.Shopify.routes.root + "cart.js", {
          method: "GET",
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            const variantId = parseInt(
              $(addToCartForm).serialize().split("id=")[1]
            );
            const item = response.items.find(
              (item) => item.variant_id == variantId
            );
            const currentQuantity = item?.quantity;
            const currentProductId = item?.product_id;
            const moreQuantity = parseInt(
              productForm.find("[data-inventory-quantity]").val()
            );
            const maxQuantity = parseInt(
              productForm
                .find("[data-inventory-quantity]")
                .data("inventory-quantity")
            );
            const saleOutStock =
              (document.getElementById("product-add-to-cart").dataset
                .available ===
                "true") |
              false;
  
            if (!currentQuantity || !maxQuantity || saleOutStock)
              return addItemToCart(variantId);
            var arrayInVarName = `selling_array_${currentProductId}`,
              itemInArray = window[arrayInVarName],
              itemStatus = itemInArray[variantId];
            if (itemStatus == "deny") {
              if (currentQuantity + moreQuantity > maxQuantity) {
                const remainingQuantity = maxQuantity - currentQuantity;
                throw new Error(
                  `You ${
                    remainingQuantity > 0
                      ? `can only add ${remainingQuantity}`
                      : "cannot add"
                  } more of the items into the cart`
                );
              } else {
                addItemToCart(variantId);
              }
            } else {
              addItemToCart(variantId);
            }
          })
          .catch((err) => {
            this.showWarning(err);
          })
          .finally(() => {
            $target.removeClass("is-loading");
          });
      },
  
      checkSufficientStock: function (productForm) {
        const maxValidQuantity = productForm
          .find("[data-inventory-quantity]")
          .data("inventory-quantity");
        const inputQuantity = parseInt(
          productForm.find("[data-inventory-quantity]").val()
        );
  
        return maxValidQuantity >= inputQuantity;
      },
  
      updateContentQuickshopOption3: function (handle) {
        var quickShopPopup = $("#halo-quickshop-popup-option-3"),
          quickShopPopupContent = quickShopPopup.find(".halo-popup-content");
  
        $.ajax({
          type: "get",
          url:
            window.routes.root + "/products/" + handle + "?view=ajax_quick_shop",
          beforeSend: function () {
            $("[data-quick-view-popup] .halo-popup-content").empty();
          },
          success: function (data) {
            quickShopPopupContent.html(data);
          },
          error: function (xhr, text) {
            // alert($.parseJSON(xhr.responseText).description);
            halo.showWarning($.parseJSON(xhr.responseText).description);
          },
          complete: function () {
            var $scope = quickShopPopup.find(".quickshop");
  
            halo.productImageGallery($scope);
            setTimeout(() => {
              $body.addClass("quickshop-popup-show");
            }, 150);
          },
        });
      },
  
      appendProductQuickShopOption2: function (product) {
        //  Append Product Popup Quick Shop 2 Show Mobile
        if (window.innerWidth <= 767) {
          var quickshopMobilePopup = $doc.find("#halo-card-mobile-popup");
          var quickshopForm = product.clone();
          quickshopMobilePopup.find(".halo-popup-content").empty();
          quickshopForm.find(".card-product__group").remove();
          quickshopMobilePopup.find(".halo-popup-content").append(quickshopForm);
  
          var form = quickshopMobilePopup.find("[data-quickshop] form").eq("0");
          var mobilePopupId = form.attr("id") + "mobile";
          form.attr("id", mobilePopupId);
          var optionInputs = form.find(".single-option");
          var optionLabels = form.find(".single-label");
  
          optionInputs.each((index, optionInput) => {
            $(optionInput).attr("id", $(optionInput).attr("id") + "-mobile");
          });
  
          optionLabels.each((index, optionLabel) => {
            $(optionLabel).attr("for", $(optionLabel).attr("for") + "-mobile");
          });
  
          quickshopMobilePopup.addClass("show");
  
          $doc.on("click", (e) => {
            var $target = $(e.target);
            if ($target.hasClass("background-overlay")) {
              quickshopMobilePopup.removeClass("show");
              $body.removeClass("quick_shop_popup_mobile");
              product.removeClass("quickshop-popup-show");
            }
          });
        }
      },
  
      isRunningInIframe: function () {
        try {
          return window.self !== window.top;
        } catch (e) {
          return true;
        }
      },
  
      redirectTo: function (url) {
        if (halo.isRunningInIframe() && !window.iframeSdk) {
          window.top.location = url;
        } else {
          window.location = url;
        }
      },
  
      initQuickCart: function () {
        if (window.quick_cart.show) {
          if (window.quick_cart.type == "popup") {
            // halo.initDropdownCart();
          } else {
            halo.initSidebarCart();
          }
        }
  
        halo.initEventQuickCart();
      },
  
      initEventQuickCart: function () {
        halo.removeItemQuickCart();
        halo.updateQuantityItemQuickCart();
        halo.editQuickCart();
      },
  
      productCollectionCartSlider: function () {
        var productCart = $("[data-product-collection-cart]");
  
        productCart.each((index, element) => {
          var self = $(element),
            productGrid = self.find(".products-carousel"),
            itemDots = productGrid.data("item-dots"),
            itemArrows = productGrid.data("item-arrows");
  
          if (productGrid.length > 0) {
                 console.log('hthis is the lcarasule 888888')
            if (!productGrid.hasClass("slick-initialized")) {
              productGrid.slick({
                mobileFirst: true,
                adaptiveHeight: false,
                infinite: false,
                vertical: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: [
                  {
                    breakpoint: 1025,
                    settings: {
                      dots: itemDots,
                      arrows: itemArrows,
                    },
                  },
                ],
              });
            }
          }
        });
      },
  
      updatePopupCart: function (cart, layout, variantId) {
        var item = cart.items.filter((item) => item.id == variantId)[0],
          popup = $("[data-add-to-cart-popup]"),
          product = popup.find(".product-added"),
          productTitle = product.find(".product-title"),
          productImage = product.find(".product-image"),
          title = item.title || item.product_title,
          image = item.featured_image,
          img =
            '<img src="' +
            image.url +
            '" alt="' +
            image.alt +
            '" title="' +
            image.alt +
            '"/>';
  
        productImage.attr("href", item.url).html(img);
  
        productTitle.find(".title").attr("href", item.url).empty().append(title);
  
        Shopify.getCart((cartTotal) => {
          $body.find("[data-cart-count]").text(cartTotal.item_count);
        });
      },
  
      initSidebarCart: function () {
        var cartIcon = $("[data-cart-sidebar]");
        let checkInitSideBarCart = true;
        cartIcon.on("click", () => {
          if (!checkInitSideBarCart) return;
          checkInitSideBarCart = false;
          Shopify.getCart((cart) => {
            halo.updateSidebarCart(cart);
          });
        });
        if ($body.hasClass("template-cart")) {
          cartIcon.on("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              700
            );
          });
        } else {
          cartIcon.on("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            $body.addClass("cart-sidebar-show");
          });
        }
  
        $doc.on("click", "[data-close-cart-sidebar]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          if ($body.hasClass("cart-sidebar-show")) {
            $body.removeClass("cart-sidebar-show");
          }
        });
  
        $body.on("click", ".background-overlay", (event) => {
          if (
            $body.hasClass("cart-sidebar-show") &&
            !$body.hasClass("edit-cart-show") &&
            !$body.hasClass("term-condition-show") &&
            !$body.hasClass("has-warning")
          ) {
            if (
              $(event.target).closest("#halo-cart-sidebar").length === 0 &&
              $(event.target).closest("[data-cart-sidebar]").length === 0 &&
              $(event.target).closest("[data-edit-cart-popup]").length === 0 &&
              $(event.target).closest("[data-warning-popup]").length === 0 &&
              $(event.target).closest("[data-term-condition-popup]").length === 0
            ) {
              $body.removeClass("cart-sidebar-show");
            }
          }
        });
      },
  
      updateSidebarCart: function (cart) {
        if (!$.isEmptyObject(cart)) {
          const $cartDropdown = $(
            "#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"
          );
          const $cartLoading =
            '<div class="loading-overlay loading-overlay--custom">\
                          <div class="loading-overlay__spinner">\
                              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                              </svg>\
                          </div>\
                      </div>';
          const loadingClass = "is-loading";
  
          $cartDropdown.addClass(loadingClass).prepend($cartLoading);
  
          $.ajax({
            type: "GET",
            url: window.routes.root + "/cart?view=ajax_side_cart",
            cache: false,
            success: function (data) {
              var response = $(data);
  
              $cartDropdown.removeClass(loadingClass).html(response);
  
              halo.dispatchChangeForShippingMessage();
            },
            error: function (xhr, text) {
              halo.showWarning($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
              $body.find("[data-cart-count]").text(cart.item_count);
              halo.productCollectionCartSlider();
              halo.updateGiftWrapper();
              if (halo.checkNeedToConvertCurrency()) {
                Currency.convertAll(
                  window.shop_currency,
                  $("#currencies .active").attr("data-currency"),
                  "span.money",
                  "money_format"
                );
              }
              document.dispatchEvent(
                new CustomEvent("cart-update", { detail: cart })
              );
            },
          });
        }
      },
  
      dispatchChangeForShippingMessage: function () {
        document
          .querySelectorAll("[data-free-shipping-wrapper]")
          .forEach((freeShippingWrapper) => {
            const changeEvent = new Event("change", { bubbles: true });
            freeShippingWrapper.dispatchEvent(changeEvent);
          });
      },
  
      updateGiftWrapper: function () {
        let debounce;
        $("#gift-wrapping")
          .off("click")
          .on("click", (event) => {
            event.stopPropagation();
            event.preventDefault();
            const $target = $(event.currentTarget);
            clearTimeout(debounce);
            debounce = setTimeout(() => {
              const variantId = event.target.dataset.giftId;
              Shopify.addItem(variantId, 1, $target, () => {
                Shopify.getCart((cart) => {
                  halo.updateSidebarCart(cart);
                });
              });
            }, 250);
          });
  
        $("#cart-gift-wrapping")
          .off("click")
          .on("click", (event) => {
            event.stopPropagation();
            event.preventDefault();
  
            var $target = $(event.currentTarget),
              text = $target.attr("data-adding-text");
            $target.text(text);
  
            clearTimeout(debounce);
            debounce = setTimeout(() => {
              const variantId = event.target.dataset.giftId;
              Shopify.addItem(variantId, 1, $target, () => {
                Shopify.getCart((cart) => {
                  halo.updateCart(cart);
                });
              });
            }, 250);
          });
      },
  
      removeItemQuickCart: function () {
  $doc.on("click", "[data-cart-remove]", (event) => {
      console.log('click-remove');
      event.preventDefault();
      event.stopPropagation();
  
      var $target = $(event.currentTarget),
          productId = $target.attr("data-cart-remove-id"),
          text = $("#cart-gift-wrapping").attr("data-add-text"),
          productLine = $target.data("line");
  
      console.log('Removing product with line:', productLine); // Log the product line
      $("#cart-gift-wrapping").text(text);
  
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { id: productLine, quantity: 0 },
          dataType: 'json',
          success: function(cart) {
              console.log('Product removed, cart updated:', cart); // Log the updated cart object
  
              if ($body.hasClass("template-cart")) {
                  halo.updateCart(cart);
              } else if ($body.hasClass("cart-modal-show")) {
              } else if ($body.hasClass("cart-sidebar-show")) {
                  halo.updateSidebarCart(cart);
              } else {
                  console.warn('No valid cart update method found for current page template.');
              }
          },
          error: function(jqXHR, textStatus, errorThrown) {
              console.error('Error removing item:', textStatus, errorThrown);
              console.error('Response:', jqXHR.responseText);
          }
      });
  });
      },
  
      updateCart: function (cart) {
        if (!$.isEmptyObject(cart)) {
          const $sectionId = $("#main-cart-items").data("id");
          const $cart = $("[data-cart]");
          const $cartContent = $cart.find("[data-cart-content]");
          const $cartTotals = $cart.find("[data-cart-total]");
          const $cartLoading =
            '<div class="loading-overlay loading-overlay--custom">\
                          <div class="loading-overlay__spinner">\
                              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                              </svg>\
                          </div>\
                      </div>';
          const loadingClass = "is-loading";
  
          $cart.addClass(loadingClass).prepend($cartLoading);
  
          $.ajax({
            type: "GET",
            url: `/cart?section_id=${$sectionId}`,
            cache: false,
            success: function (data) {
              var jsPreventedData = data.replaceAll(
                "cart-coupon-discount",
                "div"
              );
              var response = $(jsPreventedData);
  
              $cart.removeClass(loadingClass);
              $cart.find(".loading-overlay").remove();
  
              if (cart.item_count > 0) {
                var contentCart = response
                    .find("[data-cart-content] .cart")
                    .html(),
                  subTotal = response
                    .find("[data-cart-total] .cart-total-subtotal")
                    .html(),
                  grandTotal = response
                    .find("[data-cart-total] .cart-total-grandtotal")
                    .html(),
                  savings = response
                    .find("[data-cart-total] .cart-total-savings")
                    .html();
  
                $cartContent.find(".cart").html(contentCart);
                $cartTotals.find(".cart-total-subtotal").html(subTotal);
                $cartTotals.find(".cart-total-grandtotal").html(grandTotal);
                $cartTotals.find(".cart-total-savings").html(savings);
  
                if (response.find(".haloCalculatorShipping").length > 0) {
                  var calculatorShipping = response.find(
                    ".haloCalculatorShipping"
                  );
  
                  $cart
                    .find(".haloCalculatorShipping")
                    .replaceWith(calculatorShipping);
                }
              } else {
                var contentCart = response.find("#main-cart-items").html(),
                  headerCart = response.find(".page-header").html();
                cartCountdownText1 = response
                  .find(".cart-countdown")
                  .data("coundown-text-empty-1");
                cartCountdownText2 = response
                  .find(".cart-countdown")
                  .data("coundown-text-empty-2");
                cartCountdownProductUrl = response
                  .find(".cart-countdown")
                  .data("coundown-prd-empty-url");
                cartCountdownProductTitle = response
                  .find(".cart-countdown")
                  .data("coundown-prd-empty-title");
                var cartCountdownHtml =
                  cartCountdownText1 +
                  ' <a href="' +
                  cartCountdownProductUrl +
                  '" class="cart-countdown-product link-effect p-relative"><span class="text">' +
                  cartCountdownProductTitle +
                  "</span></a> " +
                  cartCountdownText2;
  
                $("#main-cart-items").html(contentCart);
                $(".page-header").html(headerCart);
                $(".cart-countdown .text-wrap").html(cartCountdownHtml);
              }
            },
            error: function (xhr, text) {
              halo.showWarning($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
              $body.find("[data-cart-count]").text(cart.item_count);
              halo.dispatchChangeForShippingMessage();
              if (halo.checkNeedToConvertCurrency()) {
                Currency.convertAll(
                  window.shop_currency,
                  $("#currencies .active").attr("data-currency"),
                  "span.money",
                  "money_format"
                );
              }
              if ($body.hasClass("template-cart")) {
                const giftWrapping =
                  document.getElementById("cart-gift-wrapping");
                const isChecked = giftWrapping?.dataset.isChecked;
                const variantId = giftWrapping?.dataset.giftId;
                if (isChecked === "true") {
                  $("#is-a-gift").hide();
                  const giftCardRemoveButton = document.querySelector(
                    `[data-cart-remove-id="${variantId}"]`
                  );
                  const giftCardQuantityInput = document.querySelector(
                    `[data-cart-quantity-id="${variantId}"]`
                  );
  
                  giftCardRemoveButton?.addEventListener("click", () => {
                    giftWrapping.dataset.isChecked = "false";
                  });
  
                  giftCardQuantityInput?.addEventListener("change", (e) => {
                    const value = Number(e.target.value);
                    if (value <= 0) {
                      giftWrapping.dataset.isChecked = "false";
                    }
                  });
                } else {
                  $("#is-a-gift").show();
                }
              }
  
              document.dispatchEvent(
                new CustomEvent("cart-update", { detail: cart })
              );
            },
          });
        }
      },
  
      updateQuantityItemQuickCart: function () {
  $doc.on("change", "[data-cart-quantity]", (event) => {
      console.log('change_invento');
      event.preventDefault();
      event.stopPropagation();
  
      var $target = $(event.currentTarget),
          productId = $target.attr("data-cart-quantity-id"),
          productLine = $target.data("line"),
          quantity = parseInt($target.val()),
          stock = parseInt($target.data("inventory-quantity"));
      let enoughInStock = true;
  
      if (stock < quantity && stock > 0) {
          var arrayInVarName = `cart_selling_array_${
              event.currentTarget.closest(".cart-update-quantity").dataset.product
          }`,
          itemInArray = window[arrayInVarName],
          itemStatus =
              itemInArray[
                  event.currentTarget.closest(".cart-update-quantity").dataset.variant
              ];
          if (itemStatus == "deny") {
              quantity = stock;
              enoughInStock = false;
          }
      }
  
      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
              id: productLine,
              quantity: quantity
          },
          dataType: 'json',
          success: function(cart) {
              console.log('Cart updated:', cart); // Log the updated cart object
  
              if ($body.hasClass("template-cart")) {
                  halo.updateCart(cart);
              } else if ($body.hasClass("cart-modal-show")) {
                  // Uncomment this if the dropdown cart is being used
                  // halo.updateDropdownCart(cart);
              } else if ($body.hasClass("cart-sidebar-show")) {
                  halo.updateSidebarCart(cart);
              }
              if (!enoughInStock) {
                  halo.showWarning(
                      `${window.cartStrings.addProductOutQuantity.replace(
                          "[maxQuantity]",
                          quantity
                      )}`
                  );
              }
          },
          error: function(jqXHR, textStatus, errorThrown) {
              console.error('Error updating cart:', textStatus, errorThrown);
              console.error('Response:', jqXHR.responseText);
          }
      });
  });
  
      },
  
      editQuickCart: function () {
        let checkLoadEC = true;
  
        $doc.on("click", "[data-open-edit-cart]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var $target = $(event.currentTarget),
            url = $target.data("edit-cart-url"),
            itemId = $target.data("edit-cart-id"),
            itemLine = $target.data("line"),
            quantity = $target.data("edit-cart-quantity"),
            option = $target
              .parents(".previewCartItem")
              .find("previewCartItem-variant")
              .text();
  
          const modal = $("[data-edit-cart-popup]"),
            modalContent = modal.find(".halo-popup-content");
  
          if (checkLoadEC) {
            checkLoadEC = false;
            const $editCart = document.querySelector(".halo-edit-cart-popup");
            const urlStyleEC = $editCart.dataset.urlStyleEditCart;
            const urlScriptEC = $editCart.dataset.urlScriptEditCart;
  
            halo.buildStyleSheet(urlStyleEC, $editCart);
            halo.buildScript(urlScriptEC);
          }
  
          $.ajax({
            type: "get",
            url: url,
            cache: false,
            dataType: "html",
            beforeSend: function () {
              if ($body.hasClass("template-cart")) {
                // halo.showLoading();
              }
            },
            success: function (data) {
              modalContent.html(data);
              modalContent.find("[data-template-cart-edit]").attr({
                "data-cart-update-id": itemId,
                "data-line": itemLine,
              });
  
              var productItem = modalContent.find(".product-edit-item");
              productItem.find('input[name="quantity"]').val(quantity);
            },
            error: function (xhr, text) {
              // alert($.parseJSON(xhr.responseText).description);
              halo.showWarning($.parseJSON(xhr.responseText).description);
              if ($body.hasClass("template-cart")) {
                // halo.hideLoading();
              }
            },
            complete: function () {
              $body.addClass("edit-cart-show");
  
              if ($body.hasClass("template-cart")) {
                // halo.hideLoading();
              }
  
              if (halo.checkNeedToConvertCurrency()) {
                Currency.convertAll(
                  window.shop_currency,
                  $("#currencies .active").attr("data-currency"),
                  "span.money",
                  "money_format"
                );
              }
            },
          });
        });
  
        $doc.on("click", "[data-close-edit-cart]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.removeClass("edit-cart-show");
        });
  
        $doc.on("click", (event) => {
          if ($body.hasClass("edit-cart-show")) {
            if (
              $(event.target).closest("[data-edit-cart-popup]").length === 0 &&
              $(event.target).closest("[data-open-edit-cart]").length === 0
            ) {
              $body.removeClass("edit-cart-show");
            }
          }
        });
  
        halo.addMoreItemEditCart();
        halo.addAllItemCartEdit();
      },
  
      addMoreItemEditCart: function () {
        $doc.on("click", "[data-edit-cart-add-more]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var itemWrapper = $("[data-template-cart-edit]"),
            currentItem = $(event.target).parents(".product-edit-item"),
            count = parseInt(itemWrapper.attr("data-count")),
            cloneProduct = currentItem
              .clone()
              .removeClass("product-edit-itemFirst");
          cloneProductId = cloneProduct.attr("id") + count;
  
          cloneProduct.attr("id", cloneProductId);
  
          console.log(cloneProductId);
  
          halo.updateClonedProductAttributes(cloneProduct, count);
  
          cloneProduct.insertAfter(currentItem);
  
          count = count + 1;
          itemWrapper.attr("data-count", count);
        });
  
        $doc.on("click", "[data-edit-cart-remove]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var currentItem = $(event.target).parents(".product-edit-item");
  
if (currentItem && typeof currentItem.remove === "function") currentItem.remove();
        });
      },
  
      updateClonedProductAttributes: function (product, count) {
        var form = $(".shopify-product-form", product),
          formId = form.attr("id"),
          newFormId = formId + count;
  
        form.attr("id", newFormId);
  
        $(".product-form__radio", product).each((index, element) => {
          var formInput = $(element),
            formLabel = formInput.next(),
            id = formLabel.attr("for"),
            newId = id + count,
            formInputName = formInput.attr("name");
  
          formLabel.attr("for", newId);
  
          formInput.attr({
            id: newId,
            name: formInputName + count,
          });
        });
      },
  
      addAllItemCartEdit: function () {
  $doc.on("click", "#add-all-to-cart", (event) => {
      event.preventDefault();
      event.stopPropagation();
  
      var $target = $(event.currentTarget),
          cartEdit = $("[data-template-cart-edit]"),
          product = cartEdit.find(".product-edit-item.isChecked"),
          productLine = cartEdit.data("line"); // Assume this is the line to be removed
  
      if (product.length > 0) {
          $target.addClass("is-loading");
  
          // First, remove the existing product
          $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {
                  id: productLine,
                  quantity: 0
              },
              dataType: 'json',
              success: function(cart) {
                  var productHandleQueue = [];
  
                  var ajax_caller = function(data) {
                      return $.ajax(data);
                  };
  
                  // After removing, add the new products
                  product.each((index, element) => {
                      var item = $(element),
                          variantId = item.find('input[name="id"]').val(),
                          qty = parseInt(item.find('input[name="quantity"]').val());
  
                      productHandleQueue.push(
                          ajax_caller({
                              type: "POST",
                              url: window.routes.root + "/cart/add.js",
                              data: {
                                  quantity: qty,
                                  id: variantId
                              },
                              dataType: "json"
                          })
                      );
                  });
  
                  if (productHandleQueue.length > 0) {
                      $.when.apply($, productHandleQueue).done(() => {
                          setTimeout(function() {
                              $target.removeClass("is-loading");
                          }, 1000);
  
                          $.getJSON('/cart.js', function(cart) {
                              $body.removeClass("edit-cart-show");
  
                              if ($body.hasClass("template-cart")) {
                                  halo.updateCart(cart);
                              } else if ($body.hasClass("cart-modal-show")) {
                                  // Uncomment this if the dropdown cart is being used
                                  // halo.updateDropdownCart(cart);
                              } else if ($body.hasClass("cart-sidebar-show")) {
                                  halo.updateSidebarCart(cart);
                              }
                          });
                      }).fail((jqXHR, textStatus, errorThrown) => {
                          console.error('Error adding item:', textStatus, errorThrown);
                          console.error('Response:', jqXHR.responseText);
                          $target.removeClass("is-loading");
                      });
                  }
              },
              error: function(jqXHR, textStatus, errorThrown) {
                  console.error('Error removing item:', textStatus, errorThrown);
                  console.error('Response:', jqXHR.responseText);
                  $target.removeClass("is-loading");
              }
          });
      } else {
          alert(window.variantStrings.addToCart_message);
      }
  });
      },
  
      initNotifyInStock: function () {
        $doc.on("click", "[data-open-notify-popup]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var $target = $(event.currentTarget);
  
          halo.notifyInStockPopup($target);
        });
  
        $doc.on("click", "[data-close-notify-popup]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.removeClass("notify-me-show");
          setTimeout(() => {
            $(".halo-notify-popup .form-field").removeClass("hidden");
            $(".halo-notify-popup .form-message").addClass("hidden");
          }, 700);
        });
  
        $doc.on("click", (event) => {
          if ($body.hasClass("notify-me-show")) {
            if (
              $(event.target).closest("[data-open-notify-popup]").length === 0 &&
              $(event.target).closest("[data-notify-popup]").length === 0
            ) {
              $body.removeClass("notify-me-show");
              setTimeout(() => {
                $(".halo-notify-popup .form-field").removeClass("hidden");
                $(".halo-notify-popup .form-message").addClass("hidden");
              }, 700);
            }
          }
        });
      },
  
      notifyInStockPopup: function ($target) {
        var variant,
          product = $target.parents(".product-item"),
          title = product.find(".card-title").data("product-title"),
          link =
            window.location.host +
            product.find(".card-title").data("product-url"),
          popup = $("[data-notify-popup]");
  
        if ($target.hasClass("is-notify-me")) {
          variant = product
            .find(".card-swatch .swatch-label.is-active")
            .attr("title");
        } else {
          variant = $target.data("variant-id");
        }
  
        popup.find(".halo-notify-product-title").val($.trim(title));
        popup.find(".halo-notify-product-link").val(link);
  
        if (variant) {
          popup.find(".halo-notify-product-variant").val(variant);
        }
        $body.addClass("notify-me-show");
      },
  
      initAskAnExpert: function () {
        $doc.on("click", "[data-open-ask-an-expert]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var askAnExpert = $("[data-ask-an-expert-popup]"),
            modalContent = askAnExpert.find(".halo-popup-content"),
            url;
  
          if ($body.hasClass("template-product")) {
            var handle = $(".productView").data("product-handle");
  
            url =
              window.routes.root +
              "/products/" +
              handle +
              "?view=ajax_ask_an_expert";
          } else if ($body.hasClass("quick-view-show")) {
            var handle = $(".halo-quickView").data("product-quickview-handle");
  
            url =
              window.routes.root +
              "/products/" +
              handle +
              "?view=ajax_ask_an_expert";
          } else {
            url = window.routes.root + "/search?view=ajax_ask_an_expert";
          }
  
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function () {
              modalContent.empty();
            },
            success: function (data) {
              modalContent.html(data);
            },
            error: function (xhr, text) {
              alert($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
              $body.addClass("ask-an-expert-show");
            },
          });
        });
  
        $doc.on("click", "[data-close-ask-an-expert]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.removeClass("ask-an-expert-show");
          if ($body.hasClass("recently-popup-mb-show")) {
            $body.removeClass("recently-popup-mb-show");
          }
        });
  
        $doc.on("click", (event) => {
          if ($body.hasClass("ask-an-expert-show")) {
            if (
              $(event.target).closest("[data-open-ask-an-expert]").length === 0 &&
              $(event.target).closest("#halo-ask-an-expert-popup").length === 0
            ) {
              $body.removeClass("ask-an-expert-show");
            }
          }
        });
      },
  
      resetForm: function (form) {
        $(".form-field", form).removeClass(
          "form-field--success form-field--error"
        );
        $("input[type=email], input[type=text], textarea", form).val("");
      },
  
      formMessage: function () {
        const error = window.location.href.indexOf("form_type=contact") > -1;
  
        if (window.location.href.indexOf("contact_posted=true") > -1 || error) {
          const formMessage = $(
            `[data-form-message="${$.cookie("contact_form")}"]`
          );
          let delay = 400;
  
          if ($body.hasClass("template-product")) delay = 1600;
  
          switch (formMessage.data("form-message")) {
            case "ask":
              setTimeout(() => {
                $body.addClass("ask-an-expert-show");
              }, delay);
              this.changeStateforContactForm(formMessage, error);
              $(".halo-notify-popup .form-message").addClass("hidden");
              break;
            case "contact":
              formMessage.removeClass("hidden");
              this.changeStateforContactForm(formMessage, error);
              $(".halo-notify-popup .form-message").addClass("hidden");
              break;
            case "notifyMe":
              $(".halo-notify-popup .form-field").addClass("hidden");
              setTimeout(() => {
                $body.addClass("notify-me-show");
              }, delay);
              this.changeStateforContactForm(formMessage, error);
              break;
          }
        }
  
        $(document).on("click", "[data-button-message]", (event) => {
          $.cookie("contact_form", $(event.target).data("button-message"), {
            expires: 1,
            path: "/",
          });
        });
      },
  
      changeStateforContactForm(formMessage, error) {
        window.history.pushState(
          "object",
          document.title,
          location.href.split("?")[0]
        );
        if (error) {
          $(".newsletter-form__message--error").addClass("hidden");
          $("html, body").animate(
            { scrollTop: formMessage.offset().top - window.innerHeight / 2 },
            700
          );
        }
      },
  
      initCompareProduct: function () {
        var $compareLink = $("[data-compare-link]");
  
        if (window.compare.show) {
          halo.setLocalStorageProductForCompare($compareLink);
          halo.setAddorRemoveProductForCompare($compareLink);
          halo.setProductForCompare();
  
          $doc.on("click", "[data-close-compare-product-popup]", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            $body.removeClass("compare-product-show");
          });
  
          $doc.on("click", (event) => {
            if ($body.hasClass("compare-product-show")) {
              if (
                $(event.target).closest("[data-compare-link]").length === 0 &&
                $(event.target).closest("[data-compare-product-popup]").length ===
                  0
              ) {
                $body.removeClass("compare-product-show");
              }
            }
          });
        }
      },
  
      setLocalStorageProductForCompare: function ($link) {
        var count = JSON.parse(localStorage.getItem("compareItem")),
          items = $("[data-product-compare-handle]");
  
        if (count !== null) {
          if (items.length > 0) {
            items.each((index, element) => {
              var item = $(element),
                handle = item.data("product-compare-handle");
  
              if (count.indexOf(handle) >= 0) {
                item.find(".compare-icon").addClass("is-checked");
                item.find(".text").text(window.compare.added);
                item.find("input").prop("checked", true);
              } else {
                item.find(".compare-icon").removeClass("is-checked");
                item.find(".text").text(window.compare.add);
                item.find("input").prop("checked", false);
              }
            });
  
            halo.updateCounterCompare($link);
          }
        }
      },
  
      setAddorRemoveProductForCompare: function ($link) {
        $doc.on("change", "[data-product-compare] input", (event) => {
          var $this = $(event.currentTarget),
            item = $this.parents(".card-compare"),
            handle = $this.val(),
            count = JSON.parse(localStorage.getItem("compareItem"));
  
          count = halo.uniqueArray(count);
  
          if (event.currentTarget.checked) {
            item.find(".compare-icon").addClass("is-checked");
            item.find(".text").text(window.compare.added);
            item.find("input").prop("checked", true);
            halo.incrementCounterCompare(count, handle, $link);
          } else {
            item.find(".compare-icon").removeClass("is-checked");
            item.find(".text").text(window.compare.add);
            item.find("input").prop("checked", false);
            halo.decrementCounterCompare(count, handle, $link);
          }
        });
      },
  
      setProductForCompare: function () {
        $doc.on("click", "[data-compare-link]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var list = JSON.parse(localStorage.getItem("compareItem"));
  
          if (list.length <= 1) {
            alert(window.compare.message);
  
            return false;
          } else {
            halo.updateContentCompareProduct(list, 0);
          }
        });
  
        $doc.on("click", "[data-compare-remove]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var id = $(event.currentTarget).data("compare-item"),
            compareTable = $("[data-compare-product-popup] .compareTable"),
            item = compareTable.find(
              '.compareTable-row[data-product-compare-id="' + id + '"]'
            ),
            handle = item.data("compare-product-handle");
  
          if (compareTable.find("tbody .compareTable-row").length == 1) {
            // alert(window.compare.message);
if (item && typeof item.remove === "function") item.remove();
            var count = JSON.parse(localStorage.getItem("compareItem")),
              index = count.indexOf(handle),
              $compareLink = $("[data-compare-link]");
  
            if (index > -1) {
              count.splice(index, 1);
              count = halo.uniqueArray(count);
              localStorage.setItem("compareItem", JSON.stringify(count));
  
              halo.setLocalStorageProductForCompare($compareLink);
              halo.updateCounterCompare($compareLink);
            }
  
            $body.removeClass("compare-product-show");
          } else {
if (item && typeof item.remove === "function") item.remove();
  
            var count = JSON.parse(localStorage.getItem("compareItem")),
              index = count.indexOf(handle),
              $compareLink = $("[data-compare-link]");
  
            if (index > -1) {
              count.splice(index, 1);
              count = halo.uniqueArray(count);
              localStorage.setItem("compareItem", JSON.stringify(count));
  
              halo.setLocalStorageProductForCompare($compareLink);
              halo.updateCounterCompare($compareLink);
            }
          }
        });
      },
  
      updateCounterCompare: function ($link) {
        var count = JSON.parse(localStorage.getItem("compareItem"));
  
        if (count.length > 1) {
          $link.parent().addClass("is-show");
          $link.find("span.countPill").html(count.length);
        } else {
          $link.parent().removeClass("is-show");
        }
      },
  
      uniqueArray: function (list) {
        var result = [];
  
        $.each(list, function (index, element) {
          if ($.inArray(element, result) == -1) {
            result.push(element);
          }
        });
  
        return result;
      },
  
      incrementCounterCompare: function (count, item, $link) {
        const index = count.indexOf(item);
  
        count.push(item);
        count = halo.uniqueArray(count);
  
        localStorage.setItem("compareItem", JSON.stringify(count));
  
        halo.updateCounterCompare($link);
      },
  
      decrementCounterCompare: function (count, item, $link) {
        const index = count.indexOf(item);
  
        if (index > -1) {
          count.splice(index, 1);
          count = halo.uniqueArray(count);
          localStorage.setItem("compareItem", JSON.stringify(count));
  
          halo.updateCounterCompare($link);
        }
      },
  
      updateContentCompareProduct: function (list, count) {
        const compareTable = $("[data-compare-product-popup] .compareTable"),
          url =
            window.routes.root +
            "/products/" +
            list[count] +
            "?view=ajax_product_card_compare";
  
        if (count == 0) compareTable.find("tbody").empty();
  
        if (list.length > count) {
          $.ajax({
            type: "get",
            url: url,
            cache: false,
            success: function (data) {
              compareTable.find("tbody").append(data);
              count++;
              halo.updateContentCompareProduct(list, count);
            },
          });
        } else {
          $body.addClass("compare-product-show");
        }
      },
  
      initProductView: function ($scope) {
       // halo.productImageGallery($scope);
        halo.productLastSoldOut($scope);
        halo.productCustomerViewing($scope);
        halo.productCountdown($scope);
        halo.productSizeChart($scope);
        halo.productCustomCursor($scope);
        halo.productVideoGallery($scope);
        halo.initVariantImageGroup($scope, window.variant_image_group);
      },
  
      initQuickView: function () {
        let checkLoadQV = true;
  
        $doc.on("click", "[data-open-quick-view-popup]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          if (checkLoadQV) {
            checkLoadQV = false;
            const $quickView = document.querySelector(".halo-quick-view-popup");
            const urlStyleProduct = $quickView.dataset.urlStyleProduct;
            const urlStyleQV = $quickView.dataset.urlStyleQuickView;
            const urlVariantsQV = $quickView.dataset.urlVariantsQuickView;
            const urlSortable =
              "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js";
  
            if (!document.body.matches(".qs3-loaded"))
              halo.buildStyleSheet(urlStyleProduct, $quickView);
            halo.buildStyleSheet(urlStyleQV, $quickView);
            halo.buildScript(urlVariantsQV);
            document.body.classList.add("qv-loaded");
            if (!document.body.matches(".sortable-loader")) {
              document.body.classList.add("sortable-loader");
              halo.buildScript(urlSortable);
            }
          }
  
          var handle = $(event.currentTarget).data("product-handle");
  
          halo.updateContentQuickView(handle);
        });
  
        $doc.on("click", "[data-close-quick-view-popup]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.removeClass("quick-view-show");
        });
  
        $(".background-overlay")
          .off("click.closeQuickView")
          .on("click.closeQuickView", (e) => {
            if (
              $body.hasClass("quick-view-show") &&
              !$body.hasClass("cart-sidebar-show") &&
              !$body.hasClass("ask-an-expert-show") &&
              !$body.hasClass("size-chart-show") &&
              !$body.hasClass("compare-color-show") &&
              !$body.hasClass("term-condition-show")
            ) {
              $body.removeClass("quick-view-show");
            }
          });
      },
  
      updateContentQuickView: function (handle) {
        var popup = $("[data-quick-view-popup]"),
          popupContent = popup.find(".halo-popup-content");
  
        $.ajax({
          type: "get",
          url:
            window.routes.root + "/products/" + handle + "?view=ajax_quick_view",
          beforeSend: function () {
            popupContent.empty();
            $("#halo-quickshop-popup-option-3")
              .find(".halo-popup-content")
              .empty();
          },
          success: function (data) {
            popupContent.html(data);
          },
          error: function (xhr, text) {
            alert($.parseJSON(xhr.responseText).description);
          },
          complete: function () {
            var $scope = popup.find(".quickView");
            const items = $(
                ".halo-popup-content .halo-compare-color-popup li.item"
              ),
              tableList = $(
                ".halo-popup-content .halo-compare-color-popup #sortTableList"
              ),
              compareColorPopup = $(
                ".halo-popup-content .halo-compare-color-popup"
              ),
              sizeChartPopup = $(".halo-popup-content .halo-size-chart-popup");
  
            halo.productImageGallery($scope);
            halo.productLastSoldOut($scope);
            halo.productCustomerViewing($scope);
            halo.productCountdown($scope);
            halo.productSizeChart($scope);
            halo.setProductForWishlist(handle);
            halo.initVariantImageGroup(
              $scope,
              window.variant_image_group_quick_view
            );
  
            $body.addClass("quick-view-show");
  
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            tableList.attr("id", "quickViewSortTableList");
  
            items.each((index, element) => {
              const itemInput = $(element).find(".swatch-compare-color-option"),
                itemLabel = $(element).find(".swatch-compare-color-label"),
                itemId = itemInput.attr("id");
  
              itemInput
                .attr("id", `quickView-${itemId}`)
                .attr("name", `quickView-${itemId}`);
              itemLabel.attr("for", `quickView-${itemId}`);
            });
  
            compareColorPopup.attr("id", "quickView-halo-compare-color-popup");
            sizeChartPopup.attr("id", "quickView-halo-size-chart-popup");
  
            if ($(".halo-productView .addthis_inline_share_toolbox").length) {
              var html = $(
                ".halo-productView .addthis_inline_share_toolbox"
              ).html();
  
              $(".halo-popup-content .share-button__button").click(function () {
                $(".halo-popup-content .addthis_inline_share_toolbox").append(
                  html
                );
              });
            }
  
            const thisSortTable = document.getElementById(
              "quickViewSortTableList"
            );
            const thisImageList = $(
              ".halo-popup-content .halo-compareColors-image"
            );
  
            if (window.innerWidth >= 1025 && thisSortTable) {
              new Sortable(thisSortTable, {
                animation: 150,
              });
            } else {
              onRemoveHandlerQuickView();
            }
  
            function onRemoveHandlerQuickView() {
              thisImageList.on("click", ".item", (event) => {
                event.preventDefault();
  
                var $target = event.currentTarget,
                  itemId = $target.classList[1].replace("item-", ""),
                  optionId = `swatch-compare-color-${itemId}`,
                  item = $(document.getElementById(optionId));
  
                item.trigger("click");
              });
            }
  
            if (
              window.review.show_quick_view &&
              $(".shopify-product-reviews-badge").length > 0 &&
              window.SPR != null &&
              typeof window.SPR.registerCallbacks === "functions"
            ) {
              return (
                window.SPR.registerCallbacks(),
                window.SPR.initRatingHandler(),
                window.SPR.initDomEls(),
                window.SPR.loadProducts(),
                window.SPR.loadBadges()
              );
            }
          },
        });
      },
  
      productImageGallery: function ($scope) {
        var sliderNav = $scope.find(".productView-nav"),
          sliderFor = $scope.find('.productView-for:not(".mobile")'),
          sliderForMobile = $scope.find(".productView-for.mobile");
  
        if (
          !sliderFor.hasClass("slick-initialized") &&
          !sliderNav.hasClass("slick-initialized")
        ) {
               console.log('hthis is the lcarasule 99999')
          const navArrowsDesk = sliderNav.data("arrows-desk"),
            navArrowsMobi = sliderNav.data("arrows-mobi"),
            navCounterMobi = sliderNav.data("counter-mobi"),
            navMediaCount = sliderNav.data("media-count"),
            thumbnailToShow = parseInt(sliderFor.data("max-thumbnail-to-show"));
  
          let checkNav, checkFor, navSlideCount;
  
          var appendTimeout;
  
          sliderNav.hasClass("productView-nav-gallery")
            ? (navSlideCount = Math.round(navMediaCount / 2))
            : (navSlideCount = navMediaCount);
          sliderNav.hasClass("productView-horizontal-tabs") && navMediaCount == 2
            ? (navSlideCount = 1)
            : (navSlideCount = navMediaCount);
          const slickCounter =
            `<div class="slick-counter">
                      <span class="slick-counter--current">1</span>
                      <span aria-hidden="true">/</span>
                      <span class="slick-counter--total">` +
            navSlideCount +
            `</span>
                  </div>`;
  
          sliderNav.on("init", () => {
            if (window.innerWidth < 768 && navCounterMobi) {
              if (variant_image_group == "false") {
                clearTimeout(appendTimeout);
                appendTimeout = setTimeout(() => {
                  sliderNav.append(slickCounter);
                }, 1000);
  
                sliderNav.on(
                  "reInit afterChange",
                  function (event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    sliderNav.find(".slick-counter--current").text(i);
                  }
                );
              }
            }
          });
  
          sliderNav.on("reInit", () => {
            clearTimeout(appendTimeout);
            appendTimeout = setTimeout(() => {
              sliderNav.append(slickCounter);
            }, 1000);
          });
  
          if (sliderNav.closest(".productView").is(".layout-4")) {
            checkFor = false;
          } else {
            checkFor = sliderFor;
          }
  
          if (sliderNav.hasClass("productView-nav-gallery")) {
            var sliderNav2 = $scope.find(
                ".productView-nav.productView-nav-gallery"
              ),
              length = sliderNav2.data("media-count"),
              show = 2,
              rows = 2;
  
            if (length == 1) {
              show = 1;
              rows = 1;
            }
            if (length == 2) {
              show = 2;
              rows = 1;
            }
  
            sliderNav2.slick({
              dots: true,
              rows: rows,
              arrows: navArrowsDesk,
              infinite: true,
              slidesPerRow: 1,
              slidesToShow: show,
              focusOnSelect: false,
              asNavFor: checkFor,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    arrows: navArrowsMobi,
                  },
                },
              ],
            });
          } else if (sliderNav.hasClass("productView-horizontal-tabs")) {
            var sliderNav2 = $scope.find(
                ".productView-nav.productView-horizontal-tabs"
              ),
              show = 2,
              rows = 1;
  
            sliderNav2.slick({
              dots: true,
              rows: rows,
              arrows: navArrowsDesk,
              infinite: true,
              slidesPerRow: 1,
              slidesToShow: show,
              focusOnSelect: false,
              asNavFor: checkFor,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    arrows: navArrowsMobi,
                  },
                },
              ],
            });
          } else {
            if (!sliderNav.is(".style-2, .style-3") || window.innerWidth < 768) {
              sliderNav.slick({
                fade: true,
                dots: false,
                arrows: navArrowsDesk,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: checkFor,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                rtl: window.rtl_slick,
                responsive: [
                  {
                    breakpoint: 768,
                    settings: {
                      arrows: navArrowsMobi,
                    },
                  },
                ],
              });
              checkNav = sliderNav;
            } else {
              checkNav = false;
            }
          }
  
          if ($scope.hasClass("layout-1") || $scope.hasClass("layout-2")) {
            sliderFor.on("init", (event, slick) => {
              sliderFor.find(".animated-loading").removeClass("animated-loading");
            });
  
            sliderFor.slick({
              slidesToShow: thumbnailToShow,
              slidesToScroll: 1,
              asNavFor: checkNav,
              arrows: true,
              dots: false,
              draggable: false,
              adaptiveHeight: false,
              focusOnSelect: true,
              vertical: true,
              verticalSwiping: true,
              infinite: true,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              responsive: [
                {
                  breakpoint: 1600,
                  settings: {
                    slidesToShow:
                      thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 1280,
                  settings: {
                    vertical: false,
                    verticalSwiping: false,
                    rtl: window.rtl_slick,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false,
                    rtl: window.rtl_slick,
                  },
                },
              ],
            });
          } else if ($scope.hasClass("layout-3")) {
            sliderFor.on("init", (event, slick) => {
              sliderFor.find(".animated-loading").removeClass("animated-loading");
            });
  
            sliderFor.slick({
              slidesToShow: thumbnailToShow,
              slidesToScroll: 1,
              asNavFor: checkNav,
              arrows: true,
              dots: false,
              focusOnSelect: true,
              infinite: true,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1600,
                  settings: {
                    slidesToShow:
                      thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }
  
          sliderForMobile.on("init", (event, slick) => {
            sliderForMobile
              .find(".animated-loading")
              .removeClass("animated-loading");
          });
  
          sliderForMobile.slick({
            slidesToShow: parseInt(sliderForMobile.data("max-thumbnail-to-show")),
            slidesToScroll: 1,
            asNavFor: checkNav,
            arrows: true,
            dots: false,
            draggable: false,
            adaptiveHeight: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: true,
            infinite: true,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 1600,
                settings: {
                  slidesToShow:
                    thumbnailToShow > 3 ? thumbnailToShow - 1 : thumbnailToShow,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 1280,
                settings: {
                  vertical: false,
                  verticalSwiping: false,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2.2,
                  slidesToScroll: 1,
                  vertical: false,
                  verticalSwiping: false,
                },
              },
            ],
          });
  
          if ($scope.hasClass("layout-1") || $scope.hasClass("layout-2")) {
            var height_for = sliderFor.outerHeight(),
              height_nav = sliderNav.outerHeight(),
              pos = (height_nav - height_for) / 2,
              pos_disable = pos + 80;
  
            if ($win.width() > 1279) {
              if (sliderFor.find(".slick-arrow").length > 0) {
                sliderFor.parent().addClass("arrows-visible");
                sliderFor.parent().css("top", pos);
              } else {
                sliderFor.parent().addClass("arrows-disable");
                sliderFor.parent().css("top", pos_disable);
              }
            } else {
              if (sliderFor.find(".slick-arrow").length > 0) {
                sliderFor.parent().css("top", "unset");
              } else {
                sliderFor.parent().css("top", pos_disable);
              }
            }
          }
  
          if (sliderNav.find("[data-youtube]").length > 0) {
            if (typeof window.onYouTubeIframeAPIReady === "undefined") {
              window.onYouTubeIframeAPIReady = halo.initYoutubeCarousel.bind(
                window,
                sliderNav
              );
  
              const tag = document.createElement("script");
              tag.src = "https://www.youtube.com/player_api";
              const firstScriptTag = document.getElementsByTagName("script")[0];
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            } else {
              halo.initYoutubeCarousel(sliderNav);
            }
          }
  
          if (sliderNav.find("[data-vimeo]").length > 0) {
            sliderNav.on("beforeChange", (event, slick) => {
              var currentSlide, player, command;
  
              currentSlide = $(slick.$slider).find(".slick-current");
              player = currentSlide.find("iframe").get(0);
  
              command = {
                method: "pause",
                value: "true",
              };
  
              if (player != undefined) {
                player.contentWindow.postMessage(JSON.stringify(command), "*");
              }
            });
  
            sliderNav.on("afterChange", (event, slick) => {
              var currentSlide, player, command;
  
              currentSlide = $(slick.$slider).find(".slick-current");
              player = currentSlide.find("iframe").get(0);
  
              command = {
                method: "play",
                value: "true",
              };
  
              if (player != undefined) {
                player.contentWindow.postMessage(JSON.stringify(command), "*");
              }
            });
          }
  
          if (sliderNav.find("[data-mp4]").length > 0) {
            sliderNav.on("beforeChange", (event, slick) => {
              var currentSlide, player;
  
              currentSlide = $(slick.$slider).find(".slick-current");
              player = currentSlide.find("video").get(0);
  
              if (player != undefined) {
                player.pause();
              }
            });
  
            sliderNav.on("afterChange", (event, slick) => {
              var currentSlide, player;
  
              currentSlide = $(slick.$slider).find(".slick-current");
              player = currentSlide.find("video").get(0);
  
              if (player != undefined) {
                player.play();
              }
            });
          }
        }
  
        var productFancybox = $scope.find("[data-fancybox]");
  
        if (productFancybox.length > 0) {
          productFancybox.fancybox({
            buttons: [
              "zoom",
              "share",
              "slideShow",
              "fullScreen",
              //"download",
              "thumbs",
              "close",
            ],
            loop: true,
            thumbs: {
              autoStart: true,
            },
          });
        }
  
        if ($body.hasClass("template-product")) {
          if ($scope.closest(".quickView").length) return;
          var productZoom = $scope.find("[data-zoom-image]");
  
          if ($win.width() > 1024) {
            productZoom.each((index, element) => {
              var $this = $(element);
  
              if ($win.width() > 1024) {
                $this.zoom({ url: $this.attr("data-zoom-image"), touch: false });
              } else {
                $this.trigger("zoom.destroy");
              }
            });
          }
        }
  
        $win.on("resize", () => {
          if ($scope.hasClass("layout-1") || $scope.hasClass("layout-2")) {
            if ($win.width() > 1279) {
              setTimeout(() => {
                if (sliderFor.find(".slick-arrow").length > 0) {
                  var height_for = sliderFor.outerHeight(),
                    height_nav = sliderNav.outerHeight(),
                    pos = (height_nav - height_for) / 2;
  
                  sliderFor.parent().addClass("arrows-visible");
                  sliderFor.parent().css("top", pos);
                } else {
                  sliderFor.parent().addClass("arrows-disable");
                }
              }, 200);
            } else {
              setTimeout(() => {
                if (sliderFor.find(".slick-arrow").length > 0) {
                  sliderFor.parent().css("top", "unset");
                }
              }, 200);
            }
          }
        });
      },
  
      productVideoGallery: function ($scope) {
        const videoThumbnail = $scope.find("[data-video-thumbnail]"),
          videoThumbnailLen = videoThumbnail.length,
          productVideoLen = $(".productView-video").length;
  
        if (videoThumbnailLen) {
          const $imageWrapper = $scope.find(".productView-image-wrapper"),
            videoModal = $("[data-popup-video]"),
            sliderNav = $scope.find(".productView-nav");
          let offsetTop =
            $imageWrapper.offset().top + $imageWrapper.outerHeight();
  
          if (productVideoLen) {
            $body.addClass("has-product-video");
          }
  
          $win.on("scroll", (event) => {
            const $targetCur = $(event.currentTarget),
              thisVideo = $scope.find(".slick-current .productView-video"),
              videoType = thisVideo.data("type"),
              videoUrl = thisVideo.data("video-url");
  
            if (videoUrl != undefined) {
              if ($targetCur.scrollTop() > offsetTop) {
                if (!videoModal.is(".is-show")) {
                  const player = sliderNav
                      .find(".slick-slide.slick-active")
                      .data("youtube-player"),
                    dataTime = parseInt(player.getCurrentTime()),
                    videoContent = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">
                                                      ${
                                                        videoType == "youtube"
                                                          ? `<iframe
                                                              id="player"
                                                              type="text/html"
                                                              width="100%"
                                                              frameborder="0"
                                                              webkitAllowFullScreen
                                                              mozallowfullscreen
                                                              allowFullScreen
                                                              src="https://www.youtube.com/embed/${videoUrl}?autoplay=1&mute=1&start=${dataTime}">
                                                          </iframe>`
                                                          : `<iframe 
                                                              src="https://player.vimeo.com/video/${videoUrl}?autoplay=1&mute=1" 
                                                              class="js-vimeo" 
                                                              allow="autoplay; 
                                                              encrypted-media" 
                                                              webkitallowfullscreen 
                                                              mozallowfullscreen 
                                                              allowfullscreen">
                                                          </iframe>`
                                                      }
                                                  </div>`;
                  videoModal.addClass("is-show");
                  videoModal.find(".halo-popup-content").html(videoContent);
                  $body.addClass("video-show product-video-show");
                  player.pauseVideo();
                }
              } else {
                const player = sliderNav
                  .find(".slick-slide.slick-active")
                  .data("youtube-player");
                videoModal.removeClass("is-show");
                videoModal.find(".halo-popup-content").empty();
                $body.removeClass("video-show product-video-show");
                player.playVideo();
              }
            }
          });
        }
      },
  
      initVariantImageGroup: function ($scope, enable = false) {
        if (enable) {
          var inputChecked = $scope.find("[data-filter]:checked"),
            sliderFor = $scope.find(".productView-for"),
            sliderNav = $scope.find(".productView-nav");
  
          if (inputChecked.length > 0) {
            var className = inputChecked.data("filter");
  
            if (className !== undefined) {
              sliderNav.slick("slickUnfilter");
              sliderFor.slick("slickUnfilter");
  
              if (
                sliderNav.find(className).length &&
                sliderFor.find(className).length
              ) {
                sliderNav.slick("slickFilter", className).slick("refresh");
                sliderFor.slick("slickFilter", className).slick("refresh");
              }
            }
          }
  
          $doc.on("change", "input[data-filter]", (event) => {
            var className = $(event.currentTarget).data("filter");
  
            sliderNav.find(".slick-counter").remove();
            sliderNav.slick("slickUnfilter");
            sliderFor.slick("slickUnfilter");
  
            if (className !== undefined) {
              if (
                sliderNav.find(className).length &&
                sliderFor.find(className).length
              ) {
                sliderNav.slick("slickFilter", className).slick("refresh");
                sliderFor.slick("slickFilter", className).slick("refresh");
              }
            }
          });
        }
      },
  
      initYoutubeCarousel: function (slider) {
        slider.each((index, slick) => {
          const $slick = $(slick);
  
          if ($slick.find("[data-youtube]").length > 0) {
            $slick.addClass("slick-slider--video");
  
            halo.initYoutubeCarouselEvent(slick);
          }
        });
      },
  
      initYoutubeCarouselEvent: function (slick) {
        var $slick = $(slick),
          $videos = $slick.find("[data-youtube]");
  
        bindEvents(slick);
  
        function bindEvents() {
          if ($slick.hasClass("slick-initialized")) {
            onSlickImageInit($slick, $videos);
          }
  
          $doc.on("init", $slick, onSlickImageInit);
          $doc.on("beforeChange", $slick, onSlickImageBeforeChange);
          $doc.on("afterChange", $slick, onSlickImageAfterChange);
        }
  
        function onPlayerReady(event) {
          $(event.target.getIframe())
            .closest(".slick-slide")
            .data("youtube-player", event.target);
  
          setTimeout(function () {
            if (
              $(event.target.getIframe())
                .closest(".slick-slide")
                .hasClass("slick-active")
            ) {
              $slick.slick("slickPause");
              event.target.playVideo();
            }
          }, 200);
        }
  
        function onPlayerStateChange(event) {
          if (event.data === YT.PlayerState.PLAYING) {
            $slick.slick("slickPause");
          }
  
          if (event.data === YT.PlayerState.ENDED) {
            $slick.slick("slickNext");
          }
        }
  
        function onSlickImageInit() {
          $videos.each((j, vid) => {
            const $vid = $(vid);
            const id = `youtube_player_${Math.floor(Math.random() * 100)}`;
  
            $vid.attr("id", id);
  
            const player = new YT.Player(id, {
              host: "http://www.youtube.com",
              videoId: $vid.data("youtube"),
              wmode: "transparent",
              playerVars: {
                autoplay: 0,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                fs: 0,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                wmode: "transparent",
              },
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
              },
            });
          });
        }
  
        function onSlickImageBeforeChange() {
          const player = $slick
            .find(".slick-slide.slick-active")
            .data("youtube-player");
  
          if (player) {
            player.stopVideo();
            $slick.removeClass("slick-slider--playvideo");
          }
        }
  
        function onSlickImageAfterChange() {
          const player = $slick
            .find(".slick-slide.slick-active")
            .data("youtube-player");
  
          if (player) {
            $slick.slick("slickPause");
            $slick.addClass("slick-slider--playvideo");
            player.playVideo();
          }
        }
      },
  
      productSizeChart: function ($scope) {
        window.sizeChart = function () {
          var sizeChartBtn = $scope.find("[data-open-size-chart-popup]");
  
          sizeChartBtn.on("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            document.body.classList.add("size-chart-show");
            if (document.body.classList.contains("quick-view-show")) {
              $(".halo-popup-content .halo-size-chart-popup").addClass("is-show");
            } else {
              $("#MainContent .halo-size-chart-popup").addClass("is-show");
            }
          });
  
          $doc.on("click", "[data-close-size-chart-popup]", () => {
            $body.removeClass("size-chart-show");
            $(".halo-size-chart-popup").removeClass("is-show");
          });
  
          $doc.on("click", (event) => {
            if ($body.hasClass("size-chart-show")) {
              if (
                $(event.target).closest("[data-open-size-chart-popup]").length ===
                  0 &&
                $(event.target).closest("[data-size-chart-popup]").length === 0
              ) {
                $body.removeClass("size-chart-show");
              }
            }
          });
        };
  
        var quickViewShow = document.body.classList.contains("quick-view-show"),
          productSizeChart = $(".halo-productView .productView-sizeChart").length;
  
        if (document.body.classList.contains("template-product")) {
          if (!quickViewShow && productSizeChart) {
            window.sizeChart();
          } else if (quickViewShow && productSizeChart === 0) {
            window.sizeChart();
          }
        } else {
          window.sizeChart();
        }
      },
  
      productLastSoldOut: function ($scope) {
        var wrapper = $scope.find("[data-sold-out-product]");
  
        if (wrapper.length > 0) {
          var numbersProductList = wrapper.data("item").toString().split(","),
            numbersProductItem = Math.floor(
              Math.random() * numbersProductList.length
            ),
            numbersHoursList = wrapper.data("hours").toString().split(","),
            numbersHoursItem = Math.floor(
              Math.random() * numbersHoursList.length
            );
  
          wrapper
            .find("[data-sold-out-number]")
            .text(numbersProductList[numbersProductItem]);
          wrapper
            .find("[data-sold-out-hours]")
            .text(numbersHoursList[numbersHoursItem]);
          wrapper.show();
        }
      },
  
      productCustomerViewing: function ($scope) {
        var wrapper = $scope.find("[data-customer-view]");
  
        if (wrapper.length > 0) {
          var numbersViewer = wrapper.data("customer-view"),
            numbersViewerList = JSON.parse("[" + numbersViewer + "]"),
            numbersViewerTime = wrapper.data("customer-view-time"),
            timeViewer = parseInt(numbersViewerTime) * 1000;
  
          setInterval(function () {
            var numbersViewerItem = Math.floor(
              Math.random() * numbersViewerList.length
            );
  
            wrapper
              .find(".text")
              .text(
                window.customer_view.text.replace(
                  "[number]",
                  numbersViewerList[numbersViewerItem]
                )
              );
          }, timeViewer);
        }
      },
  
      productCountdown: function ($scope) {
        var wrapper = $scope.find("[data-countdown-id]"),
          countDown = wrapper.data("countdown"),
          countDownDate = new Date(countDown).getTime(),
          countDownText = window.countdown.text;
  
        if (wrapper.length > 0) {
          var countdownfunction = setInterval(function () {
            var now = new Date().getTime(),
              distance = countDownDate - now;
  
            if (distance < 0) {
              clearInterval(countdownfunction);
if (wrapper && typeof wrapper.remove === "function") wrapper.remove();
            } else {
              var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours = Math.floor(
                  (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                ),
                minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((distance % (1000 * 60)) / 1000),
                strCountDown;
  
              if (wrapper.is(".style-2, .style-3")) {
                strCountDown =
                  '<span class="text"><span>' +
                  countDownText +
                  '</span></span><span class="num">' +
                  days +
                  "<span>" +
                  window.countdown.day_2 +
                  '</span></span>\
                                  <span class="num">' +
                  hours +
                  "<span>" +
                  window.countdown.hour_2 +
                  '</span></span>\
                                  <span class="num">' +
                  minutes +
                  "<span>" +
                  window.countdown.min_2 +
                  '</span></span>\
                                  <span class="num">' +
                  seconds +
                  "<span>" +
                  window.countdown.sec_2 +
                  "</span></span>";
              } else {
                strCountDown =
                  '<span class="text"><span>' +
                  countDownText +
                  '</span></span><span class="num">' +
                  days +
                  "<span>" +
                  window.countdown.day +
                  '</span></span>\
                                  <span class="num">' +
                  hours +
                  "<span>" +
                  window.countdown.hour +
                  '</span></span>\
                                  <span class="num">' +
                  minutes +
                  "<span>" +
                  window.countdown.min +
                  '</span></span>\
                                  <span class="num">' +
                  seconds +
                  "<span>" +
                  window.countdown.sec +
                  "</span></span>";
              }
  
              wrapper.html(strCountDown);
              wrapper.addClass("show");
            }
          }, 1000);
        }
      },
  
      productCustomCursor: function ($scope) {
        if ($(".cursor-wrapper").length == 0) return;
        const { Back } = window;
  
        this.cursorWrapper = document.querySelector(".cursor-wrapper");
        this.innerCursor = document.querySelector(".custom-cursor__inner");
        this.outerCursor = document.querySelector(".custom-cursor__outer");
  
        this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect();
        this.innerCursorBox = this.innerCursor.getBoundingClientRect();
        this.outerCursorBox = this.outerCursor.getBoundingClientRect();
  
        document.addEventListener("mousemove", (e) => {
          this.clientX = e.clientX;
          this.clientY = e.clientY;
        });
  
        const render = () => {
          TweenMax.set(this.cursorWrapper, {
            x: this.clientX,
            y: this.clientY,
          });
          requestAnimationFrame(render);
        };
        requestAnimationFrame(render);
  
        this.fullCursorSize = 60;
        this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, {
          width: this.fullCursorSize,
          height: this.fullCursorSize,
          ease: this.easing,
          paused: true,
        });
  
        const handleMouseEnter = () => {
          this.enlargeCursorTween.play();
          $(".cursor-wrapper")
            .addClass("handleMouseEnter")
            .removeClass("handleMouseLeave");
        };
  
        const handleMouseLeave = () => {
          this.enlargeCursorTween.reverse();
          $(".cursor-wrapper")
            .addClass("handleMouseLeave")
            .removeClass("handleMouseEnter");
        };
  
        const gridItems = document.querySelectorAll(".productView-image");
        gridItems.forEach((el) => {
          if (el?.querySelector(".productView-video")) return;
          el.addEventListener("mouseenter", handleMouseEnter);
          el.addEventListener("mouseleave", handleMouseLeave);
        });
  
        this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
          scale: 0.7,
          paused: true,
          onComplete: () => {
            TweenMax.to(this.outerCursor, 0.2, {
              scale: 1,
              ease: this.easing,
            });
          },
        });
  
        $(document).on("mouseover", "[data-cursor-image]", (event) => {
          var $target = $(event.currentTarget),
            imagesInView = new Array();
  
          imagesInView.push($target.attr("data-index"));
          $("#count-image").text(imagesInView[0]);
        });
  
        $.fn.isInViewport = function (excludePartials) {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).height();
  
          var viewportTop = $(document).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
  
          if (excludePartials) {
            var bottomVisible = (elementBottom - viewportTop) / $(this).height();
            var isInView =
              elementBottom > viewportTop && elementTop < viewportBottom;
  
            return isInView && bottomVisible > 0.5;
          }
  
          return elementBottom > viewportTop && elementTop < viewportBottom;
        };
  
        if (
          $(".product-full-width").length > 0 ||
          $(".product-full-width-2").length > 0
        ) {
          $(window).on("resize scroll", function () {
            var imagesInView = new Array();
            $(".productView-image").each(function () {
              if ($(this).isInViewport(true)) {
                imagesInView.push($(this).attr("data-index"));
                $("#count-image").text(imagesInView[0]);
              }
            });
          });
        }
      },
  
      initWishlist: function () {
        if (window.wishlist.show) {
          halo.setLocalStorageProductForWishlist();
  
          $doc.on("click", "[data-wishlist]", (event) => {
            event.preventDefault();
            event.stopPropagation();
  
            if (!$(event.currentTarget).hasClass("is-in-grid")) {
              $("[data-wishlist-items-display]").removeClass("is-loaded");
            }
  
            var $target = $(event.currentTarget),
              id = $target.data("product-id"),
              handle = $target.data("wishlist-handle"),
              wishlistList = localStorage.getItem("wishlistItem")
                ? JSON.parse(localStorage.getItem("wishlistItem"))
                : [];
            (index = wishlistList.indexOf(handle)),
              (wishlistContainer = $("[data-wishlist-container]"));
            wishlistLayout = wishlistContainer.attr("data-wishlist-layout");
  
            if (!$target.hasClass("wishlist-added")) {
              $target
                .addClass("wishlist-added")
                .find(".text")
                .text(window.wishlist.added);
  
              if (wishlistContainer.length > 0) {
                const addEvent = new CustomEvent("addwishlistitem", {
                  detail: { handle },
                  bubbles: true,
                });
                document.dispatchEvent(addEvent);
              }
  
              wishlistList.push(handle);
              localStorage.setItem("wishlistItem", JSON.stringify(wishlistList));
  
              const updateWishlistMailEvent = new CustomEvent(
                "updatewishlistmail",
                { bubbles: true }
              );
              document.dispatchEvent(updateWishlistMailEvent);
            } else {
              $target
                .removeClass("wishlist-added")
                .find(".text")
                .text(window.wishlist.add);
              if (wishlistContainer.length > 0) {
                if ($('[data-wishlist-added="wishlist-' + id + '"]').length > 0) {
                  $('[data-wishlist-added="wishlist-' + id + '"]').remove();
                  const icon = $(`[data-wishlist][data-product-id=${id}]`);
                  const productCard = icon.closest(".product");
if (productCard && typeof productCard.remove === "function") productCard.remove();
                }
              }
  
              wishlistList.splice(index, 1);
              localStorage.setItem("wishlistItem", JSON.stringify(wishlistList));
  
              const updatePaginationEvent = new CustomEvent("updatepagination", {
                bubbles: true,
              });
              document.dispatchEvent(updatePaginationEvent);
  
              if (wishlistContainer.length > 0) {
                wishlistList = localStorage.getItem("wishlistItem")
                  ? JSON.parse(localStorage.getItem("wishlistItem"))
                  : [];
  
                if (wishlistList.length > 0) {
                  const updateWishlistMailEvent = new Event(
                    "updatewishlistmail",
                    { bubbles: true }
                  );
                  document.dispatchEvent(updateWishlistMailEvent);
                } else {
                  $("[data-wishlist-container]").addClass("is-empty").html(`\
                                      <div class="wishlist-content-empty text-center">\
                                          <span class="wishlist-content-text">${window.wishlist.empty}</span>\
                                          <div class="wishlist-content-actions">\
                                              <a class="button button-2 button-continue" href="${window.routes.collection_all}">\
                                                  ${window.wishlist.continue_shopping}\
                                              </a>\
                                          </div>\
                                      </div>\
                                  `);
  
                  $("[data-wishlist-footer]").hide();
                }
              }
            }
            $("[data-wishlist-count]").text(wishlistList.length);
            halo.setProductForWishlist(handle);
          });
        }
      },
  
      calculateCard06Padding() {
        if (!$body.hasClass("product-card-layout-06")) return;
  
        const cardAction = document.querySelector(
          ".card .card-action.card-grid__hidden"
        );
        cardAction.classList.remove("card-grid__hidden");
        const padding = cardAction.scrollHeight;
  
        document
          .querySelector("[data-wishlist-items-grid-display]")
          .style.setProperty("--card-06-padding", padding + "px");
        cardAction.classList.add("card-grid__hidden");
      },
  
      setProductForWishlist: function (handle) {
        var wishlistList = JSON.parse(localStorage.getItem("wishlistItem")),
          item = $('[data-wishlist-handle="' + handle + '"]'),
          index = wishlistList?.indexOf(handle);
  
        if (index == null || wishlistList == null) return;
  
        if (index >= 0) {
          item
            .addClass("wishlist-added")
            .find(".text")
            .text(window.wishlist.added);
        } else {
          item
            .removeClass("wishlist-added")
            .find(".text")
            .text(window.wishlist.add);
        }
      },
  
      setLocalStorageProductForWishlist: function () {
        var wishlistList = localStorage.getItem("wishlistItem")
          ? JSON.parse(localStorage.getItem("wishlistItem"))
          : [];
        localStorage.setItem("wishlistItem", JSON.stringify(wishlistList));
  
        if (wishlistList.length > 0) {
          wishlistList = JSON.parse(localStorage.getItem("wishlistItem"));
  
          wishlistList.forEach((handle) => {
            halo.setProductForWishlist(handle);
          });
        }
        $("[data-wishlist-count]").text(wishlistList.length);
      },
  
      initCountdown: function () {
        var countdownAnnouncementElm = $("[data-countdown-announcement]"),
          countdownElm = $("[data-countdown]").not("[data-countdown-id]");
  
        if (countdownAnnouncementElm.length) {
          countdownAnnouncementElm.each(function () {
            var self = $(this),
              countdownAnnouncement = self.data("countdown-value"),
              countdownAnnouncementDate = new Date(
                countdownAnnouncement
              ).getTime();
  
            var countdownAnnouncementFunction = setInterval(function () {
              var now = new Date().getTime(),
                distance = countdownAnnouncementDate - now;
  
              if (distance < 0) {
                clearInterval(countdownAnnouncementFunction);
                if (self.hasClass("hide--countdown")) {
if (self && typeof self.remove === "function") self.remove();
                } else {
                  const thisItem = self.parents(".announcement-bar__message"),
                    thisBar = self.parents("[data-announcement-bar]");
                  thisBar.is(".slick-initialized")
                    ? thisBar.slick("slickRemove", thisItem.data("slick-index"))
                    : thisItem.remove();
                }
              } else {
                var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                  hours = `0${Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                  )}`.slice(-2),
                  minutes = `0${Math.floor(
                    (distance % (1000 * 60 * 60)) / (1000 * 60)
                  )}`.slice(-2),
                  seconds = `0${Math.floor(
                    (distance % (1000 * 60)) / 1000
                  )}`.slice(-2),
                  strCountDown = "";
  
                strCountDown =
                  '<div class="clock-item"><span class="num">' +
                  days +
                  '</span><span class="text">' +
                  window.countdown.days +
                  '</span></div>\
                                              <div class="clock-item"><span class="num">' +
                  hours +
                  '</span><span class="text">' +
                  window.countdown.hours +
                  '</span></div>\
                                              <div class="clock-item"><span class="num">' +
                  minutes +
                  '</span><span class="text">' +
                  window.countdown.mins +
                  '</span></div>\
                                              <div class="clock-item"><span class="num">' +
                  seconds +
                  '</span><span class="text">' +
                  window.countdown.secs +
                  "</span></div>";
  
                self.html(strCountDown);
              }
            }, 1000);
          });
        }
  
        if (countdownElm.length) {
          countdownElm.each(function () {
            var self = $(this),
              countDown = self.data("countdown-value"),
              countDownDate = new Date(countDown).getTime();
  
            var countdownfunction = setInterval(function () {
              var now = new Date().getTime(),
                distance = countDownDate - now;
  
              if (distance < 0) {
                clearInterval(countdownfunction);
                if (self.hasClass("hide--countdown")) {
if (self && typeof self.remove === "function") self.remove();
                } else {
                  self.parents(".shopify-section").remove();
                }
              } else {
                var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                  hours = `0${Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                  )}`.slice(-2),
                  minutes = `0${Math.floor(
                    (distance % (1000 * 60 * 60)) / (1000 * 60)
                  )}`.slice(-2),
                  seconds = `0${Math.floor(
                    (distance % (1000 * 60)) / 1000
                  )}`.slice(-2),
                  strCountDown = "";
                if (self.hasClass("product-countdown-block")) {
                  if ($(".halo-block-header").hasClass("countdown_style_2")) {
                    strCountDown =
                      '<div class="clock-item"><span class="num">' +
                      days +
                      window.countdown.d +
                      '</span><span class="icon">:</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                      hours +
                      window.countdown.h +
                      '</span><span class="icon">:</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                      minutes +
                      window.countdown.m +
                      '</span><span class="icon">:</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                      seconds +
                      window.countdown.s +
                      '</span><span class="icon"></span></div>';
                  } else {
                    strCountDown = `<div class="clock-item"><span class="num">${days}d&nbsp;</span></div>
                                      <div class="clock-item"><span class="num">${hours}:</span></div>
                                      <div class="clock-item"><span class="num">${minutes}:</span></div>
                                      <div class="clock-item"><span class="num">${seconds}</span></div>`;
                  }
                } else {
                  strCountDown =
                    '<div class="clock-item"><span class="num">' +
                    days +
                    '</span><span class="text">' +
                    window.countdown.days +
                    '</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                    hours +
                    '</span><span class="text">' +
                    window.countdown.hours +
                    '</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                    minutes +
                    '</span><span class="text">' +
                    window.countdown.mins +
                    '</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                    seconds +
                    '</span><span class="text">' +
                    window.countdown.secs +
                    "</span></div>";
                }
                self.html(strCountDown);
              }
            }, 1000);
          });
        }
      },
  
      collectionCountdown: function () {
        var countdownElm = $("[data-collection-countdown]");
  
        if (countdownElm.length) {
          countdownElm.each(function () {
            var self = $(this);
  
            var countDownCollection = (self) => {
              var countDown = self.data("collection-countdown-value"),
                countDownDate = new Date(countDown).getTime(),
                countDownText = window.countdown.text,
                now = new Date().getTime(),
                distance = countDownDate - now;
  
              if (distance < 0) {
                clearInterval(countDownCollection);
                if (self.hasClass("hide--countdown")) {
if (self && typeof self.remove === "function") self.remove();
                }
              } else {
                var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                  hours = `0${Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                  )}`.slice(-2),
                  minutes = `0${Math.floor(
                    (distance % (1000 * 60 * 60)) / (1000 * 60)
                  )}`.slice(-2),
                  seconds = `0${Math.floor(
                    (distance % (1000 * 60)) / 1000
                  )}`.slice(-2),
                  strCountDown = "";
                if (self.hasClass("collection-countdown")) {
                  strCountDown =
                    '<div class="clock-item"><span class="num">' +
                    days +
                    '</span><span class="text">' +
                    window.countdown.days +
                    '</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                    hours +
                    '</span><span class="text">' +
                    window.countdown.hours +
                    '</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                    minutes +
                    '</span><span class="text">' +
                    window.countdown.mins +
                    '</span></div>\
                                                  <div class="clock-item"><span class="num">' +
                    seconds +
                    '</span><span class="text">' +
                    window.countdown.secs +
                    "</span></div>";
                }
                self.html(strCountDown);
              }
            };
  
            setInterval(() => {
              countDownCollection(self);
            }, 1000);
          });
        }
      },
  
      handleScrollDown: function () {
        console.log('scrolling downnnnnnnnn')
        var iconSrollDownSlt = "[data-scroll-down]",
          iconSrollDown = $(iconSrollDownSlt);
  
        if (iconSrollDownSlt.length) {
          iconSrollDown.each(function () {
            var self = $(this);
            var target = self
              .closest(".shopify-section")
              .next(".shopify-section")
              .attr("id");
  
            self.attr("href", "#" + target + "");
  
            iconSrollDown.on("click", function (e) {
              e.preventDefault();
              var scroll = $(this.getAttribute("href"));
  
              if (scroll.length) {
                $("html, body").stop().animate(
                  {
                    scrollTop: scroll.offset().top,
                  },
                  400
                );
              }
            });
          });
        }
      },
  
      toggleSidebarMobile: function () {
        $doc.on("click", "[data-sidebar]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.addClass("open-mobile-sidebar");
        });
  
        $doc.on("click", "[data-close-sidebar]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          $body.removeClass("open-mobile-sidebar");
        });
  
        $doc.on("click", (event) => {
          if ($body.hasClass("open-mobile-sidebar")) {
            if (
              $(event.target).closest("[data-sidebar]").length === 0 &&
              $(event.target).closest("#halo-sidebar").length === 0
            ) {
              $body.removeClass("open-mobile-sidebar");
            }
          }
        });
      },
  
      initBlogMasonry: function () {
        const $blogMasonry = $(".blog-layout-masonry .blog-block-item");
        const isRTL = $body.hasClass("layout_rtl");
  
        $blogMasonry.masonry({
          columnWidth: ".blog-grid-sizer",
          itemSelector: "[data-masonry-item]",
          isRTL: isRTL,
          originLeft: !isRTL,
        });
      },
  
      articleGallery: function () {
        const $gallery = $(".articleGallery-block"),
          $gallerySlider = $(".articleGallery-slider"),
          galleryLength = $gallery.length,
          col = $gallerySlider.data("col");
  
        if (galleryLength > 0 && $gallerySlider.not(".slick-initialized")) {
          $gallerySlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,
            mobileFirst: true,
            focusOnSelect: false,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: col,
                  slidesToScroll: col,
                },
              },
              {
                breakpoint: 319,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          });
        }
      },
  
      initCollapseSidebarBlock: function () {
        $doc.on(
          "click",
          ".sidebarBlock-headingWrapper .sidebarBlock-heading",
          (event) => {
            var $target = $(event.currentTarget),
              $blockCollapse = $target.parent().siblings(),
              $sidebarBlock = $target.parents(".sidebarBlock");
  
            if ($target.hasClass("is-clicked")) {
              $target.removeClass("is-clicked");
              $blockCollapse.slideUp("slow");
            } else {
              $target.addClass("is-clicked");
              $blockCollapse.slideDown("slow");
  
              if ($sidebarBlock.hasClass("sidebar-product")) {
                $sidebarBlock.find(".products-carousel").slick("refresh");
              }
            }
          }
        );
      },
  
      initCategoryActive: function () {
        if ($(".all-categories-list").length > 0) {
          $doc.on("click", ".all-categories-list .icon-dropdown", (event) => {
            var $target = $(event.currentTarget).parent();
  
            $target.siblings().removeClass("is-clicked current-cate");
            $target.toggleClass("is-clicked");
            $target.siblings().find("> .dropdown-category-list").slideUp("slow");
            $target.find("> .dropdown-category-list").slideToggle("slow");
          });
  
          $(".all-categories-list li").each((index, element) => {
            if ($(element).hasClass("current-cate")) {
              $(element).find("> .dropdown-category-list").slideToggle("slow");
            }
          });
        }
      },
  
      productBlockSilderSidebar: function () {
        var productGrid = $("[data-product-slider-sidebar]"),
          itemToShow = productGrid.data("item-to-show"),
          itemDots = productGrid.data("item-dots"),
          itemArrows = productGrid.data("item-arrows");
  
        if (productGrid.length > 0) {
          if (productGrid.not(".slick-initialized")) {
            productGrid.slick({
              mobileFirst: true,
              adaptiveHeight: true,
              vertical: false,
              infinite: false,
              slidesToShow: itemToShow,
              slidesToScroll: 1,
              arrows: itemArrows,
              dots: itemDots,
              autoplay: true,
              autoplaySpeed: 2000,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
            });
          }
        }
      },
  
      productBlockSilderArticle: function () {
        var productGrid = $("[data-product-slider-article]"),
          itemToShow = productGrid.data("item-to-show"),
          itemDots = productGrid.data("item-dots"),
          itemArrows = productGrid.data("item-arrows");
  
        if (productGrid.length > 0) {
          if (productGrid.not(".slick-initialized")) {
            productGrid.slick({
              adaptiveHeight: true,
              vertical: false,
              infinite: false,
              slidesToShow: itemToShow,
              slidesToScroll: 1,
              arrows: itemArrows,
              dots: itemDots,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  },
                },
                {
                  breakpoint: 551,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          }
        }
      },
  
      articleGallery: function () {
        const $gallery = $(".articleGallery-block"),
          $gallerySlider = $(".articleGallery-slider"),
          galleryLength = $gallery.length,
          col = $gallerySlider.data("col");
  
        if (galleryLength > 0 && $gallerySlider.not(".slick-initialized")) {
          $gallerySlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: false,
            mobileFirst: true,
            focusOnSelect: false,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: col,
                  slidesToScroll: col,
                },
              },
              {
                breakpoint: 319,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          });
        }
      },
  
      initInfiniteScrolling: function () {
        if ($(".pagination-infinite".length > 0)) {
          $win.on("scroll load", () => {
            var currentScroll = $win.scrollTop(),
              pageInfinite = $(".pagination-infinite"),
              linkInfinite = pageInfinite.find("[data-infinite-scrolling]"),
              position;
  
            if (linkInfinite.length > 0 && !linkInfinite.hasClass("is-loading")) {
              position = pageInfinite.offset().top - 500;
  
              if (currentScroll > position) {
                var url = linkInfinite.attr("href");
  
                halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
              }
            }
          });
        }
  
        $doc.on("click", "[data-infinite-scrolling]", (event) => {
          var linkInfinite = $(event.currentTarget),
            url = linkInfinite.attr("href");
  
          event.preventDefault();
          event.stopPropagation();
  
          halo.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
        });
      },
  
      doAjaxInfiniteScrollingGetContent: function (url, link) {
        $.ajax({
          type: "GET",
          url: url,
          beforeSend: function () {
            link.text(link.attr("data-loading-more"));
            link.addClass("is-loading");
            // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.add('is-loading');
            // $body.addClass('has-halo-loader');
          },
          success: function (data) {
            halo.ajaxInfiniteScrollingMapData(data);
          },
          error: function (xhr, text) {
            alert($.parseJSON(xhr.responseText).description);
          },
          complete: function () {
            link.text(link.attr("data-load-more"));
            link.removeClass("is-loading");
            // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.remove('is-loading');
            // $body.removeClass('has-halo-loader');
            if (document.querySelector(".collection-masonry")) {
              resizeAllGridItems();
            }
          },
        });
      },
  
      ajaxInfiniteScrollingMapData: function (data) {
        var currentTemplate = $("#CollectionProductGrid"),
          currentProductListing = currentTemplate.find(".productListing"),
          currentPagination = currentTemplate.find(".pagination"),
          newTemplate = $(data).find("#CollectionProductGrid"),
          newProductListing = newTemplate.find(".productListing"),
          newPagination = newTemplate.find(".pagination"),
          newProductItem = newProductListing.children(".product");
  
        if (newProductItem.length > 0) {
          currentProductListing.append(newProductItem);
          currentPagination.replaceWith(newPagination);
  
          $("[data-total-start]").text(1);
  
          if (window.compare.show) {
            var $compareLink = $("[data-compare-link]");
            halo.setLocalStorageProductForCompare($compareLink);
          }
  
          if (window.wishlist.show) {
            halo.setLocalStorageProductForWishlist();
          }
  
          if (halo.checkNeedToConvertCurrency()) {
            Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
          }
        }
      },
  
      initQuickShopProductList: function () {
        $doc.on("click", "[data-open-quickshop-popup-list]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var handle = $(event.currentTarget).data("product-handle"),
            product = $(event.currentTarget).closest(".card");
  
          if (!product.hasClass("quick-shop-show")) {
            halo.updateContentQuickShop(product, handle);
          }
        });
  
        $doc.on("click", "[data-close-quickshop-popup-list]", (event) => {
          event.preventDefault();
          event.stopPropagation();
  
          var product = $(event.currentTarget).closest(".card");
  
          product.removeClass("quick-shop-show");
          product.find(".card-popup-content").empty();
        });
  
        $doc.on("click", (event) => {
          if ($(".card").hasClass("quick-shop-show")) {
            if (
              $(event.target).closest("[data-open-quickshop-popup-list]")
                .length === 0 &&
              $(event.target).closest(".card-popup").length === 0
            ) {
              $(".card").removeClass("quick-shop-show");
              $(".card").find(".card-popup-content").empty();
            }
          }
        });
      },
  
      updateContentQuickShop: function (product, handle) {
        var popup = product.find(".card-popup"),
          popupContent = popup.find(".card-popup-content");
  
        $.ajax({
          type: "get",
          url:
            window.routes.root + "/products/" + handle + "?view=ajax_quick_shop",
          beforeSend: function () {
            $(".card").removeClass("quick-shop-show");
          },
          success: function (data) {
            popupContent.append(data);
          },
          error: function (xhr, text) {
            alert($.parseJSON(xhr.responseText).description);
          },
          complete: function () {
            product.addClass("quick-shop-show");
          },
        });
      },
  
      toggleVariantsForExpressOrder: function () {
        var toggleVariant = "[data-toggle-variant]";
  
        $(document).on("click", toggleVariant, function (e) {
          e.preventDefault();
          e.stopPropagation();
  
          var self = $(this),
            curVariants = self.data("target");
  
          if (self.hasClass("show-options-btn")) {
            self.text(window.inventory_text.hide_options);
            $(curVariants).slideDown(700, function () {
              self.addClass("hide-options-btn").removeClass("show-options-btn");
            });
          } else {
            self.text(window.inventory_text.show_options);
            $(curVariants).slideUp(700, function () {
              self.addClass("show-options-btn").removeClass("hide-options-btn");
            });
          }
        });
      },
  
      initExpressOrderAddToCart: function () {
        var addToCartSlt = "[data-express-addtocart]";
  
        $(document)
          .off("click.addToCartExpress", addToCartSlt)
          .on("click.addToCartExpress", addToCartSlt, function (e) {
            e.preventDefault();
  
            var self = $(this);
  
            if (self.attr("disabled") != "disabled") {
              var productItem = self.closest(".product-item");
  
              if (productItem.length == 0) {
                productItem = self.closest(".col-options");
              }
  
              var form = productItem.find("form");
              var variant_id = form.find("select[name=id]").val();
  
              if (!variant_id) {
                variant_id = form.find("input[name=id]").val();
              }
  
              var quantityElm = productItem.find("input[name=quantity]");
  
              if (quantityElm.length == 0) {
                quantityElm = productItem
                  .siblings(".col-qtt")
                  .find("input[name=quantity]");
              }
  
              var quantity = quantityElm.val();
              if (!quantity) {
                quantity = 1;
              }
  
              if (parseInt(quantity) !== 0) {
                if (window.ajax_cart == "none") {
                  form.submit();
                } else {
                  halo.expressAjaxAddToCart(variant_id, quantity, self, form);
                  form.next(".feedback-text").show();
                }
              } else {
                form
                  .next(".feedback-text")
                  .text("Quantity cannot be blank")
                  .show();
              }
            }
            return false;
          });
      },
  
      expressAjaxAddToCart: function (variant_id, quantity, cartBtn, form) {
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: "quantity=" + quantity + "&id=" + variant_id,
          dataType: "json",
  
          beforeSend: function () {
            window.setTimeout(function () {
              cartBtn.text(window.inventory_text.adding + "...");
            }, 100);
          },
  
          success: function (msg) {
            window.setTimeout(function () {
              cartBtn.text(window.inventory_text.thank_you);
              cartBtn.addClass("add_more");
              form
                .next(".feedback-text")
                .text(window.inventory_text.cart_feedback)
                .addClass("is-added");
            }, 600);
            window.setTimeout(function () {
              cartBtn.text(window.inventory_text.add_more + "...");
            }, 1000);
  
            switch (window.after_add_to_cart.type) {
              case "cart":
                halo.redirectTo(window.routes.cart);
  
                break;
              case "quick_cart":
                if (window.quick_cart.show) {
                  Shopify.getCart((cart) => {
                    if (window.quick_cart.type == "popup") {
                      // $body.addClass('cart-modal-show');
                      // halo.updateDropdownCart(cart);
                    } else {
                      $body.addClass("cart-sidebar-show");
                      halo.updateSidebarCart(cart);
                    }
                  });
                } else {
                  halo.redirectTo(window.routes.cart);
                }
  
                break;
              case "popup_cart_1":
                Shopify.getCart((cart) => {
                  halo.updatePopupCart(cart, 1, variant_id);
                  halo.updateSidebarCart(cart);
                  $body.addClass("add-to-cart-show");
                });
  
                break;
            }
          },
  
          error: function (xhr, text) {
            alert($.parseJSON(xhr.responseText).description);
            window.setTimeout(function () {
              cartBtn.text(window.inventory_text.add_to_cart);
            }, 400);
          },
        });
      },
  
      initProductBundle: function () {
        var productBundle = $("[data-product-bundle]"),
          bundleList = productBundle.find("[data-bundle-slider]"),
          dots = bundleList.data("dots"),
          arrows = bundleList.data("arrows");
  
        if (bundleList.length > 0) {
          if (!bundleList.hasClass("slick-initialized")) {
            bundleList.slick({
              dots: true,
              arrows: arrows,
              slidesToShow: 2,
              slidesToScroll: 1,
              mobileFirst: true,
              infinite: false,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: dots,
                  },
                },
                {
                  breakpoint: 551,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: dots,
                  },
                },
              ],
            });
  
            productBundle
              .find(".bundle-product-wrapper")
              .removeClass("has-halo-block-loader");
  
            bundleList.on("afterChange", function () {
              bundleList.find(".bundle-product-item").removeClass("is-open");
            });
          }
        }
      },
  
      initProductReviewSection: function () {
        $doc.ready(() => {
          setTimeout(() => {
            const $reviewTabContent = $(".productView-review .spr-content"),
              $thisReviewSection = $(".shopify-app-block .spr-content");
  
            if ($reviewTabContent && $thisReviewSection) {
              const reviewContent = $reviewTabContent.html();
              $thisReviewSection.html(reviewContent);
            }
          }, 1000);
        });
      },
  
      initDynamicBrowserTabTitle: function () {
        console.log('initDynamicBrowserTabTitle downnnnnnnnn')
        if (window.dynamic_browser_title.show) {
          var pageTitleContent = document.title,
            newPageTitleContent = window.dynamic_browser_title.text;
  
          window.onblur = function () {
            document.title = window.dynamic_browser_title.text;
          };
  
          window.onfocus = function () {
            document.title = pageTitleContent;
          };
        }
      },
  
      initWarningPopup: function () {
        console.log('initWarningPopupinitWarningPopup   downnnnnnnnn')
        this.warningPopup = document.querySelector("[data-warning-popup]");
        this.warningPopupContent = this.warningPopup.querySelector(
          "[data-halo-warning-content]"
        );
        this.warningPopupCloseButton = this.warningPopup.querySelector(
          "[data-close-warning-popup]"
        );
        this.warningPopupCloseButton.addEventListener("click", () => {
          document.body.classList.remove("has-warning");
        });
  
        this.warningTime = 3000;
        this.warningTimeout = undefined;
  
        window.warningTimeout = this.warningTimeout;
      },
  
      showWarning: function (content, time = this.warningTime) {
        if (this.warningTimeout) {
          clearTimeout(this.warningTimeout);
        }
  
        this.warningPopupContent.textContent = content;
        document.body.classList.add("has-warning");
  
        if (time) {
          this.warningTimeout = setTimeout(() => {
            document.body.classList.remove("has-warning");
          }, time);
        }
      },
  
      backgroundOverlayHoverEffect: function () {
        const backgroundOverlay = document.querySelector(".background-overlay");
        const backgroundCursorWrapper = backgroundOverlay.firstChild;
  
        const enlargeCursor = () => {
          backgroundCursorWrapper.classList.add("enlarge-cursor");
        };
  
        const dwindleCursor = () => {
          backgroundCursorWrapper.classList.remove("enlarge-cursor");
        };
  
        const setCursorPosition = (clientX, clientY) => {
          requestAnimationFrame(() => {
            backgroundCursorWrapper.style.setProperty("--translate-y", clientY);
            backgroundCursorWrapper.style.setProperty("--translate-x", clientX);
          });
        };
  
        const handleMouseMove = (e) => {
          setCursorPosition(e.clientX, e.clientY);
        };
  
        const handleMouseEnter = (e) => {
          setCursorPosition(e.clientX, e.clientY);
          enlargeCursor();
        };
  
        const handleMouseLeave = (e) => {
          setCursorPosition(e.clientX, e.clientY);
          backgroundCursorWrapper.removeEventListener(
            "mousemove",
            handleMouseMove
          );
          dwindleCursor();
        };
  
        backgroundOverlay.addEventListener("mouseenter", handleMouseEnter);
        backgroundOverlay.addEventListener("mouseleave", handleMouseLeave);
        backgroundOverlay.addEventListener("mousemove", handleMouseMove);
        backgroundOverlay.addEventListener("click", dwindleCursor);
      },
      backgroundOverlayHoverEffect1: function () {
        const backgroundOverlay = document.querySelector(".background-overlay1");
        if (!backgroundOverlay) return;
  
        const backgroundCursorWrapper = backgroundOverlay.firstChild;
  
        const enlargeCursor = () => {
          backgroundCursorWrapper.classList.add("enlarge-cursor");
        };
  
        const dwindleCursor = () => {
          backgroundCursorWrapper.classList.remove("enlarge-cursor");
        };
  
        const setCursorPosition = (clientX, clientY) => {
          requestAnimationFrame(() => {
            backgroundCursorWrapper.style.setProperty("--translate-y", clientY);
            backgroundCursorWrapper.style.setProperty("--translate-x", clientX);
          });
        };
  
        const handleMouseMove = (e) => {
          setCursorPosition(e.clientX, e.clientY);
        };
  
        const handleMouseEnter = (e) => {
          setCursorPosition(e.clientX, e.clientY);
          enlargeCursor();
        };
  
        const handleMouseLeave = (e) => {
          setCursorPosition(e.clientX, e.clientY);
          backgroundCursorWrapper.removeEventListener(
            "mousemove",
            handleMouseMove
          );
          dwindleCursor();
        };
  
        backgroundOverlay.addEventListener("mouseenter", handleMouseEnter);
        backgroundOverlay.addEventListener("mouseleave", handleMouseLeave);
        backgroundOverlay.addEventListener("mousemove", handleMouseMove);
        backgroundOverlay.addEventListener("click", dwindleCursor);
      },
  
      productBlockScroller: function (wrapper) {
        const { Back } = window;
        const easingEffect = Back.easeInOut.config(1.7);
  
        let cursorWrapper = wrapper.get(0)?.querySelector(".products-cursor");
  
        if (!cursorWrapper) return;
  
        let innerCursor = cursorWrapper.querySelector(".products-cursor__inner"),
          imageCursor = cursorWrapper.querySelector(".products-cursor__image"),
          iconCursor = cursorWrapper.querySelector(".products-cursor__icon"),
          itemTween = wrapper
            .get(0)
            ?.querySelectorAll(
              ".halo-block-content.is-scroll, .products-load.is-scroll"
            ),
          itemNotTween = wrapper
            .get(0)
            ?.querySelectorAll(
              ".card-product__group, .card-action, .card-title, .card-swatch, .variants-popup, .card-compare, .card-quickview, .card-wishlist, .list-product-tabs"
            ),
          clientX,
          clientY,
          scrollerBox,
          cursorSide = null,
          cursorInsideSwiper = false;
  
        document.addEventListener("mousemove", (event) => {
          clientX = event.clientX;
          clientY = event.clientY;
          docClientX = event.clientX;
          docClientY = event.clientY;
        });
  
        const render = () => {
          TweenMax.set(cursorWrapper, {
            x: clientX,
            y: clientY,
          });
  
          requestAnimationFrame(render);
        };
  
        requestAnimationFrame(render);
  
        const wrapTween = TweenMax.to([cursorWrapper], 0.1, {
          scale: 2.5,
          opacity: 1,
          backgroundColor: "rgba(42,104,118,1)",
          ease: easingEffect,
          paused: true,
        });
  
        const elementTween = TweenMax.to([imageCursor, iconCursor], 0.1, {
          opacity: 1,
          ease: easingEffect,
          paused: true,
        });
  
        const handleMouseEnter = (event) => {
          wrapTween.play();
          elementTween.play();
          cursorWrapper.classList.add("handleMouseEnter");
          cursorWrapper.classList.remove("handleMouseLeave");
        };
  
        const handleMouseLeave = (event) => {
          wrapTween.reverse();
          elementTween.reverse();
          cursorWrapper.classList.add("handleMouseLeave");
          cursorWrapper.classList.remove("handleMouseEnter");
        };
  
        itemTween.forEach((element) => {
          element.addEventListener("mouseenter", handleMouseEnter);
          element.addEventListener("mouseleave", handleMouseLeave);
        });
  
        itemNotTween.forEach((element) => {
          element.addEventListener("mouseenter", handleMouseLeave);
          element.addEventListener("mouseleave", handleMouseEnter);
        });
      },
  
      productCustomInformation() {
        const $customInfo = $("[data-custom-information]");
        const $thisPopup = $("#halo-product-custom-information");
  
        $customInfo.on("click", (event) => {
          const $this = $(event.currentTarget);
          const title = $this.find(".title")[0].innerText;
          const thisContent = $this
            .find(".product-customInformation__popup")
            .html();
  
          if (thisContent === "" || thisContent == null) return;
          $thisPopup.addClass("is-show");
          $thisPopup.find(".halo-popup-title").text(title);
          $thisPopup.find(".halo-popup-content").html(thisContent);
          $body.addClass("is-custom-information");
        });
  
        $doc.on("click", "[data-close-custom-information]", () => {
          $body.removeClass("is-custom-information");
          $thisPopup.removeClass("is-show");
        });
  
        $doc.on("click", (event) => {
          if ($body.hasClass("is-custom-information")) {
            if (
              $(event.target).closest("#halo-product-custom-information")
                .length === 0 &&
              $(event.target).closest("[data-custom-information]").length === 0
            ) {
              $body.removeClass("is-custom-information");
            }
          }
        });
      },
  
      initLazyloadObserver(loadingImages, productGrid) {
        const setLazyLoaded = (target) => {
          const card = target.closest(".card");
          card.classList.add("ajax-loaded");
        };
  
        this.lazyloadedObserver = new MutationObserver(
          (mutationList, observer) => {
            mutationList.forEach((mutation) => {
              if (mutation.type == "attributes") {
                if (!mutation.target.classList.contains("lazyloaded")) return;
                setLazyLoaded(mutation.target);
              }
            });
          }
        );
  
        // const parentObserver = new MutationObserver((mutationlist) => {
        //   mutationlist.forEach((mutation) => {
        //     if (mutation.type == "childList") {
        //       const addedLoadingImages = [...mutation.addedNodes].map((node) =>
        //         node.querySelector(".media--loading-effect img")
        //       );
        //       addedLoadingImages.forEach((image) => {
        //         this.lazyloadedObserver.observe(image, {
        //           childList: true,
        //           attributes: true,
        //         });
        //       });
        //     }
        //   });
        // });
        const parentObserver = new MutationObserver((mutationList) => {
            mutationList.forEach((mutation) => {
              if (mutation.type === "childList") {
                const addedLoadingImages = [...mutation.addedNodes].map((node) =>
                  node.querySelector(".media--loading-effect img")
                );
                addedLoadingImages.forEach((image) => {
                  if (image instanceof Node) { 
                    this.lazyloadedObserver.observe(image, {
                      childList: true,
                      attributes: true,
                    });
                  }
                });
              }
            });
          });
  
        if (productGrid)
          parentObserver.observe(productGrid, {
            subtree: false,
            childList: true,
          });
        if (loadingImages.length > 0)
          loadingImages.forEach((image) => {
            if (image.classList.contains("lazyloaded")) {
              setLazyLoaded(image);
            } else {
              this.lazyloadedObserver.observe(image, {
                childList: true,
                attributes: true,
              });
            }
          });
      },
  
      observeImageLazyloaded(images) {
        images.forEach((image) => {
          this.lazyloadedObserver.observe(image, {
            childList: true,
            attributes: true,
          });
        });
      },
  
      iconZoomClickMobile() {
        const iconZoom = $(".productView-iconZoom");
        iconZoom.on("click", (event) => {
          document
            .querySelector(".productView-image .productView-img-container .media")
            .click();
        });
      },
  
      calculateTranslateYHeight() {
        const cardActions = document.querySelectorAll(
          ".card .card-action:not(.variants-popup-form)"
        );
        let heighest = 0;
  
        if (!cardActions.length) return;
        cardActions.forEach((cardAction) => {
          cardAction.classList.add("temporary-show");
  
          const height = cardAction.clientHeight;
          if (height > heighest) heighest = height;
  
          cardAction.classList.remove("temporary-show");
        });
        document.body.style.setProperty(
          "--translate-y-height",
          heighest * -1 + "px"
        );
      },
  
      checkScrollLayoutForRecenlyViewed() {
        const RecentlyViewedSection = document.getElementById(
          "recently-viewed-products-list-2"
        );
  
        if (
          RecentlyViewedSection &&
          RecentlyViewedSection.classList.contains("products-flex")
        ) {
          const RecentlyViewedObserver = new MutationObserver(
            (mutationList, observer) => {
              const mutationRecentlyViewed = mutationList[0];
  
              if (
                mutationRecentlyViewed.type == "attributes" &&
                mutationRecentlyViewed.target.classList.contains(
                  "recently-viewed-loaded"
                )
              ) {
                const enableHover = $(
                  mutationRecentlyViewed.target.closest(
                    "[data-recently-viewed-block]"
                  )
                )
                  .find("[data-enable-hover]")
                  .attr("data-enable-hover");
                if (
                  enableHover === "true" &&
                  RecentlyViewedSection.clientWidth <
                    RecentlyViewedSection.scrollWidth
                ) {
                  halo.productBlockScroller(
                    $(
                      mutationRecentlyViewed.target.closest(
                        "[data-recently-viewed-block]"
                      )
                    )
                  );
                }
  
                observer.disconnect();
              }
            }
          );
  
          RecentlyViewedObserver.observe(RecentlyViewedSection, {
            attributes: true,
          });
        }
      },
  
      clickIconScrollSection() {
        console.log('clickIconScrollSection   downnnnnnnnn')
        if (!document.querySelector(".arrow-icon-scroll")) return;
        let isScrollingDown = "next";
        const sections = document.querySelectorAll(
            ".wrapper-body .shopify-section"
          ),
          sectionsLength = sections.length,
          sectionFirstHeight = sections[0]?.getBoundingClientRect().height || 0,
          sectionEndHeight =
            sections[sectionsLength - 1]?.getBoundingClientRect().height || 0,
          footerHeight =
            document
              .querySelectorAll(".shopify-section-group-footer-group")[0]
              ?.getBoundingClientRect().height || 0;
  
        if (
          window.pageYOffset + sectionEndHeight >=
          document.documentElement.scrollHeight - footerHeight
        )
          loadRotateArrow("prev");
  
        $(window).scroll(function () {
          if (
            window.pageYOffset + sectionEndHeight >=
            document.documentElement.scrollHeight - footerHeight
          )
            loadRotateArrow("prev");
          else if (window.pageYOffset <= sectionFirstHeight / 2)
            loadRotateArrow("next");
        });
  
        $doc.on("click", ".arrow-icon-scroll", (event) => {
          let checkScroll = true;
          const headerHeight =
              window.innerWidth > 1024
                ? document
                    .querySelectorAll("sticky-header")[0]
                    ?.getBoundingClientRect().height
                : document
                    .querySelector("sticky-header-mobile")
                    ?.getBoundingClientRect().height || 0,
            footerTop =
              document
                .querySelectorAll(".shopify-section-group-footer-group")[0]
                ?.getBoundingClientRect().top || -1;
  
          sections.forEach((element, index) => {
            if (!checkScroll) return;
            const thisTop = element.getBoundingClientRect().top;
  
            if (thisTop >= 0) {
              checkScroll = false;
  
              if (isScrollingDown == "next") {
                if (element.nextElementSibling != null)
                  scrollToSection(
                    element.nextElementSibling.offsetTop - headerHeight
                  );
                sectionsLength == index + 2 || element.nextElementSibling == null
                  ? loadRotateArrow("prev")
                  : loadRotateArrow("next");
              } else {
                if (element.previousElementSibling != null)
                  scrollToSection(
                    element.previousElementSibling.offsetTop - headerHeight
                  );
                index == 1 || element.previousElementSibling == null
                  ? loadRotateArrow("next")
                  : loadRotateArrow("prev");
              }
            } else if (footerTop >= 0)
              scrollToSection(
                sections[sectionsLength - 1].offsetTop - headerHeight
              );
          });
        });
  
        function scrollToSection(scope, rotate) {
          window.scrollTo({ top: scope, behavior: "smooth" });
        }
  
        function loadRotateArrow(rotate) {
          isScrollingDown = rotate;
          rotate == "next"
            ? document
                .querySelector(".arrow-icon-scroll")
                .classList.remove("rotate")
            : document
                .querySelector(".arrow-icon-scroll")
                .classList.add("rotate");
        }
      },
  
      specialBanner() {
         console.log('specialBanner   downnnnnnnnn')
        const banners = document.querySelectorAll("[sticky-special-banner]"),
          wdWidth = window.innerWidth,
          wdHeight = window.innerHeight,
          headerHeight =
            wdWidth > 1024
              ? document
                  .querySelectorAll("sticky-header")[0]
                  ?.getBoundingClientRect().height
              : document
                  .querySelector("sticky-header-mobile")
                  ?.getBoundingClientRect().height || 0;
  
        if (banners) {
          banners.forEach((element) => {
            const banner = element.querySelector(".special-banner__img_box"),
              bannerWrap = element.querySelector(".special-banner__img"),
              wrapperHeight = element
                .closest(".special-banner__wrapper")
                .getBoundingClientRect().height,
              bannerHeight = bannerWrap.getBoundingClientRect().height;
  
            let top = headerHeight || 0;
            if (wdWidth >= 1200) {
              if (wrapperHeight > bannerHeight) {
                if (wdHeight > bannerHeight) top = (wdHeight - bannerHeight) / 2;
                calculateSticky(banner, top);
              }
            } else if (wdWidth >= 768 && wdWidth < 1200) {
              if (wrapperHeight > bannerHeight) {
                calculateSticky(banner, top);
              }
            } else {
              element.classList.remove("is-sticky");
              element.style.top = ``;
            }
          });
        }
  
        function calculateSticky(banner, top) {
          banner.classList.add("is-sticky");
          banner.style.top = `${top}px`;
        }
      },
  
      specialBannerSlider() {
        const productGrid = $(".special-banner__products--grid"),
          wdWidth = window.innerWidth;
  
        if (productGrid) {
          productGrid.each(function (index, element) {
            const $this = $(element),
              $block = $this.closest(".special-banner__product");
  
            if (!$block.hasClass("ajax-loaded")) return;
  
            if (wdWidth < 1200) {
              if (!$this.hasClass("slick-initialized")) {
                $this.addClass("products-carousel");
                specialProductSlider($block);
              }
            } else {
              if ($this.hasClass("slick-initialized")) {
                $this.slick("unslick");
                $this.removeClass("products-carousel");
              }
            }
          });
        }
  
        function specialProductSlider(wrapper) {
          let productGrid = wrapper.find(".products-carousel"),
            itemToShow = productGrid.data("item-to-show"),
            itemDots = productGrid.data("item-dots"),
            itemDotsMb = productGrid.data("item-dots-mb"),
            itemArrows = productGrid.data("item-arrows"),
            itemArrowsMb = productGrid.data("item-arrows-mb");
  
          productGrid.slick({
            mobileFirst: true,
            adaptiveHeight: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: itemArrowsMb,
            dots: itemDotsMb,
            nextArrow: window.arrows.icon_next,
            prevArrow: window.arrows.icon_prev,
            rtl: window.rtl_slick,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  arrows: itemArrows,
                  dots: itemDots,
                  slidesToShow: itemToShow,
                  slidesToScroll: itemToShow,
                },
              },
            ],
          });
        }
      },
    };
  })(jQuery);
  
  $(document).ready(function () {
    
document.addEventListener("DOMContentLoaded", function () {
  requestIdleCallback(() => {
    const slickEl = document.querySelector(".under_ss");
    if (slickEl && slickEl.offsetWidth > 0) {
      $(".under_ss").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        autoplay: false,
        fade: true,
        speed: 900,
        prevArrow:
          "<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0673/6094/8477/files/right-arrow_2_1.png?v=1702454835'></button>",
        nextArrow:
          "<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0673/6094/8477/files/right-arrow_2_1.png?v=1702454835'></button>",
      });
    }
  });
});

  
    //**********code****** */
  
  
  
  });

document.addEventListener('DOMContentLoaded', function () {
    function updateSaleLabels() {
        document.querySelectorAll('.product').forEach(product => {
            // Ensure a default variant is selected on load
            const selectedVariant = product.querySelector('.color-swatch.selected') || product.querySelector('.color-swatch:first-child');
            
            if (selectedVariant) {
                const isOnSale = selectedVariant.getAttribute('data-sale') === 'yes';
                let saleLabel = product.querySelector('.saleLabel-cust');

                if (isOnSale) {
                    if (!saleLabel) {
                        let spanElement = document.createElement('span');
                        spanElement.className = "saleLabel-cust";
                        spanElement.textContent = "Sale";
                        product.querySelector('.product-item-link').prepend(spanElement);
                    }
                } else {
                    if (saleLabel) {
if (saleLabel && typeof saleLabel.remove === "function") saleLabel.remove();
                    }
                }
            }
        });
    }

    function handleColorSelection(event) {
        if (event.target.classList.contains('color-swatch')) {
            const product = event.target.closest('.product');
            const isOnSale = event.target.getAttribute('data-sale') === 'yes';
            let saleLabel = product.querySelector('.saleLabel-cust');

            // Remove existing sale labels before adding a new one
            product.querySelectorAll('.saleLabel-cust').forEach(label => label.remove());

            if (isOnSale) {
                let spanElement = document.createElement("span");
                spanElement.className = "saleLabel-cust";
                spanElement.textContent = "Sale";
                product.querySelector('.product-item-link').prepend(spanElement);
            }
        }
    }

    // Ensure products are loaded before applying sale labels
    const observer = new MutationObserver((mutations, obs) => {
        if (document.querySelectorAll('.product').length > 0) {
            updateSaleLabels();
            obs.disconnect();
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', handleColorSelection);
    
    // Run initial update after slight delay for lazy-loaded elements
    setTimeout(updateSaleLabels, 1000);
});



document.addEventListener("DOMContentLoaded", function() {
    let searchElement = document.querySelector('.search-container');
    if (searchElement) {
        let header = document.querySelector('.page-header.text-center.scroll-trigger.animate--slide-in');
        if (header) {
            let newText = header.innerHTML.replace(/^\d+\s+/, '');
            header.innerHTML = newText;
        }
    }
});


document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/cart') return;
  const orderRows = document.querySelectorAll('.order-history tbody tr');
  
  orderRows.forEach(row => {
    const link = row.querySelector('td a'); // Link van het bestelnummer
    if (link) {
      row.style.cursor = 'pointer';
      row.addEventListener('click', () => {
        window.location.href = link.href; // Hele rij klikbaar maken
      });
    }
  });
});



if (window.location.pathname === '/cart') {
    document.querySelectorAll('.cart-item').forEach(item => {
        item.style.display = 'block';
        item.style.visibility = 'visible';
    });
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/collections/')) {
    function updateSaleLabels() {
      document.querySelectorAll('.product').forEach(product => {
        // If no variant is explicitly selected, default the first variant to selected
        let selectedVariant = product.querySelector('.color-swatch.selected');
        if (!selectedVariant) {
          selectedVariant = product.querySelector('.color-swatch:first-child');
          if (selectedVariant) {
            selectedVariant.classList.add('selected');
          }
        }
        
        // Determine if the selected variant is on sale
        const isOnSale = selectedVariant && selectedVariant.getAttribute('data-sale') === 'yes';
        let saleLabel = product.querySelector('.saleLabel-cust');

        if (isOnSale) {
          // If on sale and no label exists, add it
          if (!saleLabel) {
            let spanElement = document.createElement('span');
            spanElement.className = "saleLabel-cust";
            spanElement.textContent = "Sale";
            product.querySelector('.product-item-link').prepend(spanElement);
          }
        } else {
          // Not on sale: remove any existing sale label
          if (saleLabel) {
if (saleLabel && typeof saleLabel.remove === "function") saleLabel.remove();
          }
        }
      });
    }

    function handleColorSelection(event) {
      if (event.target.classList.contains('color-swatch')) {
        const product = event.target.closest('.product');

        // Remove "selected" class from other swatches
        product.querySelectorAll('.color-swatch').forEach(swatch => {
          swatch.classList.remove('selected');
        });
        // Mark the clicked swatch as selected
        event.target.classList.add('selected');

        // Remove existing sale label
        product.querySelectorAll('.saleLabel-cust').forEach(label => label.remove());

        // If the clicked swatch is on sale, add the sale label
        if (event.target.getAttribute('data-sale') === 'yes') {
          let spanElement = document.createElement("span");
          spanElement.className = "saleLabel-cust";
          spanElement.textContent = "Sale";
          product.querySelector('.product-item-link').prepend(spanElement);
        }
      }
    }

    // Run updateSaleLabels on page load
    updateSaleLabels();

    // Listen for clicks on swatches to update the selection and sale label
    document.addEventListener('click', handleColorSelection);

    // Use a MutationObserver to re-run updateSaleLabels when DOM changes occur (e.g., after sorting/filtering)
    const observer = new MutationObserver(() => {
      updateSaleLabels();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});

document.addEventListener("DOMContentLoaded", function() {
    function hideVariantImageURL() {
        document.querySelectorAll(".product-option").forEach(element => {
            let keyElement = element.querySelector("dt.definitionList-key");
            let valueElement = element.querySelector("dd.definitionList-value");

            if (keyElement && keyElement.textContent.trim() === "variant_image_url:") {
                keyElement.style.display = "none";
                if (valueElement) {
                    valueElement.style.display = "none"; // Also hides the URL
                }
            }
        });
    }

    // Run on page load
    hideVariantImageURL();

    // Watch for dynamically loaded elements
    const observer = new MutationObserver(hideVariantImageURL);
    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function() {
  // Listen for changes on the sort control (ensure your HTML includes an element with id "sort-by")
  const sortSelect = document.querySelector("#sort-by");
  if (sortSelect) {
    sortSelect.addEventListener("change", function() {
      const sortOrder = this.value; // e.g. "price-asc" or "price-desc"
      const container = document.querySelector('.productListing');
      if (!container) return;
      
      // Get all product cards from the container
      const products = Array.from(container.querySelectorAll('.product'));
      
      // Sort the products by the price (assumes the price is in an element with class "price" in the format "€XX.XX")
      products.sort((a, b) => {
        const priceA = parseFloat(a.querySelector('.price')?.textContent.replace('€','')) || 0;
        const priceB = parseFloat(b.querySelector('.price')?.textContent.replace('€','')) || 0;
        return sortOrder === "price-asc" ? priceA - priceB : priceB - priceA;
      });
      
      // Remove existing products and re-append sorted ones
      container.innerHTML = "";
      products.forEach(product => container.appendChild(product));
    });
  }
});